webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./figure_bc_10.json": 143,
	"./figure_bc_11.json": 144,
	"./figure_bc_12.json": 145,
	"./figure_bc_13.json": 146,
	"./figure_bc_1_1.json": 147,
	"./figure_bc_1_2.json": 148,
	"./figure_bc_1_3.json": 149,
	"./figure_bc_1_4.json": 150,
	"./figure_bc_1_5.json": 151,
	"./figure_bc_1_6.json": 152,
	"./figure_bc_1_7.json": 153,
	"./figure_bc_2_1.json": 154,
	"./figure_bc_2_2.json": 155,
	"./figure_bc_2_3.json": 156,
	"./figure_bc_3_1.json": 157,
	"./figure_bc_3_2.json": 158,
	"./figure_bc_3_3.json": 159,
	"./figure_bc_3_4.json": 160,
	"./figure_bc_3_5.json": 161,
	"./figure_bc_4_1.json": 162,
	"./figure_bc_4_2.json": 163,
	"./figure_bc_4_3.json": 164,
	"./figure_bc_4_4.json": 165,
	"./figure_bc_5_1.json": 166,
	"./figure_bc_5_2.json": 167,
	"./figure_bc_5_3.json": 168,
	"./figure_bc_5_4.json": 169,
	"./figure_bc_5_5.json": 170,
	"./figure_bc_5_6.json": 171,
	"./figure_bc_5_7.json": 172,
	"./figure_bc_6_1.json": 173,
	"./figure_bc_6_2.json": 174,
	"./figure_bc_7.json": 175,
	"./figure_bc_8.json": 176,
	"./figure_bc_9.json": 37,
	"./figure_fha_10.json": 177,
	"./figure_fha_11.json": 178,
	"./figure_fha_12.json": 179,
	"./figure_fha_13.json": 180,
	"./figure_fha_1_1.json": 181,
	"./figure_fha_1_2.json": 182,
	"./figure_fha_1_3.json": 183,
	"./figure_fha_1_4.json": 184,
	"./figure_fha_1_5.json": 185,
	"./figure_fha_1_6.json": 186,
	"./figure_fha_1_7.json": 187,
	"./figure_fha_2_1.json": 188,
	"./figure_fha_2_2.json": 189,
	"./figure_fha_2_3.json": 190,
	"./figure_fha_3_1.json": 191,
	"./figure_fha_3_2.json": 192,
	"./figure_fha_3_3.json": 193,
	"./figure_fha_3_4.json": 194,
	"./figure_fha_3_5.json": 195,
	"./figure_fha_4_1.json": 196,
	"./figure_fha_4_2.json": 197,
	"./figure_fha_4_3.json": 198,
	"./figure_fha_4_4.json": 199,
	"./figure_fha_5_1.json": 200,
	"./figure_fha_5_2.json": 201,
	"./figure_fha_5_3.json": 202,
	"./figure_fha_5_4.json": 203,
	"./figure_fha_5_5.json": 204,
	"./figure_fha_5_6.json": 205,
	"./figure_fha_5_7.json": 206,
	"./figure_fha_6_1.json": 207,
	"./figure_fha_6_2.json": 208,
	"./figure_fha_7.json": 209,
	"./figure_fha_8.json": 210,
	"./figure_fha_9.json": 38,
	"./figure_iha_10.json": 211,
	"./figure_iha_11.json": 212,
	"./figure_iha_12.json": 213,
	"./figure_iha_13.json": 214,
	"./figure_iha_1_1.json": 215,
	"./figure_iha_1_2.json": 216,
	"./figure_iha_1_3.json": 217,
	"./figure_iha_1_4.json": 218,
	"./figure_iha_1_5.json": 219,
	"./figure_iha_1_6.json": 220,
	"./figure_iha_1_7.json": 221,
	"./figure_iha_2_1.json": 222,
	"./figure_iha_2_2.json": 223,
	"./figure_iha_2_3.json": 224,
	"./figure_iha_3_1.json": 225,
	"./figure_iha_3_2.json": 226,
	"./figure_iha_3_3.json": 227,
	"./figure_iha_3_4.json": 228,
	"./figure_iha_3_5.json": 229,
	"./figure_iha_4_1.json": 230,
	"./figure_iha_4_2.json": 231,
	"./figure_iha_4_3.json": 232,
	"./figure_iha_4_4.json": 233,
	"./figure_iha_5_1.json": 234,
	"./figure_iha_5_2.json": 235,
	"./figure_iha_5_3.json": 236,
	"./figure_iha_5_4.json": 237,
	"./figure_iha_5_5.json": 238,
	"./figure_iha_5_6.json": 239,
	"./figure_iha_5_7.json": 240,
	"./figure_iha_6_1.json": 241,
	"./figure_iha_6_2.json": 242,
	"./figure_iha_7.json": 243,
	"./figure_iha_8.json": 244,
	"./figure_iha_9.json": 39,
	"./figure_nha_10.json": 245,
	"./figure_nha_11.json": 246,
	"./figure_nha_12.json": 247,
	"./figure_nha_13.json": 248,
	"./figure_nha_1_1.json": 249,
	"./figure_nha_1_2.json": 250,
	"./figure_nha_1_3.json": 251,
	"./figure_nha_1_4.json": 252,
	"./figure_nha_1_5.json": 253,
	"./figure_nha_1_6.json": 254,
	"./figure_nha_1_7.json": 255,
	"./figure_nha_2_1.json": 256,
	"./figure_nha_2_2.json": 257,
	"./figure_nha_2_3.json": 258,
	"./figure_nha_3_1.json": 259,
	"./figure_nha_3_2.json": 260,
	"./figure_nha_3_3.json": 261,
	"./figure_nha_3_4.json": 262,
	"./figure_nha_3_5.json": 263,
	"./figure_nha_4_1.json": 264,
	"./figure_nha_4_2.json": 265,
	"./figure_nha_4_3.json": 266,
	"./figure_nha_4_4.json": 267,
	"./figure_nha_5_1.json": 268,
	"./figure_nha_5_2.json": 269,
	"./figure_nha_5_3.json": 270,
	"./figure_nha_5_4.json": 271,
	"./figure_nha_5_5.json": 272,
	"./figure_nha_5_6.json": 273,
	"./figure_nha_5_7.json": 274,
	"./figure_nha_6_1.json": 275,
	"./figure_nha_6_2.json": 276,
	"./figure_nha_7.json": 277,
	"./figure_nha_8.json": 278,
	"./figure_nha_9.json": 40,
	"./figure_vcha_10.json": 279,
	"./figure_vcha_11.json": 280,
	"./figure_vcha_12.json": 281,
	"./figure_vcha_13.json": 282,
	"./figure_vcha_1_1.json": 283,
	"./figure_vcha_1_2.json": 284,
	"./figure_vcha_1_3.json": 285,
	"./figure_vcha_1_4.json": 286,
	"./figure_vcha_1_5.json": 287,
	"./figure_vcha_1_6.json": 288,
	"./figure_vcha_1_7.json": 289,
	"./figure_vcha_2_1.json": 290,
	"./figure_vcha_2_2.json": 291,
	"./figure_vcha_2_3.json": 292,
	"./figure_vcha_3_1.json": 293,
	"./figure_vcha_3_2.json": 294,
	"./figure_vcha_3_3.json": 295,
	"./figure_vcha_3_4.json": 296,
	"./figure_vcha_3_5.json": 297,
	"./figure_vcha_4_1.json": 298,
	"./figure_vcha_4_2.json": 299,
	"./figure_vcha_4_3.json": 300,
	"./figure_vcha_4_4.json": 301,
	"./figure_vcha_5_1.json": 302,
	"./figure_vcha_5_2.json": 303,
	"./figure_vcha_5_3.json": 304,
	"./figure_vcha_5_4.json": 305,
	"./figure_vcha_5_5.json": 306,
	"./figure_vcha_5_6.json": 307,
	"./figure_vcha_5_7.json": 308,
	"./figure_vcha_6_1.json": 309,
	"./figure_vcha_6_2.json": 310,
	"./figure_vcha_7.json": 311,
	"./figure_vcha_8.json": 312,
	"./figure_vcha_9.json": 41,
	"./figure_viha_10.json": 313,
	"./figure_viha_11.json": 314,
	"./figure_viha_12.json": 315,
	"./figure_viha_13.json": 316,
	"./figure_viha_1_1.json": 317,
	"./figure_viha_1_2.json": 318,
	"./figure_viha_1_3.json": 319,
	"./figure_viha_1_4.json": 320,
	"./figure_viha_1_5.json": 321,
	"./figure_viha_1_6.json": 322,
	"./figure_viha_1_7.json": 323,
	"./figure_viha_2_1.json": 324,
	"./figure_viha_2_2.json": 325,
	"./figure_viha_2_3.json": 326,
	"./figure_viha_3_1.json": 327,
	"./figure_viha_3_2.json": 328,
	"./figure_viha_3_3.json": 329,
	"./figure_viha_3_4.json": 330,
	"./figure_viha_3_5.json": 331,
	"./figure_viha_4_1.json": 332,
	"./figure_viha_4_2.json": 333,
	"./figure_viha_4_3.json": 334,
	"./figure_viha_4_4.json": 335,
	"./figure_viha_5_1.json": 336,
	"./figure_viha_5_2.json": 337,
	"./figure_viha_5_3.json": 338,
	"./figure_viha_5_4.json": 339,
	"./figure_viha_5_5.json": 340,
	"./figure_viha_5_6.json": 341,
	"./figure_viha_5_7.json": 342,
	"./figure_viha_6_1.json": 343,
	"./figure_viha_6_2.json": 344,
	"./figure_viha_7.json": 345,
	"./figure_viha_8.json": 346,
	"./figure_viha_9.json": 42
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

module.exports = {
	"period": "2017 Q2–2019 Q1",
	"dataLabels": {
		"bc": {
			"12": {
				"AIDS: DTP Reports": 10,
				"AIDS: BCCDC Reports": 10
			},
			"2.1": {
				"Interior Health": 4,
				"Northern Health": 8
			},
			"2.2": {
				"Female": 12,
				"Male": 2
			},
			"3.3": {
				"< 30": 0,
				"≥ 50": 15,
				"30–39": 10,
				"40–49": 0
			},
			"3.4": {
				"NIR/Unknown": -5,
				"HET": 10
			},
			"3.5": {
				"Interior Health": 10
			},
			"6.1": {
				"No Baseline Genotype": 10
			}
		},
		"fha": {
			"3.3": {
				"< 30": 0,
				"≥ 50": 0,
				"30–39": 0,
				"40–49": 10
			},
			"3.4": {
				"HET": 0,
				"NIR/Unknown": 10,
				"PWID": 0,
				"Other": 10
			},
			"3.5": {
				"Fraser South": -10
			},
			"6.1": {
				"<3 CD4 Tests": 10,
				"Non-Recommended ART": 0
			}
		},
		"iha": {
			"1.2": {
				"Male": 10,
				"Female": 0
			},
			"1.5": {
				"East Kootenay": 0
			},
			"1.7": {
				"East Kootenay": 0
			},
			"2.1": {
				"Okanagan": 4,
				"Thompson Cariboo Shuswap": 10,
				"All Interior Health": 25
			},
			"2.2": {
				"Female": 2,
				"Male": 15
			},
			"2.3": {
				"≥ 50": 15,
				"< 30": 0
			},
			"3.2": {
				"Male": 0,
				"Female": 10
			},
			"3.3": {
				"< 30": 10,
				"≥ 50": 0,
				"30–39": 8,
				"40–49": -10
			},
			"3.4": {
				"Other": 20,
				"HET": 0,
				"PWID": 10,
				"MSM": -10,
				"NIR/Unknown": 0
			},
			"3.5": {
				"Thompson Cariboo Shuswap": 10,
				"East Kootenay": 0,
				"Okanagan": 0,
				"Kootenay Boundary": -10
			},
			"6.1": {
				"No Baseline Genotype": 18,
				"<3 Viral Load Tests": -5,
				"<3 CD4 Tests": 18,
				"Baseline CD4 <200/µL": -10
			}
		},
		"nha": {
			"7": {
				"Experienced Starts": 0,
				"First Starts": 10
			},
			"12": {
				"AIDS: BCCDC Reports": 14,
				"AIDS: DTP Reports": -4
			},
			"2.1": {
				"Northwest": 15
			},
			"3.3": {
				"30–39": -10,
				"40–49": 10,
				"≥ 50": 0
			},
			"3.4": {
				"HET": 0,
				"PWID": -10,
				"MSM": 10,
				"Other": 20,
				"NIR/Unknown": 10
			},
			"3.5": {
				"Northeast": 10,
				"Northwest": 0,
				"Northern Interior": 10
			},
			"6.1": {
				"<3 CD4 Tests": 10,
				"Non Viral Suppression at 9 Mo.": 0,
				"Baseline CD4 <200/µL": -10,
				"<3 Viral Load Tests": 20,
				"No Baseline Genotype": 30
			}
		},
		"vcha": {
			"1.5": {
				"North Shore / Coast Garibaldi": 10,
				"Richmond": 0
			},
			"1.6": {
				"North Shore / Coast Garibaldi": 10,
				"Richmond": 0
			},
			"1.7": {
				"North Shore / Coast Garibaldi": 10,
				"Richmond": 0
			},
			"2.3": {
				"40–49": 0,
				"≥ 50": 10
			},
			"3.3": {
				"30–39": 0,
				"40–49": 10
			},
			"3.4": {
				"NIR/Unknown": -5,
				"PWID": 3,
				"HET": 5,
				"Other": 10
			},
			"3.5": {
				"Richmond": 0
			},
			"6.1": {
				"No Baseline Genotype": 7,
				"<3 CD4 Tests": 6,
				"<3 Viral Load Tests": -5
			}
		},
		"viha": {
			"12": {
				"AIDS: BCCDC Reports": -4,
				"AIDS: DTP Reports": 14
			},
			"2.1": {
				"All Vancouver Island Health": 0,
				"Central Vancouver Island": 10
			},
			"3.3": {
				"30–39": 0,
				"≥ 50": 10,
				"40–49": 15
			},
			"3.4": {
				"HET": -10,
				"PWID": 0,
				"Other": 10,
				"NIR/Unknown": -10
			},
			"3.5": {
				"Central Vancouver Island": 0,
				"North Vancouver Island": 10
			},
			"6.1": {
				"Non-Recommended ART": 17,
				"<3 Viral Load Tests": 7
			}
		}
	},
	"breaks": {
		"bc": [
			{
				"from": 1300,
				"to": 7000,
				"breakSize": 500,
				"position": -230
			}
		],
		"fha": [
			{
				"from": 250,
				"to": 1700,
				"breakSize": 100,
				"position": -201
			}
		],
		"iha": [
			{
				"from": 90,
				"to": 440,
				"breakSize": 80,
				"position": -230
			}
		],
		"nha": [
			{
				"from": 50,
				"to": 200,
				"breakSize": 20,
				"position": -240
			}
		],
		"vcha": [
			{
				"from": 800,
				"to": 3900,
				"breakSize": 400,
				"position": -250
			}
		],
		"viha": [
			{
				"from": 140,
				"to": 800,
				"breakSize": 100,
				"position": -230
			}
		]
	}
};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cfe-logo.ee2025a.png";

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

// @flow

const allHealthAuthorities = [
  'bc', 'fha', 'iha', 'nha', 'vcha', 'viha',
];
const healthAuthorities = {
  'bc': {
    name: 'British Columbia',
    shortName: 'BC',
    cascadeKey: 'BC Overall',
    indicatorsKey: 'BC',
    hsda: [
      {
        key: 'fha',
        name: 'Fraser Health',
      },
      {
        key: 'iha',
        name: 'Interior Health',
      },
      {
        key: 'nha',
        name: 'Northern Health',
      },
      {
        key: 'vcha',
        name: 'Vancouver Coastal Health',
      },
      {
        key: 'viha',
        name: 'Vancouver Island Health',
        cascadeKey: 'Vancouver Island Health',
      },
    ],
  },
  'fha': {
    name: 'Fraser Health',
    indicatorsKey: 'FRASER',
    hsda: ['Fraser East', 'Fraser North', 'Fraser South'],
  },
  'iha': {
    name: 'Interior Health',
    indicatorsKey: 'INTERIOR',
    hsda: ['East Kootenay', 'Kootenay Boundary', 'Okanagan', 'Thompson Cariboo Shuswap'],
  },
  'viha': {
    name: 'Vancouver Island Health',
    shortName: 'Island Health',
    indicatorsKey: 'VANCOUVER ISLAND',
    hsda: ['Central Vancouver Island', 'North Vancouver Island', 'South Vancouver Island'],
    cascadeKey: 'Vancouver Island Health',
  },
  'nha': {
    name: 'Northern Health',
    indicatorsKey: 'NORTHERN',
    hsda: ['Northeast', 'Northern Interior', 'Northwest'],
  },
  'vcha': {
    name: 'Vancouver Coastal Health',
    indicatorsKey: 'VANCOUVER COASTAL',
    hsda: ['North Shore / Coast Garibaldi', 'Richmond', 'Vancouver'],
  },
};
const inputFiles = {
  bccdc: 'NewSTOPIndicators.xlsx',
  cascade: 'cascade.txt',
  indicators: 'indicators.csv',
  indicators_y: 'indicators_y.csv',
};
const figures = {
  '1.1': {
    title: 'HIV Test Episodes for %(ha)s',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 10,
      fha: 1,
      iha: 1,
      nha: 0.2,
      vcha: 5,
      viha: 1,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 300,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 80,
  },
  '1.2': {
    title: 'HIV Test Episodes by Gender for %(ha)s <sup style="font-size: 10px;">1, 2</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 10,
      fha: 1,
      iha: 1,
      nha: 0.3,
      vcha: 2,
      viha: 0.5,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 650,
    height: 290,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 100,
  },
  '1.3': {
    title: 'HIV Test Episodes by Age Category for %(ha)s <sup style="font-size: 10px;">1, 2</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 3,
      fha: 0.4,
      iha: 0.3,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 650,
    height: 400,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 110,
  },
  '1.4': {
    title: 'Point-of-Care HIV Tests for %(ha)s',
    yTitle: {
      bc: '# Point-of-Care HIV Tests<br>(thousands)',
      fha: '# Point-of-Care HIV Tests',
      iha: '# Point-of-Care HIV Tests',
      nha: '# Point-of-Care HIV Tests',
      vcha: '# Point-of-Care HIV Tests<br>(thousands)',
      viha: '# Point-of-Care HIV Tests',
    },
    yTickInterval: {
      bc: 0.2,
      fha: 100,
      iha: 40,
      nha: 20,
      vcha: 0.2,
      viha: 100,
    },
    yLabelsFormat: {
      bc: '{value:.1f}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value:.1f}',
      viha: '{value}',
    },
    width: 650,
    height: 350,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 80,
  },
  '1.5': {
    title: 'HIV Test Episodes for %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 3,
      fha: 0.5,
      iha: 0.3,
      nha: 0.2,
      vcha: 3,
      viha: 0.3,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 900,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '1.6': {
    title: 'HIV Test Episodes for Non-prenatal Females in %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 2,
      fha: 0.4,
      iha: 0.2,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 440,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '1.7': {
    title: 'HIV Test Episodes for Males in %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 2,
      fha: 0.4,
      iha: 0.3,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 440,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '2.1': {
    title: 'Rate of HIV Testing for %(ha)s and %(group)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 1000,
      fha: 200,
      iha: 500,
      nha: 400,
      vcha: 1000,
      viha: 300,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 430,
    marginLeft: 150,
    marginRight: 170,
    marginBottom: 120,
  },
  '2.2': {
    title: 'Rate of HIV Testing by Gender for %(ha)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 300,
      fha: 200,
      iha: 200,
      nha: 200,
      vcha: 1000,
      viha: 200,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 420,
    marginLeft: 100,
    marginRight: 170,
    marginBottom: 80,
  },
  '2.3': {
    title: 'Rate of HIV Testing by Age Category for %(ha)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 500,
      fha: 300,
      iha: 400,
      nha: 300,
      vcha: 1000,
      viha: 300,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 640,
    height: 870,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 100,
  },
  '3.1': {
    title: 'New HIV Diagnoses for %(ha)s <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 2,
      iha: 2,
      nha: 1.5,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 250,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 90,
  },
  '3.2': {
    title: 'New HIV Diagnoses for %(ha)s by Gender <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 5,
      iha: 2,
      nha: 2,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 350,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 90,
  },
  '3.3': {
    title: 'New HIV Diagnoses for %(ha)s by Age Category <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 2,
      iha: 2,
      nha: 2,
      vcha: 4,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 380,
    marginLeft: 100,
    marginRight: 90,
    marginBottom: 110,
  },
  '3.4': {
    title: 'New HIV Diagnoses for %(ha)s by Exposure Category <sup style="font-size: 10px;">3, 4</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 5,
      fha: 2,
      iha: 2,
      nha: 1,
      vcha: 5,
      viha: 3,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 440,
    marginLeft: 100,
    marginRight: 90,
    marginBottom: 120,
  },
  '3.5': {
    title: 'New HIV Diagnoses for %(ha)s by %(group)s <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 3,
      iha: 1,
      nha: 2,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 870,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 170,
  },
  '4.1': {
    title: 'Stage of HIV Infection at Diagnosis for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 300,
    height: 390,
  },
  '4.2': {
    title: 'Stage of HIV Infection at Diagnosis by Gender for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 370,
    height: 380,
    marginTop: 60,
    marginRight: 1,
  },
  '4.3': {
    title: 'Stage of HIV Infection at Diagnosis by Age for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 710,
    height: 355,
    marginTop: 60,
  },
  '4.4': {
    title: 'Stage of HIV Infection at Diagnosis by Exposure Category for %(ha)s <sup style="font-size: 10px;">5, 6</sup>',
    yTitle: '',
    width: 532,
    height: 355,
    marginTop: 60,
  },
  '5.1': {
    title: 'Estimated Cascade of Care for %(ha)s, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">7</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -85,
      fha: -55,
      iha: -85,
      nha: -85,
      vcha: -85,
      viha: -85,
    },
    width: 330,
    height: 390,
    marginTop: 100,
    marginLeft: {
      bc: 110,
      fha: 130,
      iha: 110,
      nha: 110,
      vcha: 110,
      viha: 110,
    },
  },
  '5.2': {
    title: 'Estimated Cascade of Care for %(ha)s by Gender, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">7</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -100,
      fha: -100,
      iha: -100,
      nha: -100,
      vcha: -100,
      viha: -100,
    },
    width: 380,
    height: 390,
    marginTop: 100,
  },
  '5.3': {
    title: 'Estimated Cascade of Care for %(ha)s by Age Category, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">8</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -40,
      iha: -40,
      nha: -60,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 70,
      iha: 70,
      nha: 62,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -130,
      fha: -130,
      iha: -130,
      nha: -165,
      vcha: -130,
      viha: -130,
    },
    width: 720,
    height: 500,
    marginTop: 60,
    marginLeft: 110,
  },
  '5.4': {
    title: 'Estimated Cascade of Care for %(ha)s by MSM Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -60,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 62,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -125,
      fha: -75,
      iha: -125,
      nha: -160,
      vcha: -125,
      viha: -125,
    },
    width: 720,
    height: 500,
    marginTop: 80,
    marginLeft: {
      bc: 100,
      fha: 100,
      iha: 100,
      nha: 110,
      vcha: 100,
      viha: 100,
    },
  },
  '5.5': {
    title: 'Estimated Cascade of Care for %(ha)s by Age Category and MSM Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -60,
      fha: -40,
      iha: -100,
      nha: -100,
      vcha: -60,
      viha: -80,
    },
    yAxisHeight: {
      bc: 60,
      fha: 70,
      iha: 50,
      nha: 50,
      vcha: 60,
      viha: 60,
    },
    xAxisLabelsY: {
      bc: -100,
      fha: -100,
      iha: -100,
      nha: -100,
      vcha: -100,
      viha: -100,
    },
    width: 950,
    height: 530,
    marginTop: 80,
    marginLeft: 110,
  },
  '5.6': {
    title: 'Estimated Cascade of Care for %(ha)s by PWID Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -60,
      fha: -40,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 60,
      fha: 70,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -165,
      fha: -125,
      iha: -125,
      nha: -125,
      vcha: -125,
      viha: -125,
    },
    width: 720,
    height: 500,
    marginTop: 80,
    marginLeft: 110,
  },
  '5.7': {
    title: 'Estimated Cascade of Care for %(ha)s by %(group)s, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -60,
      nha: -60,
      vcha: -20,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 60,
      nha: 60,
      vcha: 83,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -145,
      fha: -80,
      iha: -185,
      nha: -185,
      vcha: -80,
      viha: -140,
    },
    width: 950,
    height: 530,
    marginTop: 60,
    marginLeft: {
      bc: 100,
      fha: 100,
      iha: 100,
      nha: 110,
      vcha: 100,
      viha: 100,
    },
  },
  '6.1': {
    title: 'PCS Components for %(ha)s, %(period)s <sup style="font-size: 10px;">10</sup>',
    yTitle: 'Percentage',
    yTickInterval: {
      bc: 2,
      fha: 5,
      iha: 5,
      nha: 5,
      vcha: 2,
      viha: 10,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 680,
    height: 400,
    marginLeft: 100,
    marginRight: 180,
    marginBottom: 80,
  },
  '6.2': {
    title: 'Historical Trends for PCS Score for %(ha)s, %(period)s <sup style="font-size: 10px;">10, 11</sup>',
    yTitle: 'Distribution of PCS Score',
    width: 510,
    height: 380,
    marginLeft: 100,
    marginBottom: 80,
  },
  '7': {
    title: 'BC-CfE Drug Treatment Program Enrollment New ART Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">12</sup>',
    yTitle: '# Participants',
    yTickInterval: {
      bc: 20,
      fha: 10,
      iha: 2,
      nha: 2,
      vcha: 2,
      viha: 10,
    },
    width: 600,
    height: 210,
    marginLeft: 100,
    marginRight: 300,
  },
  '8': {
    title: 'CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">13</sup>',
    yTitle: '% in CD4 Cell Count Category at ART Initiation',
    y2Title: 'Median CD4 Cell Count at ART Initiation (cells/µL)',
    width: 480,
    height: 350,
    marginLeft: 110,
    marginRight: 110,
    marginBottom: 80,
  },
  '9': {
    title: 'Active and Inactive DTP Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">15</sup>',
    yTitle: '# Participants',
    width: 660,
    height: 300,
    marginLeft: 100,
    marginRight: 200,
  },
  '10': {
    title: 'Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for %(ha)s, %(period)s <sup style="font-size: 10px;">16</sup>',
    yTitle: '% Achieving Prescription Refill Adherence',
    width: 600,
    height: 580,
    marginLeft: 80,
    marginRight: 200,
    marginBottom: 80,
  },
  '11': {
    title: 'Cumulative Resistance Testing Results by Resistance Category for %(ha)s, %(period)s <sup style="font-size: 10px;">17</sup>',
    yTitle: '% DTP Patients',
    width: 600,
    height: 550,
    marginLeft: 160,
    marginRight: 100,
    marginBottom: 80,
  },
  '12': {
    title: 'AIDS Case Rate and Reports for %(ha)s <sup style="font-size: 10px;">18</sup>',
    yTitle: 'Rate per 100,000 population',
    yTickInterval: {
      bc: 0.5,
      fha: 0.5,
      iha: 0.5,
      nha: 0.5,
      vcha: 1,
      viha: 0.5,
    },
    yLabelsFormat: {
      bc: '{value:.1f}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 600,
    height: 370,
    marginLeft: 180,
    marginRight: 160,
    marginBottom: 120,
  },
  '13': {
    title: 'HIV-Related Deaths by Year for all BC, 2004-2015 <sup style="font-size: 10px;">19</sup>',
    yTitle: '',
    width: 600,
    height: 500,
    marginLeft: 150,
    marginRight: 40,
    marginBottom: 120,
  },
};
const colors = {
  text: '#2c3e50',
  axisLine: '#231f20',
  plotBackground: '#e1e2e4',
  gridLineColor: '#ffffff',
  cascadePoints: ['', '#043f61', '#0c4250', '#0d4440', '#09472e', '#0a4a23'],
  stackedColumnSeries: ['#6bcff6', 'url(#polka-dot-1)', 'url(#polka-dot-2a)', 'url(#polka-dot-2b)', '#9d070d'],
  lineSeries: ['#0076a3', '#9d0140', '#ab9f01', '#2b7025', '#560054', '#9d070d'],
  lineSingle: '#231f20',
};

module.exports = {
  figures: figures,
  allHealthAuthorities: allHealthAuthorities,
  healthAuthorities: healthAuthorities,
  colors: colors,
  inputFiles: inputFiles,
};



/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./figure_bc_9.json": 37,
	"./figure_fha_9.json": 38,
	"./figure_iha_9.json": 39,
	"./figure_nha_9.json": 40,
	"./figure_vcha_9.json": 41,
	"./figure_viha_9.json": 42
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 9,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					7452,
					7497,
					7479,
					7503,
					7520,
					7541,
					7597,
					{
						"y": 7653,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1128,
					1138,
					1176,
					1188,
					1185,
					1233,
					1217,
					{
						"y": 1213,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 314,
			"30–39": 1029,
			"40–49": 1722,
			"≥ 50": 4588,
			"Male": 6380,
			"Female": 1273,
			"MSM": 3194,
			"PWID": 1985,
			"Total": 7653
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_9.png"
};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 9,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1840,
					1851,
					1857,
					1860,
					1869,
					1883,
					1906,
					{
						"y": 1915,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					244,
					247,
					255,
					256,
					265,
					272,
					264,
					{
						"y": 263,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 89,
			"30–39": 272,
			"40–49": 494,
			"≥ 50": 1060,
			"Male": 1473,
			"Female": 442,
			"MSM": 652,
			"PWID": 410,
			"Total": 1915
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_9.png"
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 9,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					486,
					493,
					487,
					490,
					498,
					506,
					505,
					{
						"y": 519,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					81,
					78,
					83,
					83,
					85,
					88,
					92,
					{
						"y": 86,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 22,
			"30–39": 57,
			"40–49": 99,
			"≥ 50": 341,
			"Male": 418,
			"Female": 101,
			"MSM": 193,
			"PWID": 146,
			"Total": 519
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_9.png"
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 9,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					222,
					223,
					228,
					229,
					224,
					220,
					221,
					{
						"y": 221,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					40,
					39,
					38,
					42,
					40,
					41,
					39,
					{
						"y": 40,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 9,
			"30–39": 42,
			"40–49": 56,
			"≥ 50": 114,
			"Male": 134,
			"Female": 87,
			"MSM": 28,
			"PWID": 103,
			"Total": 221
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_9.png"
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 9,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					3999,
					4011,
					3985,
					4003,
					4004,
					4006,
					4019,
					{
						"y": 4040,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					632,
					645,
					664,
					665,
					653,
					684,
					684,
					{
						"y": 695,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 146,
			"30–39": 563,
			"40–49": 873,
			"≥ 50": 2458,
			"Male": 3559,
			"Female": 481,
			"MSM": 1993,
			"PWID": 1070,
			"Total": 4040
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_9.png"
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 9,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 660,
			"height": 300,
			"marginLeft": 100,
			"marginRight": 200,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					903,
					914,
					918,
					917,
					922,
					922,
					944,
					{
						"y": 956,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					117,
					115,
					121,
					126,
					127,
					133,
					123,
					{
						"y": 113,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 48,
			"30–39": 93,
			"40–49": 200,
			"≥ 50": 615,
			"Male": 794,
			"Female": 162,
			"MSM": 327,
			"PWID": 256,
			"Total": 956
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_9.png"
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Report__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Report__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: 'hash',
  routes: [{
    path: '/:ha',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Report___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Report___default.a,
    redirect: '/bc'
  }]
  // routes: [
  //   {
  //     path: '*',
  //     component: Report,
  //     redirect: '/bc',
  //   },
  //   {
  //     path: '/bc',
  //     component: Report,
  //     props: {
  //       ha: 'bc',
  //     },
  //   },
  //   {
  //     path: '/fha',
  //     component: Report,
  //     props: {
  //       ha: 'fha',
  //     },
  //   },
  //   {
  //     path: '/iha',
  //     component: Report,
  //     props: {
  //       ha: 'iha',
  //     },
  //   },
  //   {
  //     path: '/nha',
  //     component: Report,
  //     props: {
  //       ha: 'nha',
  //     },
  //   },
  //   {
  //     path: '/vcha',
  //     component: Report,
  //     props: {
  //       ha: 'vcha',
  //     },
  //   },
  //   {
  //     path: '/viha',
  //     component: Report,
  //     props: {
  //       ha: 'viha',
  //     },
  //   },
  // ],
}));

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(128),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/*
 Highcharts JS v5.0.12 (2017-05-24)

 (c) 2009-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(h){"object"===typeof module&&module.exports?module.exports=h:h(Highcharts)})(function(h){(function(f){function h(){return Array.prototype.slice.call(arguments,1)}function u(b){b.apply(this);this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,r(this.pointArrayMap,["y"]))}var r=f.pick,g=f.wrap,q=f.each,y=f.extend,z=f.isArray,v=f.fireEvent,t=f.Axis,A=f.Series;y(t.prototype,{isInBreak:function(b,e){var c=b.repeat||Infinity,a=b.from,d=b.to-b.from;e=e>=a?(e-a)%c:c-(a-e)%c;return b.inclusive?
e<=d:e<d&&0!==e},isInAnyBreak:function(b,e){var c=this.options.breaks,a=c&&c.length,d,n,w;if(a){for(;a--;)this.isInBreak(c[a],b)&&(d=!0,n||(n=r(c[a].showPoints,this.isXAxis?!1:!0)));w=d&&e?d&&!n:d}return w}});g(t.prototype,"setTickPositions",function(b){b.apply(this,Array.prototype.slice.call(arguments,1));if(this.options.breaks){var e=this.tickPositions,c=this.tickPositions.info,a=[],d;for(d=0;d<e.length;d++)this.isInAnyBreak(e[d])||a.push(e[d]);this.tickPositions=a;this.tickPositions.info=c}});
g(t.prototype,"init",function(b,e,c){var a=this;c.breaks&&c.breaks.length&&(c.ordinal=!1);b.call(this,e,c);b=this.options.breaks;a.isBroken=z(b)&&!!b.length;a.isBroken&&(a.val2lin=function(d){var n=d,b,c;for(c=0;c<a.breakArray.length;c++)if(b=a.breakArray[c],b.to<=d)n-=b.len;else if(b.from>=d)break;else if(a.isInBreak(b,d)){n-=d-b.from;break}return n},a.lin2val=function(d){var b,c;for(c=0;c<a.breakArray.length&&!(b=a.breakArray[c],b.from>=d);c++)b.to<d?d+=b.len:a.isInBreak(b,d)&&(d+=b.len);return d},
a.setExtremes=function(a,b,c,e,f){for(;this.isInAnyBreak(a);)a-=this.closestPointRange;for(;this.isInAnyBreak(b);)b-=this.closestPointRange;t.prototype.setExtremes.call(this,a,b,c,e,f)},a.setAxisTranslation=function(b){t.prototype.setAxisTranslation.call(this,b);b=a.options.breaks;var c=[],d=[],e=0,f,l,m=a.userMin||a.min,p=a.userMax||a.max,h=r(a.pointRangePadding,0),k,g;q(b,function(b){l=b.repeat||Infinity;a.isInBreak(b,m)&&(m+=b.to%l-m%l);a.isInBreak(b,p)&&(p-=p%l-b.from%l)});q(b,function(a){k=a.from;
for(l=a.repeat||Infinity;k-l>m;)k-=l;for(;k<m;)k+=l;for(g=k;g<p;g+=l)c.push({value:g,move:"in"}),c.push({value:g+(a.to-a.from),move:"out",size:a.breakSize})});c.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-b.value});f=0;k=m;q(c,function(a){f+="in"===a.move?1:-1;1===f&&"in"===a.move&&(k=a.value);0===f&&(d.push({from:k,to:a.value,len:a.value-k-(a.size||0)}),e+=a.value-k-(a.size||0))});a.breakArray=d;a.unitLength=p-m-e+h;v(a,"afterBreaks");a.options.staticScale?
a.transA=a.options.staticScale:a.unitLength&&(a.transA*=(p-a.min+h)/a.unitLength);h&&(a.minPixelPadding=a.transA*a.minPointOffset);a.min=m;a.max=p})});g(A.prototype,"generatePoints",function(b){b.apply(this,h(arguments));var e=this.xAxis,c=this.yAxis,a=this.points,d,f=a.length,g=this.options.connectNulls,x;if(e&&c&&(e.options.breaks||c.options.breaks))for(;f--;)d=a[f],x=null===d.y&&!1===g,x||!e.isInAnyBreak(d.x,!0)&&!c.isInAnyBreak(d.y,!0)||(a.splice(f,1),this.data[f]&&this.data[f].destroyElements())});
f.Series.prototype.drawBreaks=function(b,e){var c=this,a=c.points,d,f,g,h;b&&q(e,function(e){d=b.breakArray||[];f=b.isXAxis?b.min:r(c.options.threshold,b.min);q(a,function(a){h=r(a["stack"+e.toUpperCase()],a[e]);q(d,function(c){g=!1;if(f<c.from&&h>c.to||f>c.from&&h<c.from)g="pointBreak";else if(f<c.from&&h>c.from&&h<c.to||f>c.from&&h>c.to&&h<c.from)g="pointInBreak";g&&v(b,g,{point:a,brk:c})})})})};f.Series.prototype.gappedPath=function(){var b=this.options.gapSize,e=this.points.slice(),c=e.length-
1;if(b&&0<c)for(;c--;)e[c+1].x-e[c].x>this.closestPointRange*b&&e.splice(c+1,0,{isNull:!0});return this.getGraphPath(e)};g(f.seriesTypes.column.prototype,"drawPoints",u);g(f.Series.prototype,"drawPoints",u)})(h)});


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Highcharts pattern fill plugin
 *
 * Version         3.0.0
 * Author:         Torstein Honsi
 *                 Stephane Vanraes
 * Last revision:  2016-10-05
 * License:        MIT License
 *
 * Remark:         The latest version is not compatible with earlier versions.
 *
 * Usage:          Add a 'defs' object to the options
 *                 Create a 'patterns' array under 'defs'
 *                 Each item in this array represents a pattern
 *                 To use a pattern, set the color to `url(#id-of-pattern)'
 *
 * Options for the patterns:
 * - id:                  The id for the pattern, defaults to highcharts-pattern-# with # an increasing number for each pattern without id
 * - width:               The width of the pattern, defaults to 10
 * - height:              The height of the pattern, defaults to 10
 * - backgroundColor:     A color to be used to fill the rect background
 * - opacity:             A general opacity for the pattern
 * - patternTransform:    The "transform" attribute, for example, "rotate(45)"
 * - path:                In SVG, the path for the pattern
 *                        (Note: this can be a string with only a path, or an object with d, stroke, strokeWidth and fill)
 * - image:               An image source for the pattern
 * - color:               A color to be used instead of a path
 *
 * Notes:          VML does not support the path setting
 *                 If all other fills fail (no path, image or color) the pattern will return #A0A0A0 as a color
 *                 Several patterns have been predefined, called highcharts-default-pattern-# (numbered 0-9)
 */

/*global Highcharts, document */
(function (factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {

    'use strict';

    var idCounter = 0,
        wrap = Highcharts.wrap,
        each = Highcharts.each;

    /**
     * Exposed method to add a pattern to the renderer.
     */
    Highcharts.SVGRenderer.prototype.addPattern = function (id, options) {
        var pattern,
            path,
            w = options.width || 10,
            h = options.height || 10,
            ren = this;

        /**
         * Add a rectangle for solid color
         */
        function rect (fill) {
            ren.rect(0, 0, w, h)
                .attr({
                    fill: fill
                })
                .add(pattern);
        }

        if (!id) {
            id = 'highcharts-pattern-' + idCounter;
            idCounter += 1;
        }

        pattern = this.createElement('pattern').attr({
            id: id,
            patternUnits: 'userSpaceOnUse',
            patternTransform: options.patternTransform || '',
            width: options.width || 10,
            height: options.height || 10
        }).add(this.defs);

        // Get id
        pattern.id = pattern.element.id;

        // Use an SVG path for the pattern
        if (options.path) {
            path = options.path;

            // The background
            if (options.backgroundColor) {
              rect(options.backgroundColor);
            }

            // The pattern
            this.createElement('path').attr({
                'd': path.d || path,
                'stroke': path.stroke || options.color || '#343434',
                'stroke-width': path.strokeWidth || 0,
                'fill': path.fill
            }).add(pattern);
            pattern.color = options.color;

        // Image pattern
        } else if (options.image) {

            this.image(options.image, 0, 0, options.width, options.height).add(pattern);

        // A solid color
        } else if (options.color) {

            rect(options.color);

        }

        if (options.opacity !== undefined) {
            each(pattern.element.children, function (child) {
                child.setAttribute('opacity', options.opacity);
            });
        }

        return pattern;
    };

    if (Highcharts.VMLElement) {

        Highcharts.VMLRenderer.prototype.addPattern = function (id, options) {

            var patterns;
            if (!id) {
                id = 'highcharts-pattern-' + idCounter;
                idCounter += 1;
            }
            patterns = this.patterns || {};
            patterns[id] = options;
            this.patterns = patterns;
        };

        Highcharts.wrap(Highcharts.VMLRenderer.prototype.Element.prototype, 'fillSetter', function (proceed, color, prop, elem) {
            if (typeof color === 'string' && color.substring(0, 5) === 'url(#') {
                var id = color.substring(5, color.length - 1),
                    pattern = this.renderer.patterns[id],
                    markup;

                if (pattern.image) {
                    // Remove Previous fills
                    if (elem.getElementsByTagName('fill').length) {
                        elem.removeChild(elem.getElementsByTagName('fill')[0]);
                    }

                    markup = this.renderer.prepVML(['<', prop, ' type="tile" src="', pattern.image, '" />']);
                    elem.appendChild(document.createElement(markup));

                    // Work around display bug on updating attached nodes
                    if (elem.parentNode.nodeType === 1) {
                        elem.outerHTML = elem.outerHTML;
                    }

                } else if (pattern.color) {
                    proceed.call(this, pattern.color, prop, elem);
                } else {
                    proceed.call(this, '#A0A0A0', prop, elem);
                }
            } else {
                proceed.call(this, color, prop, elem);
            }
        });
    }

    /**
     * Add the predefined patterns
     */
    function addPredefinedPatterns(renderer) {
        var colors = Highcharts.getOptions().colors;

        each([
            'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9',
            'M 3 0 L 3 10 M 8 0 L 8 10',
            'M 0 3 L 10 3 M 0 8 L 10 8',
            'M 0 3 L 5 3 L 5 0 M 5 10 L 5 7 L 10 7',
            'M 3 3 L 8 3 L 8 8 L 3 8 Z',
            'M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0',
            'M 10 3 L 5 3 L 5 0 M 5 10 L 5 7 L 0 7',
            'M 2 5 L 5 2 L 8 5 L 5 8 Z',
            'M 0 0 L 5 10 L 10 0'
        ], function (pattern, i) {
            renderer.addPattern('highcharts-default-pattern-' + i, {
                path: pattern,
                color: colors[i]
            });
        });
    }

    // Add patterns to the defs element
    wrap(Highcharts.Chart.prototype, 'getContainer', function (proceed) {
        proceed.apply(this);

        var chart = this,
            renderer = chart.renderer,
            options = chart.options,
            patterns = options.defs && options.defs.patterns;

        // First add default patterns
        addPredefinedPatterns(renderer);

        // Add user defined patterns
        if (patterns) {
            each(patterns, function (pattern) {
                renderer.addPattern(pattern.id, pattern);
            });
        }

    });

}));


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var report = __webpack_require__(11);
    $('head title').text('HIV QMR: ' + this.$route.params.ha.toUpperCase() + ' ' + report.period.slice(-7).replace(' ', '-'));
  },

  name: 'app',
  watch: {
    '$route': function $route(to, from) {
      location.reload();
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cli_constants__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cli_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cli_constants__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      healthAuthorities: __WEBPACK_IMPORTED_MODULE_1__cli_constants__["healthAuthorities"],
      ha: this.$route.params.ha,
      indicator6: [{
        name: '< 3 CD4 Tests',
        figure: [6.1],
        serie: '<3 CD4 Tests'
      }, {
        name: '< 3 Viral Load Tests',
        figure: [6.1],
        serie: '<3 Viral Load Tests'
      }, {
        name: 'No Baseline Genotype',
        figure: [6.1]
      }, {
        name: 'Baseline CD4 < 200 cells/µL',
        figure: [6.1],
        serie: 'Baseline CD4 <200/µL'
      }, {
        name: 'Non-Recommended ART',
        figure: [6.1]
      }, {
        name: 'Non Viral Suppression at 9 Mo.',
        figure: [6.1]
      }, {
        name: 'PCS Score: 0',
        figure: [6.2],
        serie: '0'
      }, {
        name: 'PCS Score: 1',
        figure: [6.2],
        serie: '1'
      }, {
        name: 'PCS Score: 2',
        figure: [6.2],
        serie: '2'
      }, {
        name: 'PCS Score: 3',
        figure: [6.2],
        serie: '3'
      }, {
        name: 'PCS Score: 4 or more',
        figure: [6.2],
        serie: '≥ 4'
      }, {
        name: 'Total (n=)',
        figure: [6.2],
        serie: 'n='
      }],
      indicator7: [{
        name: 'First Starts'
      }, {
        name: 'Experienced Starts'
      }],
      indicator8: [{
        name: 'CD4 ≥ 500',
        serie: '≥ 500 cells/µL'
      }, {
        name: 'CD4 350-499',
        serie: '350–499'
      }, {
        name: 'CD4 200-349',
        serie: '200–349'
      }, {
        name: 'CD4 50-199',
        serie: '50–199'
      }, {
        name: 'CD4 < 50',
        serie: '< 50 cells/µL'
      }, {
        name: 'Total (n=)',
        serie: 'n='
      }, {
        name: 'CD4 Median',
        serie: 'Median'
      }],
      indicator9: [{
        name: 'Active DTP Participants',
        serie: 'Active'
      }, {
        name: 'Inactive DTP Participants',
        serie: 'Inactive'
      }],
      indicator10: [{
        name: '≥ 95%'
      }, {
        serie: '80% to<br>< 95%',
        name: '80% to < 95%'
      }, {
        serie: '40% to<br>< 80%',
        name: '40% to < 80%'
      }, {
        name: '< 40%'
      }, {
        name: 'Total (n=)',
        serie: 'n='
      }],
      indicator11: [{
        name: 'Suppressed'
      }, {
        name: 'Wild Type'
      }, {
        name: 'Never Genotyped'
      }, {
        name: '1-Class'
      }, {
        name: '2-Class'
      }, {
        name: '3-Class'
      }, {
        name: '4-Class'
      }, {
        name: 'Total (n=)',
        serie: 'n='
      }]
    };
  },

  methods: {
    years: function years(figure) {
      var json = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + figure.toString().replace('.', '_') + '.json').instr;
      if (figure >= 4.1 && figure <= 4.4) {
        return json.dataTable.header;
      } else {
        return json.xAxis[json.xAxis[1] ? 1 : 0].categories;
      }
    },
    quarters: function quarters(figure) {
      return __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + figure.toString().replace('.', '_') + '.json').instr.xAxis[0].categories;
    },
    rows: function rows(figures, serieName, color) {
      var rows = [];
      if ([4.1, 4.2, 4.3, 4.4].includes(figures[0])) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(figures), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var figure = _step.value;

            var json = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + figure.toString().replace('.', '_') + '.json').instr;
            rows = json.dataTable.rows.filter(function (e) {
              return typeof serieName === 'string' ? e.name === serieName : e.name === e.name;
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if ([5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7].includes(figures[0])) {
        var _json = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + figures[0].toString().replace('.', '_') + '.json').instr;
        rows = _json.dataTable[serieName];
      } else {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(figures), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _figure = _step2.value;

            var _json2 = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + _figure.toString().replace('.', '_') + '.json').instr;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_json2.series.filter(function (e) {
                return e.name === (typeof serieName === 'string' ? serieName : e.name);
              })), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var serie = _step4.value;

                var data = [];
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(serie.data), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var val = _step5.value;

                    if (typeof val === 'number') {
                      data.push(val.toFixed(figures[0] === 13 ? 2 : 1));
                    } else {
                      data.push(val.y.toFixed(1));
                    }
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }

                rows.push({
                  name: serie.name,
                  data: data,
                  color: serie.color,
                  table: serie.table || {}
                });
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        rows.sort(function (a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });

        if (figures.includes(3.4)) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(rows), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var row = _step3.value;

              row.data = row.data.slice(2);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }

        if (typeof color === 'string') {
          rows = rows.filter(function (e) {
            return e.color === color;
          });
        }
      }
      return rows;
    }
  },
  mounted: function mounted() {
    /**
     * @author Rafael Trevisan <rtrevisan@cfenet.ubc.ca>
     * @description Indicator 4.4 has a different time frame than other 4.*
     */
    // commented out on 15-Aug-2018 as indicator has now the same time frame.
    // let y = 12;
    // for (let i = 7; i <= 31; i++) {
    //   $(`#app > div > div.appendices > table.indicator-4 > tbody > tr:nth-child(12) > td:nth-child(${i})`).text(`'${y}`);
    //   y = y + 1;
    //   if (y === 17) {
    //     y = 12;
    //   }
    // }

    // if (this.$route.params.ha !== 'bc') {
    //   const highlight = {
    //     'fha': [17, 20],
    //     'iha': [17, 20, 23],
    //     'nha': [17, 20],
    //     'vcha': [17, 20],
    //     'viha': [17, 20]
    //   };

    //   for (const trIndex of highlight[this.$route.params.ha]) {
    //     $(`#app > div > div.appendices > table.indicator-1 > tbody > tr:nth-child(${trIndex})`).css({
    //       'background-color': 'rgba(255, 255, 0, 0.5)'
    //     });
    //   }

    // }

    /**
     * @author Rafael Trevisan <rtrevisan@cfenet.ubc.ca>
     * @description Using JQuery to apply suppression on numbers between 1 and 4 *after* tables been rendered.
     *  29-AUG-2017: Rolando has decided to not suppress any data anymore until further notice
     */
    // $('table.indicator-3 td,\
    //    table.indicator-4 > tbody > tr:nth-child(n+4):nth-child(-n+9) > td,\
    //    table.indicator-4 > tbody > tr:nth-child(n+13):nth-child(-n+18) > td,\
    //    table.indicator-5 td,\
    //    table.indicator-6 td,\
    //    table.indicator-12 > tbody > tr:nth-child(2) > td,\
    //    table.indicator-12 > tbody > tr:nth-child(4) > td,\
    //    table.indicator-12 > tbody > tr:nth-child(6) > td').each(function( index, element ) {
    //   const num = $(element).text().trim();
    //   if (num !== '' && !isNaN(num)){
    //     if (num >= 0 && num < 5) {
    //       $(element).text('*');
    //       $(element).attr('title', 'Suppressed for privacy reason');
    //       $(element).css('font-size', '20px');
    //       $(element).css('line-height', '1');
    //     }
    //   }
    // });

    /**
     * for each column in table indicator-6
     * get how many "<5" each column has from row 9 to 13 and put into len
     * if len === 1 then mask the whole column
     */
    function mask(indicator, rowStart, rowEnd, colStart, colEnd, maskTo) {
      for (var col = colStart; col < colEnd; col++) {
        var len = $('table.' + indicator + ' > tbody > tr:nth-child(n+' + rowStart + '):nth-child(-n+' + rowEnd + ') > td:nth-child(' + col + ')').filter(function () {
          return $(this).text() === '*';
        }).length;
        if (len === 1) {
          $('table.' + indicator + ' > tbody > tr:nth-child(n+' + rowStart + '):nth-child(-n+' + rowEnd + ') > td:nth-child(' + col + ')').html(maskTo || '<span style="font-size: 20px; line-height: 1;" title="Hidden for privacy reason">*</span>');
        }
      }
    }

    // indicator-4 part a
    // mask('indicator-4', 4, 9, 2, 32);
    // indicator-4 part b
    // mask('indicator-4', 13, 18, 2, 32);
    // indicator-6
    // mask('indicator-6', 9, 13, 2, 10);
    // indicator-8
    // mask('indicator-6', 19, 23, 2, 10);
    // indicator-10
    // mask('indicator-6', 30, 33, 2, 10);
    // indicator-11
    // mask('indicator-6', 36, 42, 2, 10);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

var settings = __webpack_require__(11);
var override = __webpack_require__(142);
var dataLabels = settings.dataLabels;
var drawTable = function drawTable() {
  // internal variables
  var chart = this;
  var series = chart.series;
  var renderer = chart.renderer;

  // user options
  var yAxis = chart.yAxis[1] || chart.yAxis[0];
  var tableTop = yAxis.toPixels(yAxis.getExtremes().min) + (chart.xAxis[1] ? 50 : 40);
  var tableLeft = 0;
  var rowHeight = 10;
  var cellPadding = 0.5;

  // settings variables
  // const suppressible = [1.4, 3.1, 3.2, 3.3, 3.4, 3.5, 6.1, 6.2, 7, 8, 9, 10, 11, 12];
  var suppressFigure = series.filter(function (e) {
    return e.visible === true;
  }).length <= 0;

  if (Array.isArray(chart.userOptions.breaks)) {
    console.info(chart.userOptions.breaks);
    var _chart$userOptions$br = chart.userOptions.breaks[0],
        x = _chart$userOptions$br.x,
        y = _chart$userOptions$br.y,
        height = _chart$userOptions$br.height,
        width = _chart$userOptions$br.width;

    renderer.rect(chart.xAxis[0].toPixels(chart.xAxis[0].getExtremes().min), chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().min), chart.plotBox.width, chart.yAxis[1].toPixels(chart.yAxis[1].getExtremes().max) - chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().min)).attr({
      "fill": "white"
    }).add();
  }

  // render group labels (top title for multichart plot)
  if (chart.userOptions.groups && !suppressFigure) {
    chart.userOptions.groups.forEach(function (group) {
      renderer.text(group.text, chart.xAxis[0].toPixels(group.x) + (group.offset || 0), group.y || chart.yAxis[0].toPixels(chart.yAxis[0].getExtremes().max) - 20).css({
        fontWeight: 'normal',
        fontSize: '11px' }).attr({
        align: group.align || 'center' }).add();
    });
  }

  // render suppression text
  if (suppressFigure) {
    var fakeSerieData = [];
    series[0].data.forEach(function (e, i) {
      fakeSerieData.push(null);
    });
    chart.addSeries({
      name: 'Fake Serie',
      data: fakeSerieData,
      table: {
        visible: false
      }
    });

    renderer.text('This figure can not be displayed in<br>\
        its entirety due to small numbers.<br>\
        This is done to ensure the privacy<br>\
        of participants and ensure robust<br>\
        data interpretation.', chart.plotBox.x + chart.plotBox.width / 2, chart.plotBox.y + chart.plotBox.height / 2 - 20)
    // .css({
    //   fontWeight: 'normal',
    //   fontSize: '12px',
    //   color: 'black',
    //   fontStyle: 'normal',
    // })
    .attr({
      align: 'center'
    }).add();
  }

  series.filter(function (e) {
    return e.userOptions.table.visible === true;
  }).forEach(function (serie, index) {
    renderer.text(serie.userOptions.table.title || serie.name, tableLeft, tableTop + (index + 2) * rowHeight - cellPadding).css({
      fontWeight: 'normal',
      fontSize: '10px',
      color: serie.color,
      fontStyle: serie.userOptions.table.fontStyle
    }).add();
  });

  function suppress(num, decimalPoint) {
    // 29-AUG-2017: Rolando has decided to not suppress any data
    if (false /*num > 0 && num < 5*/) {
        var maxNum = 5;
        return '< ' + maxNum.toFixed(decimalPoint);
      } else {
      return num.toFixed(decimalPoint);
    }
  }

  chart.xAxis[0].categories.forEach(function (category, category_index) {
    series.filter(function (e) {
      return e.userOptions.table.visible === true;
    }).forEach(function (serie, serie_index) {
      renderer.text(serie.userOptions.table.suppressible ? suppress(serie.data[category_index].y, serie.userOptions.table.decimalPoint) : serie.data[category_index].y.toFixed(serie.userOptions.table.decimalPoint), chart.xAxis[0].toPixels(category_index), tableTop + (serie_index + 2) * rowHeight - cellPadding).attr({
        align: 'center'
      }).css({
        fontWeight: 'normal',
        fontSize: '10px',
        color: serie.color,
        fontStyle: serie.userOptions.table.fontStyle
      }).add();
    });
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chart-' + this.figure,
  props: {
    figure: {
      type: String
    }
  },
  data: function data() {
    var _this = this;

    var json = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + this.figure.replace('.', '_') + '.json');
    var options = json.instr;

    // dataLabels.json holds the y position for each series that needs to have their dataLabels fixed to prevent overlapping
    // const dataLabels = require('./../../../static/dataLabels.json');
    options.chart.events = {
      load: drawTable
    };
    options.defs = json.globalOptions.defs;

    if (Number(this.figure) === 9) {
      options.yAxis[0].breaks = settings.breaks[this.$route.params.ha];
    }

    if (dataLabels[this.$route.params.ha]) {
      if (dataLabels[this.$route.params.ha][this.figure]) {
        var _loop = function _loop(serie) {
          options.series.filter(function (e) {
            if (typeof e.visible !== 'undefined') {
              return e.name === serie && e.visible === true;
            } else {
              return e.name === serie;
            }
          })[0].data[options.series[0].data.length - 1].dataLabels.y = dataLabels[_this.$route.params.ha][_this.figure][serie];
          // console.info(`Fixing ${this.$route.params.ha}...${this.figure}...${serie} to ${dataLabels[this.$route.params.ha][this.figure][serie]}`);
        };

        for (var serie in dataLabels[this.$route.params.ha][this.figure]) {
          _loop(serie);
        }
      }
    }

    if (override[this.figure]) {
      if (override[this.figure]['chart']) {
        if (typeof override[this.figure]['chart']['width'] !== 'undefined') {
          options.chart.width = override[this.figure]['chart']['width'];
        }
        if (typeof override[this.figure]['chart']['height'] === 'number') {
          options.chart.height = override[this.figure]['chart']['height'];
        }
        if (typeof override[this.figure]['chart']['marginLeft'] === 'number') {
          options.chart.marginLeft = override[this.figure]['chart']['marginLeft'];
        }
        if (typeof override[this.figure]['chart']['marginRight'] === 'number') {
          options.chart.marginRight = override[this.figure]['chart']['marginRight'];
        }
      }
    }
    //options.chart.width = null;
    //options.chart.height = 600;
    return {
      options: options
    };
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cli_constants__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cli_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cli_constants__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['figures'],
  data: function data() {
    var dataTable = null;
    var dataSource = {
      groups: [],
      header: [],
      rows: []
    };

    if (this.figures.includes(4.1) || this.figures.includes(4.3)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.figures), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var figure = _step.value;

          dataTable = __webpack_require__(2)("./figure_" + this.$route.params.ha + '_' + figure.toString().replace('.', '_') + '.json').instr.dataTable;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataTable.groups), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var group = _step2.value;

              dataSource.groups.push(group);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataTable.header), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var header = _step3.value;

              dataSource.header.push(header);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (dataSource.rows.length === 0) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataTable.rows), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var row = _step4.value;

                dataSource.rows.push(row);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          } else {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dataTable.rows.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _ref = _step5.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var index = _ref2[0];
                var _row = _ref2[1];
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_row.data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var data = _step6.value;

                    dataSource.rows[index].data.push(data);
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (this.figures.includes(9)) {
      dataSource = {};
      for (var ha in __WEBPACK_IMPORTED_MODULE_2__cli_constants__["healthAuthorities"]) {
        if (__WEBPACK_IMPORTED_MODULE_2__cli_constants__["healthAuthorities"][ha]) {
          dataTable = __webpack_require__(36)("./figure_" + ha + '_9.json').instr.dataTable;
          for (var _group in dataTable) {
            if (dataTable[_group]) {
              if (!dataSource[_group]) {
                dataSource[_group] = {};
              }
              dataSource[_group][ha] = dataTable[_group];
            }
          }
        }
      }
    }

    return {
      dataSource: dataSource,
      width: this.$route.params.ha === 'bc' ? 720 : 250
    };
  },

  methods: {
    visibleFor: function visibleFor(ha) {
      return ha === this.$route.params.ha || this.$route.params.ha === 'bc';
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['footnotes'],
  data: function data() {
    return {
      note: {
        '1': '<i>\
                <p class="zero-margin-before">\
                  Data Source: The BC Public Health Microbiology and Reference Laboratory (BCPHMRL) courtesy of the BC Centre for Disease Control (BCCDC). \
                  HIV screening tests conducted by the VIHA Laboratory are not included.\
                </p>\
                <p class="zero-margin-before">\
                  Limitation: Repeat tests in individuals who test using various identifiers may not be identified and \
                  these individuals may be counted more than once. \
                </p> \
              </i>',
        '2': '<i>\
                Testing does not include point of care tests.\
              </i>',
        '3': '<i>Data Source: BCCDC. When present, “By Provider Address” is graphed as dashed line in same colour.</i>',
        '4': '<i>MSM=men who have sex with men; PWID=people who inject drugs; HET=heterosexual. NIR=No identified risk/exposure.</i>',
        '5': '<i>Data Source: BCCDC</i>',
        '6': '<i>MSM=men who have sex with men; PWID=people who inject drugs; HET=heterosexual. NIR=No identified risk/exposure.</i>',
        '7': '<i>\
                <p class="zero-margin-before">\
                  Data is for the period 2018 Q2–2019 Q1.<br>\
                  Data Sources:<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                </p>\
                <p class="zero-margin-before">\
                  Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                  If the most recent HA of residence is not updated then the designated HA may be incorrect.\
                </p>\
                <p class="zero-margin-before">\
                  NB: Transgender have been assigned to their biological sex.\
                </p>\
              </i>',
        '8': '<i>\
                <p class="zero-margin-before">\
                  Data is for the period 2018 Q2–2019 Q1.<br>\
                  Data Sources:<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                </p>\
                <p class="zero-margin-before">\
                  Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                  If the most recent HA of residence is not updated then the designated HA may be incorrect. \
                </p>\
              </i>',
        '9': '<i>\
                <p class="zero-margin-before">\
                  Data is for the period 2018 Q2–2019 Q1.<br>\
                  Data Sources:<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                  <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                </p>\
                <p class="zero-margin-before">\
                  Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                  If the most recent HA of residence is not updated then the designated HA may be incorrect. \
                </p>\
              </i>',
        '10': '<i>\
                Data Source: British Columbia Centre for Excellence Drug Treatment Program (DTP) Database.<br> \
                Limitations: CD4 cell count capture is approximately 80%.\
              </i>',
        '11': '<i>\
                Each quarter’s data is calculated as the sum of the 4 quarters leading up to it. e.g. 2017 Q2 is calculated from 2016 Q2 – 2017 Q1.<br> \
                NB: A score of 0 is the best score and a score of 4 or more is the worst score.\
              </i>',
        '12': '<i>\
                Data Source: Drug Treatment Program Database Limitation: DTP participants are designated to an HA based on most current residence provided by the participant.\
              </i>',
        '13': '<i>\
                Data Source: Drug Treatment Program Database Limitations: CD4 cell count data is approximately 80% complete.\
              </i>',
        '14': '<i>\
                <p class="zero-margin-before">\
                  Data Source: Drug Treatment Program Database<br>\
                  Limitation: DTP participants are designated to an HA based on most current residence provided by the participant.\
                </p>\
                <p class="zero-margin-before">\
                  Definition:<br>‘On antiretroviral therapy’ defined as being on treatment in the current quarter\
                </p>\
              </i>',
        '15': '<i>\
                Active DTP participants: An individual who has had medication prescribed at least once in the preceding quarter.<br>\
                Inactive DTP participants: Persons no longer prescribed drugs through the HIV/AIDS Drug Treatment Program in the last quarter.\
              </i>',
        '16': '<i>\
                Data Source: Drug Treatment Program Database<br>\
                Limitation: Prescription refill adherence is used as a proxy for patient adherence.\
              </i>',
        '17': '<i>\
                <p class="zero-margin-before">\
                  Data Source: Drug Treatment Program Database<br>\
                  Limitation: DTP participants are designated to a HA based on most current residence provided by the participant. \
                </p>\
              </i>',
        '18': '<i>\
                <p class="zero-margin-before">\
                  Data Source: DTP AIDS cases are obtained from the Drug Treatment Program Database; BCCDC AIDS cases are obtained from the BCCDC;\
                  CD4<200 at ART initiation data came from the DTP database. Indicator 12 also reflects information from BC Vital Statistics. As this\
                  information is made available to BC-CfE, we use it to inform the development and refinement of this indicator\
                </p>\
                <p class="zero-margin-before">\
                  Limitation: AIDS case reporting was investigated using 3 definitions: First, using AIDS cases reported in AIDS case report forms from the\
                  DTP; Second, using AIDS cases reported via the BCCDC and third, using a CD4 cell count of <200 cells/µL at time of ART initiation using\
                  DTP data. AIDS case reporting is passive in BC, thus; AIDS case reporting is not well captured. The DTP sends out AIDS reporting forms to\
                  physicians annually. The BCCDC uses DTP AIDS case reports as well as physician AIDS case reports made directly to the BCCDC. Interpreting\
                  AIDS case reports should be done with these limitations in mind. AIDS data is updated annually as very few AIDS cases reports are\
                  reported in general and trends would be difficult to notice if reported quarterly.\
                </p>\
              </i>',
        '19': '<i>\
                <p class="zero-margin-before">\
                  Data Source: BC Vital Statistics\
                </p>\
                <p class="zero-margin-before">\
                  Limitation:<br>\
                  1. DTP participants are designated to an HA based on most current residence provided by the participant.<br>\
                  2. Mortality data is updated annually<br>\
                  3. The most recent available data was used.\
                </p>\
              </i>'
      }
    };
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foreword',
  data: function data() {
    return {
      msg: 'Home'
    };
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var report = __webpack_require__(11);
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var quarter = null;
    switch (Number(report.period.slice(-1))) {
      case 1:
        quarter = 'FIRST';
        break;
      case 2:
        quarter = 'SECOND';
        break;
      case 3:
        quarter = 'THIRD';
        break;
      case 4:
        quarter = 'FOURTH';
        break;
      default:
        quarter = 'Unknown';
    }
    return {
      year: report.period.substring(8, 12),
      quarter: quarter
    };
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // if (this.$route.params.ha !== 'bc') {
    //   $('#app > div > div.list-indicators.bottom-padded-2x > a:nth-child(15)').css({
    //     'background-color': 'rgba(255, 255, 0, 0.5)'
    //   });
    // }
  },

  methods: {
    goToByScroll: function goToByScroll(id) {
      __WEBPACK_IMPORTED_MODULE_0_jquery__('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery__("#" + id).offset().top }, 'fast');
    }
  },
  data: function data() {
    return {
      msg: 'Home'
    };
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Home__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Foreword__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Foreword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Foreword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListIndicators__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListIndicators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ListIndicators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TableContents__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TableContents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TableContents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Acknowledgements__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Acknowledgements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Acknowledgements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StopProgram__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StopProgram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_StopProgram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Table1__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Table1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Table1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Chart__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footnotes__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Footnotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Footnotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DataTable__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Appendices__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Appendices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Appendices__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var settings = __webpack_require__(11);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_1__components_Home___default.a,
    Foreword: __WEBPACK_IMPORTED_MODULE_2__components_Foreword___default.a,
    ListIndicators: __WEBPACK_IMPORTED_MODULE_3__components_ListIndicators___default.a,
    TableContents: __WEBPACK_IMPORTED_MODULE_4__components_TableContents___default.a,
    Acknowledgements: __WEBPACK_IMPORTED_MODULE_5__components_Acknowledgements___default.a,
    StopProgram: __WEBPACK_IMPORTED_MODULE_6__components_StopProgram___default.a,
    Table1: __WEBPACK_IMPORTED_MODULE_7__components_Table1___default.a,
    Chart: __WEBPACK_IMPORTED_MODULE_8__components_Chart___default.a,
    Footnotes: __WEBPACK_IMPORTED_MODULE_9__components_Footnotes___default.a,
    DataTable: __WEBPACK_IMPORTED_MODULE_10__components_DataTable___default.a,
    Appendices: __WEBPACK_IMPORTED_MODULE_11__components_Appendices___default.a
  },
  methods: {
    goTop: function goTop(event) {
      // document.location.href = '#toc';
      __WEBPACK_IMPORTED_MODULE_0_jquery__('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery__("#toc").offset().top }, 'fast');
    },
    print: function print(event) {
      ga('send', 'event', 'PDF Report', 'download', this.$route.params.ha);
      window.open('./static/report_' + this.$route.params.ha + '.pdf', '_blank');
    }
  },
  props: {
    ha: {
      default: 'bc',
      type: String
    }
  },
  computed: {
    haName: function haName() {
      switch (this.$route.params.ha) {
        case 'bc':
          return 'BC';
          break;
        case 'fha':
          return 'Fraser Health';
          break;
        case 'iha':
          return 'Interior Health';
          break;
        case 'nha':
          return 'Northern Health';
          break;
        case 'vcha':
          return 'Vancouver Coastal Health';
          break;
        case 'viha':
          return 'Vancouver Island Health';
          break;
        default:
          return 'Ukn';
      }
    },
    period: function period() {
      return '2014 Q2-2019 Q1';
    },
    groupBy: function groupBy() {
      return this.$route.params.ha === 'bc' ? 'Health Authority' : 'HSDA';
    },
    groupByPlural: function groupByPlural() {
      return this.$route.params.ha === 'bc' ? 'Health Authorities' : 'HSDAs';
    },
    lastYear: function lastYear() {
      return this.period.slice(8, -3); //2017
    },
    lastQuarter: function lastQuarter() {
      return this.period.slice(-1); //4
    }
  },
  data: function data() {
    var table3 = __webpack_require__(36)("./figure_" + this.$route.params.ha + '_9.json').report;
    return {
      table3: table3,
      breakStyle: {
        position: 'relative',
        top: settings.breaks[this.$route.params.ha][0].position + 'px',
        left: '80px'
      }
    };
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // if (this.$route.params.ha !== 'bc') {
    //   $('#app > div > div.table-contents.bottom-padded-2x > div:nth-child(3) > a:nth-child(52) > span.table-cell.fixed-column.bold > span').css({
    //     'background-color': 'rgba(255, 255, 0, 0.5)',
    //     'padding': '4px 0 4px 0'
    //   });
    // }
  },

  methods: {
    goToByScroll: function goToByScroll(id) {
      // console.log(`Scrolling to ${id}...`);
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery__("#" + id).offset()) {
        // console.log(`Element not found: ${id}`);
        // console.log($("#"+id));
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery__('html,body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery__("#" + id).offset().top }, 'fast');
    }
  },
  name: 'tableContents',
  data: function data() {
    return {
      msg: 'Home'
    };
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_highcharts__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_pattern_fill_v2__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_pattern_fill_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vendor_pattern_fill_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendor_broken_axis__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendor_broken_axis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__vendor_broken_axis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(43);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_4__vendor_pattern_fill_v2___default()(__WEBPACK_IMPORTED_MODULE_3_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_5__vendor_broken_axis___default()(__WEBPACK_IMPORTED_MODULE_3_highcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_highcharts__["a" /* default */], { Highcharts: __WEBPACK_IMPORTED_MODULE_3_highcharts___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a },
  mounted: function mounted() {
    window.onscroll = function () {
      scrollFunction();
    };

    var browserName = getBrowserInfo().split(' ')[0];

    if (browserName === 'Safari') {
      __WEBPACK_IMPORTED_MODULE_1_jquery__('div#using-safari').show();
    } else {
      __WEBPACK_IMPORTED_MODULE_1_jquery__('div#using-safari').hide();
    }

    function scrollFunction() {
      if (!__WEBPACK_IMPORTED_MODULE_1_jquery__('#toc')[0]) {
        return;
      }

      if (document.body.scrollTop > __WEBPACK_IMPORTED_MODULE_1_jquery__('#toc')[0].offsetTop + 10 || document.documentElement.scrollTop > __WEBPACK_IMPORTED_MODULE_1_jquery__('#toc')[0].offsetTop + 10) {
        document.getElementById("go-to-top").style.display = "block";
      } else {
        document.getElementById("go-to-top").style.display = "none";
      }
    }

    function getBrowserInfo() {
      var ua = navigator.userAgent,
          tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    }
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc-cdc-logo.6fc7213.jpg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc_hlth.1d668c6.png";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fha-logo.54cc7e6.jpg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fnha-logo.150c751.jpg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iha-logo.a174580.jpg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nha-logo.d2b3527.jpg";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phc-logo.b3b0b8e.jpg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vch-logo.f0add20.jpg";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/viha-logo.3e81c6a.jpg";

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a18d91e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(135),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7664f838",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
  __webpack_require__(95)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62653987",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cce72efc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a4b75ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56710d3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(137),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a2a537d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a9d935f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d609efc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('home', {
    attrs: {
      "clas": "bottom-padded-2x"
    }
  }), _vm._v(" "), _c('foreword', {
    staticClass: "bottom-padded-2x"
  }), _vm._v(" "), _c('ListIndicators', {
    staticClass: "bottom-padded-2x"
  }), _vm._v(" "), _c('TableContents', {
    staticClass: "bottom-padded-2x"
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "go-to-top"
    },
    on: {
      "click": _vm.goTop
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Table of Contents")]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "print"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Print")]), _vm._v(" "), _c('Acknowledgements', {
    staticClass: "bottom-padded-2x"
  }), _vm._v(" "), _c('StopProgram', {
    staticClass: "bottom-padded-2x"
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "1"
    }
  }, [_vm._v("HIV Testing Episodes and Rates")]), _vm._v(" "), _c('p', [_vm._v("\n      In this section, the number of HIV test episodes and point of care (POC) HIV tests\n      conducted each quarter in BC is shown. In general terms the goal is to increase the\n      number of tests performed and to maximize testing efficiency. Test episodes are\n      allocated by region according to where the test is performed.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bottom-padded",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\n    N.B. All HIV Testing Episodes reflect non-prenatal tests. All prenatal tests have been removed.\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Indicator 1. HIV Testing Episodes")]), _vm._v(" "), _c('Chart', {
    staticClass: "bottom-padded",
    attrs: {
      "figure": "1.1"
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "1.2"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [1, 2]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "1.3"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [1, 2]
    }
  }), _vm._v(" "), _c('Chart', {
    staticClass: "bottom-padded",
    attrs: {
      "figure": "1.4"
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "1.5"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [1]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "1.6"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [1]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "1.7"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [1]
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "2"
    }
  }, [_vm._v("Indicator 2. HIV Testing Rates")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\n    N.B. All HIV Testing Episodes reflect non-prenatal tests. All prenatal tests have been removed.\n  ")]), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "2.1"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [2]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "2.2"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [2]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "2.3"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [2]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "3"
    }
  }, [_vm._v("New HIV Diagnoses")]), _vm._v(" "), _c('p', {
    staticClass: "bottom-padded"
  }, [_vm._v("\n      Trends in HIV diagnoses by gender and exposure category are described. Interpreting\n      HIV diagnoses must be done with consideration that trends are influenced by both\n      changes in testing rate as well as changes in transmission rates. It is important to\n      note that new HIV diagnoses cases and rates are not synonymous with HIV incidence\n      as a person may have become infected with HIV long before they tested positive for\n      HIV. However, as there is no reliable method for measuring HIV incidence, we follow\n      trends in HIV diagnoses.\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Indicator 3. New HIV Diagnoses")]), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "3.1"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [3]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "3.2"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [3]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "3.3"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [3]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "3.4"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [3, 4]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "3.5"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [3]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "4"
    }
  }, [_vm._v("Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('p', [_vm._v("\n      Classification of stage of HIV infection, in the absence of\n      information regarding recent testing history, is reliant\n      on clinical information available at the time of diagnosis,\n      including first CD4+ cell count and laboratory results\n      suggestive of acute HIV infection (Table 1). The benefits\n      of Treatment as Prevention (TasP) are maximized when\n      antiretroviral therapy (ART) is initiated at high CD4 cell\n      counts. Accordingly, it is preferable that individuals newly\n      diagnosed with HIV be in the early stages of HIV infection\n      (stage 0 or 1) to allow for early ART initiation.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "bottom-padded",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\n    N.B. Interpretation of Stage of HIV Infection at Diagnosis should proceed\n    with caution. Early increases in diagnosis at late stage (i.e., low CD4\n    counts) may represent a \"catching up\" of previously missed long term\n    infected individuals rather than a trend toward diagnosis at later stage\n    of infection. Additionally, there has been an increase in the proportion\n    of new diagnosis in 2016 for whom these data are missing (37%),  leading\n    to a slight overestimation of the overall proportion within each stage.\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Indicator 4. Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "table1"
    }
  }, [_vm._v("Table 1: Staging Classifications of Infection at Time of HIV Diagnosis Based on CDC HIV Surveillance Case Definitions")]), _vm._v(" "), _c('Table1', {
    staticClass: "bottom-padded"
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-box bottom-padded"
  }, [_c('Chart', {
    attrs: {
      "figure": "4.1"
    }
  }), _vm._v(" "), _c('Chart', {
    staticClass: "left-padded",
    attrs: {
      "figure": "4.2"
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    attrs: {
      "figures": [4.1, 4.2]
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [5]
    }
  }), _vm._v(" "), _c('Chart', {
    staticClass: "bottom-padded",
    attrs: {
      "figure": "4.3"
    }
  }), _vm._v(" "), _c('Chart', {
    staticClass: "bottom-padded",
    attrs: {
      "figure": "4.4"
    }
  }), _vm._v(" "), _c('DataTable', {
    attrs: {
      "figures": [4.3, 4.4]
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [5, 6]
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "5"
    }
  }, [_vm._v("Indicator 5. HIV Cascade of Care")]), _vm._v(" "), _c('p', [_vm._v("\n      The success of seek, test, treat and retain (STTR) strategies like STOP is reliant on early diagnosis of HIV, linking newly\n      diagnosed HIV-positive persons with ongoing care, retaining persons in HIV-care; initiating ART based on best evidenced\n      practices and maintaining optimal ART adherence to ensure a suppressed viral load. These stages of HIV-care\n      can be summarized as: 1. HIV diagnosis, 2. Linked to HIV care, 3. Retained in HIV care, 4. On ART, 5. Adherent to ART\n      and 6. Achieving a suppressed VL; collectively, they are referred to as the cascade of care. Attrition between any of\n      these stages of HIV-care means a reduction in the potential of ART as a benefit to the HIV-positive individual and as an\n      HIV transmission prevention method on a population level. Thus, when interpreting trends in the cascade of care, we\n      strive to see increases along each step of the cascade of care (i.e. reduced attrition) with the ultimate goal being 100%\n      within each stage of the cascade. Monitoring the Cascade of Care provides a picture as to where deficiencies lie in the\n      delivery and uptake of HIV-care. In this section, we present the cascade of care for the period stated in BC overall and\n      stratified by sex and age for each Health Authority.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-box"
  }, [_c('Chart', {
    attrs: {
      "figure": "5.1"
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.2"
    }
  })], 1), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [7]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.3"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [8]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.4"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [9]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.5"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [9]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.6"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [9]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "5.7"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [9]
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "6"
    }
  }, [_vm._v("Indicator 6. Programmatic Compliance Score (PCS)")]), _vm._v(" "), _c('p', [_vm._v("\n      The Programmatic Compliance Score (PCS) is a summary measure of risk of future\n      death, immunologic failure and virologic failure from all causes for people who are\n      starting ART for the first time. It is composed of patient- and physician-driven effects.\n      PCS scores range from 0–6 with higher scores indicative of poorer health outcomes\n      and greater risk of death. Table 2 provides mortality, immunologic failure and virologic\n      failure probabilities for given PCS scores. We interpret an individual with a PCS≥4 as\n      being 22 times more likely to die, almost 10 times more likely to have immunologic\n      failure and nearly 4 times as likely to demonstrate virologic failure compared to\n      those individuals with a PCS score of 0. A detailed description of how the PCS score\n      is calculated and its validation can be found in the technical report. In short, PCS\n      scores are calculated by summing the results (yes=1, no=0) of six un-weighted nonperformance\n      indicators based on IAS–USA treatment guidelines:\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "table2"
    }
  }, [_vm._v("Table 2. Probability of Mortality, Immunologic Failure and Virologic Failure based on the Programmatic Compliance Score")]), _vm._v(" "), _c('DataTable', {
    attrs: {
      "figures": [6]
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "6.1"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [10]
    }
  }), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "6.2"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [10, 11]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "7a"
    }
  }, [_vm._v("Indicator 7. New Antiretroviral Therapy Starts in " + _vm._s(_vm.haName))]), _vm._v(" "), _c('h2', [_vm._v("Antiretroviral Uptake")]), _vm._v(" "), _c('p', [_vm._v("\n      In this section we present trends in ART uptake, the number and proportion of new HIV treatment initiations\n      and the number of active and inactive DTP participants. Trends in ART uptake should be interpreted under the\n      consideration of changing BC HIV treatment guidelines. BC HIV treatment guidelines are updated regularly by\n      the BC-CfE Therapeutic Guidelines Committee and reflect those of the International AIDS Society. Since 2012 HIV\n      treatment has been recommended for all HIV-positive adults regardless of CD4 cell count; as evidence demonstrates\n      that early initiation of HIV treatment maximizes both the individual’s health outcomes as well as the potential\n      of ART as a form of HIV transmission prevention at a population level.\n      As such, trends in the number and proportion of persons on ART and new ART starts (in both naïve and experienced\n      persons) are expected to increase over time at higher CD4 cell counts.\n  ")]), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "7"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [12]
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "8a"
    }
  }, [_vm._v("Indicator 8. CD4 Cell Count at ART Initiation")]), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "8"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [13]
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "9a"
    }
  }, [_vm._v("Indicator 9. Active and Inactive DTP Participants")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "table3"
    }
  }, [_vm._v("Table 3. Distribution of People on ART for " + _vm._s(_vm.table3.lastYear) + " Q" + _vm._s(_vm.table3.lastQuarter) + " "), _c('sup', [_vm._v("14")])]), _vm._v(" "), _c('DataTable', {
    attrs: {
      "figures": [9]
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded",
    attrs: {
      "footnotes": [14]
    }
  }), _vm._v(" "), _c('div', [_c('Chart', {
    attrs: {
      "figure": "9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "breaker",
    style: (_vm.breakStyle)
  }, [_c('div', {
    staticClass: "container3 zigzag top"
  }), _vm._v(" "), _c('div', {
    staticClass: "container3 zigzag bottom"
  })])], 1), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [15]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "10a"
    }
  }, [_vm._v("Indicator 10. Antiretroviral Adherence Level")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "10"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [16]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "11a"
    }
  }, [_vm._v("Resistance Testing and Results")]), _vm._v(" "), _c('h2', [_vm._v("Indicator 11. Resistance Testing and Results")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "11"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [17]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "12a"
    }
  }, [_vm._v("AIDS-Defining Illness")]), _vm._v(" "), _c('h2', [_vm._v("Indicator 12. AIDS-Defining Illness")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('Chart', {
    attrs: {
      "figure": "12"
    }
  }), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [18]
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "13a"
    }
  }, [_vm._v("HIV-Related Mortality")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "13"
    }
  }, [_vm._v("Indicator 13. HIV-Related Mortality for all BC")]), _vm._v(" "), _c('p', [_vm._v("\n      Evidence indicates that individuals who initiate treatment with\n      recommended ART in a timely fashion may live near normal lifespans.\n      Excess mortality among HIV positive persons is, therefore, an\n      important measure of HIV care with a goal of minimizing HIV-related\n      mortality in British Columbia.\n  ")]), _vm._v(" "), _c('div', [_c('Chart', {
    attrs: {
      "figure": "13"
    }
  })], 1), _vm._v(" "), _c('Footnotes', {
    staticClass: "bottom-padded-2x",
    attrs: {
      "footnotes": [19]
    }
  }), _vm._v(" "), _c('Appendices')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("having "), _c('span', {
    staticStyle: {
      "color": "#0076a3"
    }
  }, [_vm._v("<3 CD4 cell count tests")]), _vm._v(" in the first year after starting antiretroviral therapy (ART);")]), _vm._v(" "), _c('li', [_vm._v("having "), _c('span', {
    staticStyle: {
      "color": "#9d0140"
    }
  }, [_vm._v("<3 plasma viral load (VL) tests")]), _vm._v(" in the first year after starting ART; ")]), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "color": "#ab9f01"
    }
  }, [_vm._v("not having drug resistance testing")]), _vm._v(" done prior to starting ART;")]), _vm._v(" "), _c('li', [_vm._v("starting on a "), _c('span', {
    staticStyle: {
      "color": "#560054"
    }
  }, [_vm._v("non-recommended ART")]), _vm._v(" regimen;")]), _vm._v(" "), _c('li', [_vm._v("starting therapy with "), _c('span', {
    staticStyle: {
      "color": "#007236"
    }
  }, [_vm._v("CD4<200 cells/µL")]), _vm._v("; and")]), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "color": "#9d070d"
    }
  }, [_vm._v("not achieving viral suppression")]), _vm._v(" within 9 months since ART initiation. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bottom-padded"
  }, [_vm._v("\n      In this section we provide PCS scores and their components over time for the province\n      of BC. A decline to 0%, "), _c('b', [_vm._v("(i.e., all individuals having a score of 0)")]), _vm._v(" is the eventual goal.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bottom-padded"
  }, [_c('i', [_vm._v("Reference: Lima VD, Le A, Nosyk B, Barrios R, Yip B, et al. (2012) Development and Validation\n      of a Composite Programmatic Assessment Tool for HIV Therapy. PLoS ONE 7(11): e47859.\n      doi:10.1371/journal.pone.0047859")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      In this section we present trends in prescription refill adherence levels for\n      individuals in their first year of treatment. Given that the benefits of ART are\n      compromised in the presence of imperfect ART adherence, we expect to see the\n      proportion of persons on ART achieving "), _c('span', {
    staticStyle: {
      "color": "#007596"
    }
  }, [_vm._v("near perfect adherence")]), _vm._v(" (ie. "), _c('span', {
    staticStyle: {
      "color": "#007596"
    }
  }, [_vm._v("≥95%")]), _vm._v(") to\n      increase with time. Furthermore, it is important that trends in the proportion\n      of ART users achieving prescription refill adherence of "), _c('span', {
    staticStyle: {
      "color": "#007596"
    }
  }, [_vm._v("≥95%")]), _vm._v(" keep pace with\n      new ART starts and increase among those continuing on ART.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      In this section, we present trends in cumulative resistance testing by resistance category:\n      "), _c('span', {
    staticStyle: {
      "color": "#560054"
    }
  }, [_vm._v("Suppressed")]), _vm._v(" (where a DTP participant’s viral load is too low to be genotyped); "), _c('span', {
    staticStyle: {
      "color": "#0076a3"
    }
  }, [_vm._v("Wild\n      Type")]), _vm._v(" (where no HIV treatment resistances were discovered), "), _c('span', {
    staticStyle: {
      "color": "#086c28"
    }
  }, [_vm._v("Never Genotyped")]), _vm._v(", and\n      Resistances to "), _c('span', {
    staticStyle: {
      "color": "#ab9f01"
    }
  }, [_vm._v("one")]), _vm._v(", "), _c('span', {
    staticStyle: {
      "color": "#a36109"
    }
  }, [_vm._v("two")]), _vm._v(", "), _c('span', {
    staticStyle: {
      "color": "#9d070d"
    }
  }, [_vm._v("three")]), _vm._v(", or "), _c('span', {
    staticStyle: {
      "color": "#4f0e0e"
    }
  }, [_vm._v("four")]), _vm._v(" HIV treatment classes. Resistance testing prior to\n      ART initiation is recommended in the BC HIV treatment primary care guidelines. Thus,\n      it is expected that trends over time should find all persons enrolled in the DTP to have\n      been genotyped. Trends over time should also show an increase in the proportion of DTP\n      participants achieving a suppressed status and an increase in resistance testing should\n      not lead to an increase in the number of ART resistances occurring.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Improvements in ART and the expansion of ART province-wide has led to very low numbers of recorded AIDS\n      cases across BC. However, interpreting trends in AIDS cases is challenging as AIDS reporting is passive in BC and\n      it is likely that they are under-reported across all Health Authorities. In addition to under-reporting, methods of\n      reporting AIDS cases are inconsistent across HA’s and do not truly reflect the current reality of new AIDS diagnoses.\n      Efforts will need to be made to improve under- and inconsistent reporting of AIDS cases across all HA’s. The\n      table below shows AIDS cases using three definitions. First, AIDS cases were defined as the number of physician reported\n      AIDS defining illness (ADI) in a given year. AIDS case reporting is a passive process and physicians\n      can voluntarily report AIDS cases to the BCCDC or DTP. As such, we have plotted both "), _c('span', {
    staticStyle: {
      "color": "#ab9f01"
    }
  }, [_vm._v("BCCDC reports")]), _vm._v(" and "), _c('span', {
    staticStyle: {
      "color": "#9d0140"
    }
  }, [_vm._v("DTP\n          reported AIDS cases")]), _vm._v(". We also show the proportion of persons "), _c('span', {
    staticStyle: {
      "color": "#0076a3"
    }
  }, [_vm._v("initiating ART with a CD4<200 cells/µL")]), _vm._v(".\n  ")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "title-container",
    staticStyle: {
      "width": "60em"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "relative",
      "left": "-110px",
      "margin-bottom": "80px"
    },
    attrs: {
      "src": __webpack_require__(33)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "relative",
      "left": "230px",
      "margin-bottom": "80px"
    },
    attrs: {
      "src": __webpack_require__(103)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "sub-title",
    staticStyle: {
      "padding-left": "150px"
    }
  }, [_vm._v("FOR " + _vm._s(_vm.$route.params.ha === 'bc' ? 'BRITISH COLUMBIA' : this.$parent.haName.toUpperCase()))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "150px",
      "font-size": "1.5rem"
    }
  }, [_vm._v(_vm._s(_vm.quarter) + " QUARTER " + _vm._s(_vm.year))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title",
    staticStyle: {
      "padding-left": "150px"
    }
  }, [_vm._v("HIV Monitoring"), _c('br'), _vm._v("Quarterly Report")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "id": "using-safari",
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_c('i', {
    staticClass: "fa fa-safari",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Heads Up")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("It seems that you are using the Safari web browser. However, this website is best viewed using "), _c('a', {
    attrs: {
      "href": "https://www.google.com/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "logos top-padded-2x",
    attrs: {
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": __webpack_require__(102)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": __webpack_require__(106)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": __webpack_require__(105)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-1",
    attrs: {
      "src": __webpack_require__(107)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": __webpack_require__(111)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": __webpack_require__(108)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": __webpack_require__(109)
    }
  })]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "logo-partner-2",
    attrs: {
      "src": __webpack_require__(110)
    }
  })])])])])
}]}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acknowledgements"
  }, [_c('h1', {
    attrs: {
      "id": "acknowledgements"
    }
  }, [_vm._v("Acknowledgements and Contributions")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "258px"
    },
    attrs: {
      "src": __webpack_require__(33)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("British Columbia Centre for Excellence in HIV/AIDS (BC-CfE):")]), _vm._v(" The BC-CfE is responsible for\n    the conception, preparation and ongoing review of this quarterly report. The BC-CfE provides the\n    data and outputs for Indicators 5 (HIV Cascade of Care), 6 (Programmatic Compliance Score),\n    7 (New Antiretroviral Starts), 8 (CD4 Cell Count at ART Initiation), 9 (Active and Inactive Drug\n    Treatment Program Participants), 10 (Antiretroviral Adherence Level), 11 (Resistance Testing\n    Results by Resistance Category), 12 (AIDS-Defining Illness), and 13 (HIV-Related Mortality).\n    The BC-CfE database provides pVL and CD4 cell count testing data, as well as ART use. All pVL\n    measurements in BC are performed at the St Paul’s Hospital virology laboratory, thus pVL data\n    capture is 100%. An estimated 80% of all CD4 count measurements performed in the province\n    are captured in the BC-CfE data holdings. The STOP HIV/AIDS Technical Monitoring Committee–\n    BC-CFE is responsible for oversight of the monitoring report. Lilith Swetland is the editor\n    of this report. Paul Sereda, Dr. Viviane Lima and Nada Gataric perform analysis of Indicators 5–13.\n    Rafael Trevisan developed programming for this website. This report was conceived and guided by Dr. Julio Montaner.\n  ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "258px"
    },
    attrs: {
      "src": __webpack_require__(104)
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("British Columbia Centre for Disease Control (BCCDC):")]), _vm._v(" The BCCDC provides the data and\n    outputs for Indicator 1 (HIV Testing Episodes), Indicator 2 (HIV Testing Rate), Indicator 3 (New\n    HIV Diagnoses), Indicator 4 (Stage of HIV at Diagnosis) and Indicator 12 (AIDS-Defining Illness).\n    The BCCDC is the single provincial agency that centralizes all HIV surveillance through the Public\n    Health Microbiology and Reference Laboratory, which does more than 90% of all HIV screening\n    tests in BC and all confirmatory testing. Olga Mazo, Theodora Consolacion and Dr. Jason Wong\n    are responsible for outputs for Indicators 1–4\n  ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Other Data Sources:")])]), _vm._v(" "), _c('p', [_vm._v("\n    The above databases were supplemented with:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (I) The BC Vital Statistics database which was used to calculate Indicator 5. The HIV Cascade of\n    Care and Indicator 13. HIV-Related Mortality.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (II) Linkage and preparation of the de-identified individual-level database used for calculating\n    Indicator 5. The HIV Cascade of Care was facilitated by the British Columbia Ministry of Health.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    (III) The Statistics Canada database: BC and HIV-positive population counts were acquired\n    through the Statistics Canada website to calculate HIV-specific mortality rates for Indicator 13.\n    HIV-Related Mortality.\n  ")])])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tg"
  }, [_c('tr', [_c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Stage")]), _vm._v(" "), _c('th', {
    staticClass: "tg-yw4l",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Criteria")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-031e"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Laboratory criteria met for acute HIV infection, or"), _c('br'), _vm._v("previous negative or indeterminate HIV test within"), _c('br'), _vm._v("180 days of first confirmed positive HIV test.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "tg-031e",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("Stage 0"), _c('br'), _vm._v("not met "), _c('i', {
    staticStyle: {
      "position": "relative",
      "left": "30px",
      "top": "-10px"
    }
  }, [_vm._v("and")])]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 ≥500")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("2a")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 350–499")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("2b")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 200–349")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("CD4 <200")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Unknown")]), _vm._v(" "), _c('td', {
    staticClass: "tg-yw4l"
  }, [_vm._v("No available CD4")])])])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart",
    attrs: {
      "id": _vm.figure.toString().replace('.', '-')
    }
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-indicators"
  }, [_c('h1', [_vm._v("List of Indicators")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(1)
      }
    }
  }, [_vm._v("Indicator 1. HIV Testing Episodes")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(2)
      }
    }
  }, [_vm._v("Indicator 2. HIV Testing Rate")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(3)
      }
    }
  }, [_vm._v("Indicator 3. New HIV Diagnoses")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(4)
      }
    }
  }, [_vm._v("Indicator 4. Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(5)
      }
    }
  }, [_vm._v("Indicator 5. HIV Cascade of Care")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(6)
      }
    }
  }, [_vm._v("Indicator 6. Programmatic Compliance Score (PCS)")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7a')
      }
    }
  }, [_vm._v("Indicator 7. New Antiretroviral Therapy Starts")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8a')
      }
    }
  }, [_vm._v("Indicator 8. CD4 Cell Count at ART Initiation")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9a')
      }
    }
  }, [_vm._v("Indicator 9. Active and Inactive Drug Treatment Program (DTP) Participants")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10a')
      }
    }
  }, [_vm._v("Indicator 10. Antiretroviral Adherence")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11a')
      }
    }
  }, [_vm._v("Indicator 11. Resistance Testing and Results")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12a')
      }
    }
  }, [_vm._v("Indicator 12. AIDS-Defining Illness")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13a')
      }
    }
  }, [_vm._v("Indicator 13. HIV-Related Mortality")]), _vm._v(" "), _c('a', {
    staticClass: "list-indicator",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('appendices')
      }
    }
  }, [_vm._v("Appendices")])])
},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('table', [_c('tbody', _vm._l((_vm.footnotes), function(footnote) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(footnote))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.note[footnote])
      }
    })])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appendices"
  }, [_c('h1', {
    attrs: {
      "id": "appendices"
    }
  }, [_vm._v("APPENDICES")]), _vm._v(" "), _c('table', {
    staticClass: "indicator-1"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._l((_vm.years([1.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([1.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([1.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.rows([1.1])[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.1])[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.2], 'Other')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.2], 'Other')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([1.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POC Tests\n        ")]), _vm._v(" "), _vm._l((_vm.rows([1.4])[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda) {
    return [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.5], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "left-padded",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            Female\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.6], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "left-padded",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            Male\n          ")]), _vm._v(" "), _vm._l((_vm.rows([1.7], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-2"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._l((_vm.years(2.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([2.1])), function(serie) {
    return _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n          " + _vm._s(serie.name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.1], serie.name)[0].data), function(col) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n          " + _vm._s(col) + "\n        ")])
    })], 2)
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([2.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([2.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2)], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-3"
  }, [_c('tbody', [_c('tr', [_vm._m(2), _vm._v(" "), _vm._l((_vm.years([3.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([3.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([3.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          By Client Residence\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.1], _vm.healthAuthorities[_vm.ha].name)[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          By Provider Address\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.1], 'By Provider Address')[0].data), function(row, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.2], 'Female')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.2], 'Female')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.2], 'Male')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.2], 'Male')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '< 30')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '< 30')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '30–39')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '30–39')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '40–49')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '40–49')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.3], '≥ 50')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.3], '≥ 50')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("\n          Exposure\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'MSM')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'MSM')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'PWID')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'PWID')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'HET')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'HET')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'Other')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'Other')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.rows([3.4], 'NIR/Unknown')[0].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([3.4], 'NIR/Unknown')[0].data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda) {
    return [_c('tr', [_c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            By Client Residence\n          ")]), _vm._v(" "), _vm._l((_vm.rows([3.5], hsda.name || hsda)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(row).toFixed(0)) + "\n          ")])
    })], 2), _vm._v(" "), _c('tr', {
      staticStyle: {
        "font-style": "italic"
      }
    }, [_c('td', [_vm._v("\n            By Provider Address\n          ")]), _vm._v(" "), _vm._l((_vm.rows([3.5], 'By Provider Address', _vm.rows([3.5], hsda.name || hsda)[0].color)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(row).toFixed(0)) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-4"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Female\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Male\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          < 30 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          30-39 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          40-49 years\n        ")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.years(4.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.2)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.3).slice(0, -5)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([4.1])), function(serie) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(serie.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([4.1], serie.name)[0].data), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    }), _vm._v(" "), _vm._l((_vm.rows([4.3], serie.name)[0].data.slice(0, 15)), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.years(4.1)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.2)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.years(4.3).slice(0, -5)), function(year) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(("'" + (year.toString().slice(-2)))) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.rows([4.1])), function(serie) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(serie.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([4.3], serie.name)[0].data.slice(-30)), function(row) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(row) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-5"
  }, [_c('tbody', [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.healthAuthorities[_vm.ha].name) + "\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.1], 'Overall HA')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Gender\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Men\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.2], 'Men')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Women\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.2], 'Women')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Age Category\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '< 30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          30–39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '30–39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          40–49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '40–49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.3], '≥ 50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          MSM Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'MSM')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Non-MSM\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'Non-MSM')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.4], 'Unknown')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "12"
    }
  }, [_vm._v("\n          Age Category and MSM Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'MSM:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Non-MSM\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Non-MSM:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          < 30\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:<30')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          30-39\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:30-39')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          40-49\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:40-49')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          ≥ 50\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.5], 'Unknown:>=50')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("\n          PWID Status\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          PWID\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'IDU')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Non-PWID\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'Non-IDU')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Unknown\n        ")]), _vm._v(" "), _vm._l((_vm.rows([5.6], 'Unknown')), function(value) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.healthAuthorities[_vm.ha].hsda), function(hsda, index) {
    return [_c('tr', [(index === 0) ? _c('td', {
      attrs: {
        "rowspan": _vm.healthAuthorities[_vm.ha].hsda.length
      }
    }, [_vm._v("\n            " + _vm._s(_vm.ha === 'bc' ? 'Health Authority' : 'HSDA') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("\n            " + _vm._s(hsda.name || hsda) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([5.7], hsda.name || hsda)), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(value) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-6"
  }, [_c('tbody', [_c('tr', [_vm._m(6), _vm._v(" "), _vm._l((_vm.years([6.1])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([6.1])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([6.1])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator6), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows(row.figure, row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(index <= 5 ? 1 : 0)) + _vm._s(index <= 5 ? '%' : '') + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.years([7])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([7])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([7])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator7), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([7], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.years([8])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([8])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([8])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator8), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([8], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(9), _vm._v(" "), _vm._l((_vm.years([9])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([9])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([9])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator9), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([9], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.years([10])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([10])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([10])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator10), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([10], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  }), _vm._v(" "), _c('tr', {
    staticClass: "new-indicator"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.years([11])), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(_vm.years([11])[index - 1] !== year ? year : '') + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.quarters([11])), function(quarter, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(quarter) + "\n        ")])
  })), _vm._v(" "), _vm._l((_vm.indicator11), function(row, index) {
    return [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(row.name) + "\n          ")]), _vm._v(" "), _vm._l((_vm.rows([11], row.serie || row.name)[0].data), function(value) {
      return _c('td', {
        staticClass: "right-aligned"
      }, [_vm._v("\n            " + _vm._s(Number(value).toFixed(0)) + "\n          ")])
    })], 2)]
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "indicator-12"
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.years(12)), function(year) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          CD4 < 200 at ART initiation\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'CD4<200 at ART Initiation (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'CD4<200 at ART Initiation (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          AIDS Cases (DTP Reports)\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: DTP Reports (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('td', [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: DTP Reports (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          AIDS Cases (BCCDC Reports)\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          Cases\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: BCCDC Reports (CASES)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\n          Rate per 100,000\n        ")]), _vm._v(" "), _vm._l((_vm.rows([12]).find(function(e) {
    return e.table.title === 'AIDS: BCCDC Reports (PER 100K)'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(1)) + "\n        ")])
  })], 2)])]), _vm._v(" "), _c('table', {
    staticClass: "indicator-13",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.years(13)), function(year) {
    return _c('td', {
      staticClass: "right-aligned bottom-aligned"
    }, [_vm._v("\n          " + _vm._s(year) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          British Columbia\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'HIV-Related Deaths'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(0)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Per 100 HIV+ Population\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'Per 100 HIV+ Population'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(2)) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Per 100,000 Population\n        ")]), _vm._v(" "), _vm._l((_vm.rows([13]).find(function(e) {
    return e.table.title === 'Per 100,000 Population'
  }).data), function(row) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v("\n          " + _vm._s(Number(row).toFixed(2)) + "\n        ")])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 1: "), _c('b', [_vm._v("Test Episodes (thousands)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 2: "), _c('b', [_vm._v("Rate of HIV Testing per 100,000")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 3: "), _c('b', [_vm._v("New HIV Diagnoses")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "31"
    }
  }, [_vm._v("\n          Indicator 4: "), _c('b', [_vm._v("Stage of HIV Infection at Baseline")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('td', {
    staticClass: "bottom-aligned"
  }), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          ≥ 50 years\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          MSM\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          PWID\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Heterosexual\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          Other Exposure\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "center-aligned bottom-aligned",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n          NIR/Unknown\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          Indicator 5: "), _c('b', [_vm._v("HIV Cascade of Care")])]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Diagnosed\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Linked\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Retained\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          On ARVs\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Adherent\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v("\n          Suppressed\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 6: "), _c('b', [_vm._v("Programmatic Compliance Score (PCS)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 7: "), _c('b', [_vm._v("New DTP ARV Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 8: "), _c('b', [_vm._v("CD4 Cell Count Initiation for ARV-Naïve DTP Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 9: "), _c('b', [_vm._v("Active and Inactive DTP Participants")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 10: "), _c('b', [_vm._v("Antiretroviral Adherence")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n          Indicator 11: "), _c('b', [_vm._v("Resistance Testing and Results")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Indicator 12: "), _c('b', [_vm._v("AIDS-Defining Illness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "bottom-aligned"
  }, [_vm._v("\n          Indicator 13: "), _c('b', [_vm._v("HIV-Related Mortality")])])
}]}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [(_vm.figures.includes(4.1) || _vm.figures.includes(4.3)) ? _c('table', {
    staticClass: "table-4"
  }, [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.dataSource.groups), function(group) {
    return _c('td', {
      staticClass: "center-aligned",
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          " + _vm._s(group) + "\n        ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "30px",
      "vertical-align": "top"
    }
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.dataSource.header), function(year, index) {
    return _c('td', {
      staticClass: "right-aligned"
    }, [_vm._v(_vm._s(index === 0 ? year : ("'" + (year.toString().slice(-2)))))])
  })], 2), _vm._v(" "), _vm._l((_vm.dataSource.rows), function(row) {
    return _c('tr', [_c('td', {
      class: row.name.replace(' ', '-').toLowerCase()
    }, [_vm._v("\n          " + _vm._s(row.name) + "\n        ")]), _vm._v(" "), _vm._l((row.data), function(data) {
      return _c('td', {
        staticClass: "right-aligned",
        class: row.name.replace(' ', '-').toLowerCase()
      }, [_vm._v("\n          " + _vm._s(data) + "\n        ")])
    })], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.figures.includes(6)) ? _c('table', {
    staticClass: "table-6"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.figures.includes(9)) ? _c('table', {
    staticClass: "table-9",
    style: ({
      minWidth: _vm.width + 'px'
    })
  }, [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Fraser")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Interior")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Island")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Northern")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Vancouver"), _c('br'), _vm._v("Coastal")]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned bottom-aligned"
  }, [_vm._v("Total BC")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Age")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("< 30")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['< 30'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("30–39")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['30–39'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("40–49")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['40–49'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("≥ 50")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['≥ 50'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("Male")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Male'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Female")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Female'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Exposure")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("MSM")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['MSM'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("PWID")]), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['PWID'].bc))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }), _vm._v(" "), (_vm.visibleFor('fha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].fha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('iha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].iha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('viha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].viha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('nha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].nha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('vcha')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].vcha))]) : _vm._e(), _vm._v(" "), (_vm.visibleFor('bc')) ? _c('td', {
    staticClass: "grey right-aligned"
  }, [_vm._v(_vm._s(_vm.dataSource['Total'].bc))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Programmatic"), _c('br'), _vm._v("Compliance Score")]), _vm._v(" "), _c('td', [_vm._v("Mortality Risk Ratio"), _c('br'), _vm._v("(95% Confidence Interval)"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("Immunologic Failure Risk"), _c('br'), _vm._v("Ratio (95% CI)")]), _vm._v(" "), _c('td', [_vm._v("Virologic Failure Risk Ratio"), _c('br'), _vm._v("(95% CI)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("0 (Best score)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1 (–)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("3.81 (1.73–8.42)")]), _vm._v(" "), _c('td', [_vm._v("1.39 (1.04–1.85)")]), _vm._v(" "), _c('td', [_vm._v("1.32 (1.05–1.67)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("7.97 (3.70–17.18)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("2.17 (1.54–3.04)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1.86 (1.46–2.38)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("11.51 (5.28–25.08)")]), _vm._v(" "), _c('td', [_vm._v("2.93 (1.89–4.54)")]), _vm._v(" "), _c('td', [_vm._v("2.98 (2.16–4.11)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "grey"
  }, [_vm._v("4 or more"), _c('br'), _vm._v("(Worst score)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("22.37 (10.46–47.84)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("9.71 (5.72–16.47)")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("3.80 (2.52–5.73)")])])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-contents"
  }, [_c('h1', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "table"
    }
  }, [_c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('acknowledgements')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Acknowledgements and Contributions")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('bc-provincial-stop')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("BC Provincial STOP Program")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('interpreting')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("A Note on Monitoring and Interpreting HIV Indicators")])])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll(1)
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 1")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + " by Gender, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for " + _vm._s(this.$parent.haName) + " by Age Category, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Point-of-Care HIV Tests for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes by " + _vm._s(this.$parent.groupBy) + " for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for Non-Prenatal Females in " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('1-7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 1.7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV Test Episodes for Males in " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 2")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " and " + _vm._s(this.$parent.groupByPlural) + ", 2009–2018")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " by Gender, 2009–2018")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('2-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 2.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Rate of HIV Testing for " + _vm._s(this.$parent.haName) + " by Age Category, 2009–2018")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("New HIV Diagnoses")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Gender, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Age Category, " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by Exposure Category, 2013 Q4-2018 Q3")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('3-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 3.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("New HIV Diagnoses for " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", " + _vm._s(this.$parent.period))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 4")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Staging Classifications of Infection at Time of HIV Diagnosis Based on CDC HIV Surveillance Case Definitions")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + ", 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Gender, 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Age Category, 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('4-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 4.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Stage of HIV Infection at Diagnosis for " + _vm._s(this.$parent.haName) + " by Exposure Category, 2013–2017")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("HIV Cascade of Care")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + ", Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Gender, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Age Category, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-4')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.4")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by MSM Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-5')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.5")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by Age Category and MSM Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by PWID Status, Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('5-7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 5.7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Estimated Cascade of Care for " + _vm._s(this.$parent.haName) + " by " + _vm._s(this.$parent.groupBy) + ", Year Ending " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 6")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Programmatic Compliance Score (PCS)")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Probability of Mortality, Immunologic Failure and Virologic Failure Based on the Programmatic Compliance Score")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6-1')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 6.1")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("PCS Components for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Less than 3 CD4 Tests in First Year")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Less than 3 Viral Load Tests in First Year")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Not Having Drug Resistance Testing at Baseline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Non-Recommended Antiretroviral Therapy Regimen (ART)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px",
      "padding-bottom": "12px"
    }
  }, [_vm._v("Baseline CD4 < 200 cells/µL")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("Not Achieving Viral Suppression at 9 Months")])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('6-2')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 6.2")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Historical Trends for PCS Score for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("New Antiretroviral Therapy Starts in " + _vm._s(this.$parent.haName))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('7')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 7")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("\n        BC-CfE Drug Treatment Program Enrollment:"), _c('br'), _vm._v(" "), _c('span', [_vm._v("New Antiretroviral Participants for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 8")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("CD4 Cell Count at ART Initiation")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('8')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 8")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("CD4 Cell Count at ART Initiation for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 9")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Active and Inactive Drug Treatment Program (DTP) Participants")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('table3')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Table 3")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Distribution of People on ART in " + _vm._s(this.$parent.haName) + ", " + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('9')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 9")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Active and Inactive DTP Participants for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 10")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Antiretroviral Adherence")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('10')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 10")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("\n        Distribution of Individuals by Adherence Level in 1st Year of Therapy,"), _c('br'), _vm._v(" "), _c('span', [_vm._v("Based on Pharmacy Refill Compliance for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 11")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("Resistance Testing and Results")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('11')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 11")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("Cumulative Resistance Testing Results by Resistance Category for " + _vm._s(this.$parent.haName) + ", 2017 Q2–" + _vm._s(this.$parent.lastYear) + " Q" + _vm._s(this.$parent.lastQuarter))])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 12")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("AIDS-Defining Illness")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('12')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 12")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("AIDS Case Rate and Reports for " + _vm._s(this.$parent.haName) + ", 2010–2016")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13a')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_vm._v("Indicator 13")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell bold"
  }, [_vm._v("HIV-Related Mortality")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('13')
      }
    }
  }, [_c('span', {
    staticClass: "table-cell fixed-column"
  }, [_vm._v("Figure 13")]), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  }, [_vm._v("HIV-Related Deaths by Year for all BC")])]), _vm._v(" "), _c('a', {
    staticClass: "table-row",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.goToByScroll('appendices')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "table-cell"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("HIV Testing Episodes")]), _vm._v(" "), _c('i', [_vm._v("All HIV Testing Episodes reflect non-prenatal tests. All prenatal tests have been removed.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("HIV Testing Rates")]), _vm._v(" "), _c('i', [_vm._v("All HIV Testing Rates reflect non-prenatal tests. All prenatal tests have been removed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell"
  }, [_c('b', [_vm._v("Stage of HIV Infection at Diagnosis")]), _vm._v(" "), _c('i', [_vm._v("Stage definitions have been altered to remove\n        AIDS diagnosis data. Individuals previously classified as Stage 3 have been re-classified based on CD4 cell count.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "table-cell fixed-column bold"
  }, [_c('span', [_vm._v("Appendices")])])
}]}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stop-program"
  }, [_c('h1', {
    staticClass: "space-before-2x",
    attrs: {
      "id": "bc-provincial-stop"
    }
  }, [_vm._v("Membership of the STOP HIV/AIDS Technical "), _c('br'), _vm._v(" Monitoring Committee – BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Dr. Rolando Barrios, Chair, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Dr. Kate Heath, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Dr. Bohdan Nosyk, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Dr. Viviane Dias Lima, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Ms. Irene Day, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Mr. Paul Sereda, BC-CfE")]), _vm._v(" "), _c('p', [_vm._v("Dr. Jason Wong, BCCDC")]), _vm._v(" "), _c('p', [_vm._v("Dr. Mel Krajden, BCCDC")]), _vm._v(" "), _c('p', [_vm._v("FNHA (TBC)")]), _vm._v(" "), _c('p', [_vm._v("Ms. Lily Zhou, FNHA")]), _vm._v(" "), _c('p', [_vm._v("Dr. Aamir Bharmal, FHA")]), _vm._v(" "), _c('p', [_vm._v("Ms. Brooke Kinniburgh, FHA")]), _vm._v(" "), _c('p', [_vm._v("Ms. Barbara Gauthier, IHA")]), _vm._v(" "), _c('p', [_vm._v("Ms. Robin Yates, MOH")]), _vm._v(" "), _c('p', [_vm._v("Ms. Kari Harder, NHA")]), _vm._v(" "), _c('p', [_vm._v("Dr. Neora Pick, PHSA")]), _vm._v(" "), _c('p', [_vm._v("Dr. Althea Hayden, VCHA")]), _vm._v(" "), _c('p', [_vm._v("Ms. Laurence Campeau, VIHA")]), _vm._v(" "), _c('h1', {
    staticClass: "top-padded",
    attrs: {
      "id": "interpreting"
    }
  }, [_vm._v("The Seek and Treat for Optimal Prevention (STOP) HIV/AIDS BC Provincial Program: A Note on\n      Monitoring and Interpreting HIV Indicators")]), _vm._v(" "), _c('p', [_vm._v("\n    The Seek and Treat for Optimal Prevention (STOP) of HIV/AIDS programme is a provincial initiative\n    to improve HIV diagnosis and care delivery in BC through increased HIV-specific funding\n    to all Health Service Delivery Areas (HSDA’s) across BC. The STOP provincial programme is\n    an expansion of a four-year STOP pilot project which was implemented in two Health Service\n    Delivery Areas in March 2010; the Vancouver HSDA which bears the largest burden of the HIV\n    epidemic in the province and the Northern Interior HSDA which bears a high burden of HIV-related\n    mortality. The STOP pilot project demonstrated the urgent need for improved efforts in\n    early diagnosis of HIV and timely initiation of antiretroviral therapy (ART) initiation.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    The expansion to a province-wide programme was announced on November 30th, 2013 by the\n    BC Ministry of Health with roll out of funding beginning on April 1st, 2013. This funding is\n    intended to be used in the implementation and evaluation of HIV-related diagnosis and care\n    initiatives within individual HA’s. Goals of the project include: 1. A reduction in the number\n    of new HIV infections in BC; 2. Improvements in the quality, effectiveness, and reach of HIV\n    prevention services; 3. An increase in early diagnosis of HIV; 4. A reduction in AIDS cases and\n    HIV-related mortality.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    The goals of HA-led STOP-funded initiatives are to work toward achieving these goals. To these\n    ends some outcome measures or indicators of progress have been drafted that should be considered\n    in the design and implementation phases of these initiatives.\n  ")])])
}]}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foreword"
  }, [_c('h1', [_vm._v("Foreword")]), _vm._v(" "), _c('p', [_vm._v("\n    As part of the BC Centre for Excellence (BC-CfE) in HIV/AIDS's mandate to\n    evaluate the outcomes of STOP HIV/AIDS programming in BC, we have developed\n    quarterly HIV/AIDS monitoring reports. These reports provide up-to-date data on\n    a variety of key HIV-related surveillance and treatment indicators. Selection of\n    these indicators was achieved through a collaborative process with various Health\n    Authority (HA) representatives. There are six reports in total, one for each HA\n    and one for the province of BC as a whole. In addition, there is a technical report\n    which explains how each HIV indicator is calculated. Data used in these reports\n    come from the British Columbia Centre for Disease Control (BCCDC), MSP billings,\n    hospitalization data from the Discharge Abstract Database, the Sunquest\n    Laboratory database at the Provincial Public Health Microbiology and Reference\n    Laboratory, Providence Health Care laboratory, BC Vital Statistics, and the BC-CfE\n    Drug Treatment Program (DTP) Database.\n    The STOP HIV/AIDS program is funded by the Province of British Columbia's Ministry of Health. \n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    The objectives of the quarterly HIV/AIDS monitoring reports are to:\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$route.params.ha == 'xxx') ? _c('p', {
    staticStyle: {
      "background-color": "rgba(255, 255, 0, 0.5)"
    }
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("\n      Provide timely HA-specific information on key HIV indicators which will\n      guide and inform HIV leaders and innovators in the development of future\n      HIV interventions and programs which will ultimately lead to decreasing\n      the burden of HIV in BC. The indicators will reflect ongoing or past successful\n      public health interventions and highlight areas in the HIV care spectrum\n      which require further attention and support.\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      Highlight limitations in our current data due to incomplete or time lagged\n      data and to develop future strategies to improve complete and timely data\n      capture.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    These reports are produced for the benefit of individual HA’s. As such, we are\n    enthusiastic about your involvement and cooperation regarding the development\n    of these monitoring reports. Please forward your comments and queries to\n    Dr. Rolando Barrios, Senior Medical Director\n    at the BC-CFE, at "), _c('a', {
    attrs: {
      "href": "mailto:rbarrios@cfenet.ubc.ca"
    }
  }, [_vm._v("rbarrios@cfenet.ubc.ca")]), _vm._v(".\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_vm._v("\n    * Be advised that a transposition of the column headers for indicator 4.4\n    'Stage of HIV Infection at Time of Diagnosis by Exposure Category' occurred in\n    some previous QMRs. Specifically, the PWID and Heterosexual column headers were switched in Figure 4.4.\n    This transposition affects reports for Q3 2017 through Q2 2018.\n     If you have any questions, please contact Irene Day\n    at "), _c('a', {
    attrs: {
      "href": "mailto:iday@cfenet.ubc.ca"
    }
  }, [_vm._v("iday@cfenet.ubc.ca")]), _vm._v(".\n  ")])
}]}

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

module.exports = {
	"7": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 110
		}
	},
	"8": {
		"chart": {
			"width": 600,
			"height": 600,
			"marginLeft": 100,
			"marginRight": 100
		}
	},
	"9": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 60
		}
	},
	"10": {
		"chart": {
			"width": 700,
			"height": 600
		}
	},
	"12": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"13": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.2": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.3": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.4": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.5": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.6": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.7": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"2.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"2.2": {
		"chart": {
			"width": null,
			"height": 500,
			"marginLeft": 100,
			"marginRight": 60
		}
	},
	"2.3": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.2": {
		"chart": {
			"width": null,
			"height": 500,
			"marginLeft": 100
		}
	},
	"3.3": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 60
		}
	},
	"3.4": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.5": {
		"chart": {
			"width": null,
			"height": 700
		}
	},
	"4.1": {
		"chart": {
			"width": 300,
			"height": 430
		}
	},
	"4.2": {
		"chart": {
			"width": 500,
			"height": 430
		}
	},
	"4.3": {
		"chart": {
			"width": 1000,
			"height": 430
		}
	},
	"4.4": {
		"chart": {
			"width": 800,
			"height": 430
		}
	},
	"5.1": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.3": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.4": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.5": {
		"chart": {
			"width": null,
			"marginLeft": 80
		}
	},
	"5.6": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.7": {
		"chart": {
			"width": null,
			"marginLeft": 80
		}
	},
	"6.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"6.2": {
		"chart": {
			"width": 500,
			"height": 600
		}
	}
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 10,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 72,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					99,
					83,
					61,
					68,
					44,
					56,
					56
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					17,
					18,
					14,
					11,
					18,
					12,
					14
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": -10,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					5,
					5,
					4,
					5,
					2,
					0,
					7
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					3,
					1,
					0,
					0,
					1,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 90,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					124,
					107,
					79,
					84,
					65,
					69,
					77
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_10.png"
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 11,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 5436,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					5198,
					5111,
					5445,
					5410,
					5307,
					5184,
					5418
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 523,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					561,
					602,
					544,
					551,
					554,
					580,
					622
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 13,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					30,
					35,
					33,
					22,
					21,
					27,
					27
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 119,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					120,
					120,
					104,
					108,
					109,
					100,
					113
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					21,
					27,
					22,
					21,
					20,
					15,
					16
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					5,
					7,
					4,
					4,
					4,
					2,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 6107,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					5935,
					5902,
					6152,
					6116,
					6015,
					5908,
					6202
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_11.png"
};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 12,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for BC <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					121,
					104,
					93,
					94,
					97,
					92,
					{
						"y": 70,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					2.7,
					2.3,
					2,
					2,
					2.1,
					2,
					{
						"y": 1.5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					138,
					115,
					96,
					90,
					84,
					82,
					{
						"y": 78,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					3.1,
					2.6,
					2.1,
					1.9,
					1.8,
					1.7,
					{
						"y": 1.6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					110,
					88,
					83,
					84,
					84,
					84,
					{
						"y": 66,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					2.5,
					2,
					1.8,
					1.8,
					1.8,
					1.8,
					{
						"y": 1.4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_12.png"
};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 13,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_13.png"
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for BC</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "British Columbia",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					66.106,
					71.188,
					70.43,
					77.864,
					76.929,
					79.864,
					80.687,
					88.747,
					87.77,
					83.236,
					80.619,
					87.205,
					85.065,
					83.904,
					81.918,
					89.138,
					89.342,
					86.028,
					88.164,
					{
						"y": 102.937,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">British Columbia</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_1.png"
};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for BC <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					31.228,
					33.759,
					33.67,
					37.423,
					37.355,
					38.704,
					38.69,
					42.346,
					42.612,
					40.126,
					38.194,
					41.361,
					40.575,
					40.353,
					39.189,
					41.814,
					42.17,
					40.639,
					41.439,
					{
						"y": 48.916,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					31.615,
					33.818,
					33.658,
					37.227,
					36.683,
					38.277,
					39.067,
					43.333,
					42.493,
					40.438,
					39.593,
					42.863,
					41.989,
					40.956,
					40.244,
					44.848,
					44.816,
					42.953,
					44.667,
					{
						"y": 52.121,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.256,
					0.306,
					0.211,
					0.284,
					0.323,
					0.272,
					0.322,
					0.316,
					0.315,
					0.304,
					0.37,
					0.492,
					0.49,
					0.485,
					0.474,
					0.638,
					0.656,
					0.894,
					0.791,
					{
						"y": 0.977,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_2.png"
};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for BC <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					17.583,
					19.17,
					18.892,
					19.716,
					19.883,
					21.762,
					21.825,
					22.244,
					22.562,
					22.838,
					21.933,
					22.6,
					22.744,
					24.349,
					23.37,
					24.092,
					24.919,
					25.497,
					25.853,
					{
						"y": 28.147,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					13.875,
					14.584,
					14.041,
					16.079,
					16.04,
					16.64,
					16.075,
					18.629,
					18.271,
					17.265,
					16.598,
					18.639,
					18.239,
					17.993,
					17.593,
					19.731,
					19.786,
					19.041,
					19.018,
					{
						"y": 22.212,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					10.097,
					10.528,
					10.502,
					11.642,
					11.388,
					11.739,
					11.802,
					13.259,
					12.872,
					11.836,
					11.589,
					12.378,
					12.207,
					11.675,
					11.457,
					12.944,
					12.497,
					11.68,
					12.171,
					{
						"y": 14.095,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					21.424,
					23.461,
					24.005,
					27.356,
					26.902,
					26.988,
					28.256,
					31.734,
					31.58,
					28.799,
					27.846,
					30.779,
					29.565,
					27.458,
					27.209,
					30.169,
					30.122,
					27.874,
					29.558,
					{
						"y": 37.199,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_3.png"
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for BC</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "British Columbia",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					3.007,
					3.305,
					2.891,
					2.93,
					2.568,
					2.611,
					2.608,
					2.752,
					2.35,
					2.368,
					2.462,
					2.489,
					2.011,
					2.11,
					2.011,
					1.838,
					1.7,
					1.542,
					1.267,
					{
						"y": 0.923,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">British Columbia</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_4.png"
};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for BC by Health Authority <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					14.483,
					14.887,
					15.091,
					16.092,
					15.84,
					16.844,
					17.1,
					18.525,
					19.207,
					17.925,
					17.16,
					18.261,
					18.274,
					17.938,
					17.552,
					19.339,
					20.08,
					19.177,
					18.425,
					{
						"y": 19.15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					5.53,
					5.596,
					5.863,
					6.613,
					7.04,
					7.884,
					9.117,
					10.46,
					9.851,
					9.006,
					8.792,
					9.887,
					9.697,
					9.409,
					9.681,
					9.965,
					10.216,
					9.571,
					13.463,
					{
						"y": 23.843,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.963,
					2.852,
					2.987,
					3.73,
					3.177,
					3.222,
					3.188,
					3.676,
					3.395,
					3.105,
					3.087,
					3.746,
					3.659,
					3.465,
					3.381,
					3.887,
					4.116,
					3.559,
					3.594,
					{
						"y": 4.003,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					38.366,
					43.013,
					41.587,
					45.53,
					44.835,
					45.524,
					44.664,
					49.02,
					48.049,
					46.655,
					45.173,
					48.515,
					47.129,
					46.484,
					44.567,
					48.648,
					47.758,
					46.6,
					45.133,
					{
						"y": 48.23,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					4.764,
					4.84,
					4.902,
					5.899,
					6.037,
					6.39,
					6.618,
					7.066,
					7.268,
					6.545,
					6.407,
					6.796,
					6.306,
					6.608,
					6.737,
					7.299,
					7.172,
					7.121,
					7.549,
					{
						"y": 7.711,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_5.png"
};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in BC by Health Authority <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					6.936,
					7.154,
					7.36,
					7.55,
					7.586,
					8.133,
					8.084,
					8.788,
					9.313,
					8.564,
					8.217,
					8.764,
					8.683,
					8.734,
					8.539,
					9.354,
					9.681,
					9.216,
					8.669,
					{
						"y": 9.088,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.644,
					2.694,
					2.767,
					3.209,
					3.45,
					3.885,
					4.479,
					5.143,
					4.869,
					4.396,
					4.282,
					4.692,
					4.75,
					4.683,
					4.777,
					4.778,
					4.938,
					4.726,
					6.713,
					{
						"y": 12.223,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.496,
					1.463,
					1.509,
					1.908,
					1.64,
					1.614,
					1.617,
					1.884,
					1.696,
					1.543,
					1.519,
					1.857,
					1.826,
					1.718,
					1.683,
					1.909,
					2.085,
					1.842,
					1.789,
					{
						"y": 2.049,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					17.88,
					20.058,
					19.598,
					21.848,
					21.645,
					21.823,
					21.21,
					23.017,
					23.072,
					22.226,
					20.961,
					22.596,
					22.128,
					21.893,
					20.811,
					22.113,
					21.914,
					21.133,
					20.452,
					{
						"y": 21.712,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					2.272,
					2.39,
					2.436,
					2.908,
					3.034,
					3.249,
					3.3,
					3.514,
					3.662,
					3.397,
					3.215,
					3.452,
					3.188,
					3.325,
					3.379,
					3.66,
					3.552,
					3.722,
					3.816,
					{
						"y": 3.844,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_6.png"
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 1.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in BC by Health Authority <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					7.1,
					7.321,
					7.461,
					8.098,
					7.847,
					8.405,
					8.651,
					9.352,
					9.578,
					9.128,
					8.727,
					9.237,
					9.4,
					9.02,
					8.845,
					9.817,
					10.215,
					9.788,
					9.541,
					{
						"y": 9.921,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.765,
					2.695,
					2.866,
					3.188,
					3.4,
					3.766,
					4.38,
					5.091,
					4.815,
					4.378,
					4.276,
					4.886,
					4.698,
					4.474,
					4.68,
					4.955,
					5.047,
					4.63,
					6.577,
					{
						"y": 11.403,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.314,
					1.279,
					1.359,
					1.62,
					1.439,
					1.455,
					1.423,
					1.634,
					1.547,
					1.405,
					1.433,
					1.757,
					1.713,
					1.621,
					1.584,
					1.855,
					1.896,
					1.593,
					1.713,
					{
						"y": 1.851,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					18.304,
					20.399,
					19.835,
					21.746,
					21.416,
					21.892,
					21.693,
					24.109,
					23.334,
					22.681,
					22.298,
					23.926,
					23.387,
					22.862,
					22.115,
					24.874,
					24.365,
					23.768,
					23.29,
					{
						"y": 25.297,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					2.132,
					2.124,
					2.137,
					2.575,
					2.581,
					2.759,
					2.92,
					3.147,
					3.219,
					2.846,
					2.859,
					3.057,
					2.791,
					2.979,
					3.02,
					3.347,
					3.293,
					3.174,
					3.546,
					{
						"y": 3.649,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_7.png"
};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 2.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for BC and Health Authority <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2250.8488217733698,
					2267.0649481968244,
					2330.5767568597003,
					2786.5477336741924,
					3313.7770680248564,
					3590.969161713251,
					4009.2585552743635,
					4339.022468454596,
					4152.463519779481,
					{
						"y": 4254.170337321321,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2026.762017614979,
					2072.183206446978,
					2093.648480579677,
					2205.6385433185023,
					2646.222195140191,
					3069.4958253270333,
					4132.330705259747,
					4988.151563376388,
					4946.462424614734,
					{
						"y": 5425.757488282747,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 4,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2291.0420292392855,
					2350.023870770064,
					2434.29419245443,
					2928.107997198186,
					3347.791062942131,
					3850.106810998902,
					4501.1939316813705,
					4532.442575429123,
					4797.131169542297,
					{
						"y": 4979.8776647416125,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 8,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					4125.812037455745,
					4140.310731825397,
					4342.639850787271,
					5797.376213961661,
					8021.480793922817,
					10179.669338895044,
					11488.312989229491,
					11699.598737743832,
					11533.309047819079,
					{
						"y": 11567.565845512043,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					1927.4506495697653,
					1920.2260414069683,
					1850.9036506044338,
					1989.5021786173431,
					2166.8755083064225,
					2341.7245457731733,
					2945.755186284876,
					3227.0552880929745,
					3088.5801457424545,
					{
						"y": 3275.9594666879966,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All British Columbia",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2624.924643121841,
					2645.6563076308507,
					2714.0526220683555,
					3315.560599961727,
					4186.854218912476,
					4951.72455946051,
					5725.45758524668,
					6081.521622613479,
					5952.26232884106,
					{
						"y": 6111.481374387139,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All British Columbia</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_2_1.png"
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 2.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for BC <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 300,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2446.1131112185376,
					2454.2499285468157,
					2522.870795970444,
					3193.7779899937827,
					4162.790294777509,
					4926.527855773306,
					5755.410596138552,
					6064.579494983071,
					5888.53118264228,
					{
						"y": 5989.745787953848,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 12,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2695.0685416662864,
					2735.0116997897912,
					2809.1575478058403,
					3380.89648530172,
					4173.44061721416,
					4936.970237052936,
					5650.960704108458,
					6062.997471276072,
					5964.138452014982,
					{
						"y": 6119.137735435976,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_2_2.png"
};

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 2.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for BC <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 500,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2794.8289575333656,
					2801.966473303923,
					2854.0594136843974,
					3230.0061566537543,
					3680.4185358813525,
					4031.1438442029757,
					4517.246924851679,
					4781.7775571002985,
					4876.548142229325,
					{
						"y": 5184.145202516713,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					5089.611204367804,
					5225.505390778758,
					5251.685003343896,
					6049.774206401912,
					7153.4366249277855,
					8012.848839731774,
					8965.967859855904,
					9518.423910168854,
					9525.279791146342,
					{
						"y": 9813.029409822486,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					3027.894477877446,
					3025.4258902579527,
					3124.2495842140684,
					3827.7332372458936,
					4920.9251792286095,
					5684.642717621552,
					6506.4047593947225,
					6876.849590802683,
					6591.62311930661,
					{
						"y": 6678.695232141843,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1261.6052661487433,
					1304.401735895846,
					1422.5961124421553,
					2212.727133392991,
					3373.0825757509087,
					4511.744870549237,
					5484.892931788909,
					5851.571963666088,
					5493.114109352376,
					{
						"y": 5494.744219751712,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_2_3.png"
};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 3.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for BC <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "British Columbia",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					75,
					63,
					60,
					65,
					61,
					65,
					50,
					55,
					66,
					66,
					54,
					50,
					44,
					45,
					43,
					59,
					51,
					42,
					55,
					45
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					75,
					63,
					60,
					65,
					61,
					65,
					50,
					55,
					66,
					66,
					54,
					50,
					44,
					45,
					43,
					59,
					51,
					41,
					55,
					45
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_3_1.png"
};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 3.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for BC by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					9,
					13,
					9,
					10,
					4,
					12,
					11,
					9,
					11,
					11,
					6,
					2,
					6,
					2,
					5,
					8,
					11,
					12,
					10,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					65,
					50,
					51,
					55,
					57,
					53,
					39,
					46,
					55,
					55,
					48,
					48,
					38,
					43,
					36,
					51,
					40,
					30,
					44,
					{
						"y": 42,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_3_2.png"
};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 3.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for BC by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					15,
					13,
					18,
					14,
					14,
					21,
					13,
					19,
					14,
					19,
					17,
					21,
					15,
					17,
					13,
					19,
					11,
					10,
					20,
					{
						"y": 17,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					21,
					25,
					15,
					15,
					17,
					17,
					9,
					18,
					13,
					21,
					20,
					17,
					10,
					14,
					12,
					16,
					10,
					15,
					16,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					14,
					7,
					13,
					11,
					19,
					10,
					11,
					11,
					12,
					8,
					8,
					5,
					11,
					9,
					8,
					18,
					16,
					9,
					10,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					25,
					18,
					14,
					25,
					11,
					17,
					17,
					7,
					27,
					18,
					9,
					7,
					8,
					5,
					10,
					6,
					13,
					8,
					9,
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_3_3.png"
};

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 3.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for BC by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					38,
					36,
					46,
					34,
					37,
					38,
					38,
					36,
					26,
					34,
					39,
					41,
					32,
					38,
					26,
					32,
					31,
					36,
					18,
					{
						"y": 18,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					9,
					10,
					5,
					3,
					8,
					4,
					4,
					6,
					3,
					3,
					2,
					3,
					8,
					3,
					5,
					4,
					6,
					4,
					5,
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					8,
					16,
					19,
					20,
					10,
					18,
					15,
					19,
					17,
					15,
					18,
					16,
					10,
					6,
					10,
					7,
					5,
					13,
					10,
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					1,
					4,
					2,
					3,
					0,
					2,
					0,
					1,
					2,
					3,
					1,
					1,
					0,
					1,
					0,
					0,
					3,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					2,
					1,
					4,
					2,
					3,
					2,
					4,
					2,
					4,
					2,
					5,
					3,
					3,
					2,
					3,
					1,
					1,
					6,
					15,
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -5,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_3_4.png"
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 3.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for BC by Health Authority <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					11,
					16,
					17,
					18,
					17,
					15,
					13,
					19,
					18,
					17,
					13,
					12,
					9,
					9,
					11,
					13,
					16,
					13,
					20,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					4,
					4,
					6,
					5,
					1,
					7,
					6,
					6,
					2,
					4,
					2,
					2,
					2,
					0,
					3,
					2,
					6,
					1,
					4,
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					5,
					4,
					2,
					1,
					2,
					2,
					1,
					2,
					4,
					4,
					2,
					1,
					0,
					0,
					1,
					3,
					1,
					2,
					1,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"index": 30,
				"data": [
					49,
					32,
					27,
					38,
					34,
					33,
					24,
					21,
					32,
					36,
					29,
					27,
					24,
					26,
					18,
					31,
					16,
					19,
					24,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"index": 40,
				"data": [
					4,
					7,
					8,
					3,
					7,
					8,
					6,
					7,
					10,
					4,
					8,
					8,
					9,
					9,
					10,
					10,
					12,
					5,
					6,
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					10,
					12,
					13,
					11,
					11,
					15,
					15,
					17,
					15,
					12,
					12,
					8,
					9,
					8,
					11,
					7,
					10,
					10,
					9,
					8
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					2,
					4,
					5,
					5,
					1,
					7,
					6,
					6,
					2,
					3,
					2,
					2,
					2,
					0,
					2,
					3,
					5,
					1,
					4,
					6
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					5,
					3,
					2,
					1,
					2,
					2,
					1,
					3,
					4,
					4,
					2,
					1,
					1,
					0,
					1,
					2,
					2,
					2,
					1,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "ShortDash",
				"index": 31,
				"data": [
					54,
					36,
					32,
					45,
					40,
					35,
					23,
					22,
					36,
					44,
					31,
					33,
					24,
					27,
					19,
					37,
					22,
					23,
					34,
					19
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "ShortDash",
				"index": 41,
				"data": [
					4,
					8,
					8,
					3,
					7,
					6,
					5,
					7,
					9,
					3,
					7,
					6,
					8,
					10,
					10,
					10,
					12,
					5,
					7,
					10
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_3_5.png"
};

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 4.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for BC <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 49,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					64,
					52,
					63,
					53
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 58,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					55,
					50,
					46,
					37
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 45,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					33,
					21,
					28,
					12
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 37,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					30,
					36,
					25,
					18
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 65,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					44,
					51,
					40,
					27
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"British Columbia"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						49,
						64,
						52,
						63,
						53
					]
				},
				{
					"name": "Stage 1",
					"data": [
						58,
						55,
						50,
						46,
						37
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						45,
						33,
						21,
						28,
						12
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						37,
						30,
						36,
						25,
						18
					]
				},
				{
					"name": "Stage 3",
					"data": [
						65,
						44,
						51,
						40,
						27
					]
				},
				{
					"name": "Unknown",
					"data": [
						11,
						35,
						31,
						39,
						35
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						265,
						261,
						241,
						241,
						182
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_4_1.png"
};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 4.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for BC <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					5,
					9,
					8,
					5,
					{
						"y": 1,
						"color": "white"
					},
					46,
					59,
					43,
					55,
					47
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					13,
					8,
					10,
					4,
					{
						"y": 1,
						"color": "white"
					},
					49,
					42,
					42,
					36,
					33
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					4,
					2,
					null,
					2,
					{
						"y": 1,
						"color": "white"
					},
					39,
					29,
					19,
					28,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					5,
					7,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					31,
					23,
					28,
					24,
					17
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					10,
					7,
					9,
					null,
					{
						"y": 1,
						"color": "white"
					},
					58,
					34,
					44,
					30,
					27
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						2,
						5,
						9,
						8,
						5,
						46,
						59,
						43,
						55,
						47
					]
				},
				{
					"name": "Stage 1",
					"data": [
						9,
						13,
						8,
						10,
						4,
						49,
						42,
						42,
						36,
						33
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						6,
						4,
						2,
						0,
						2,
						39,
						29,
						19,
						28,
						10
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						6,
						5,
						7,
						1,
						1,
						31,
						23,
						28,
						24,
						17
					]
				},
				{
					"name": "Stage 3",
					"data": [
						7,
						10,
						7,
						9,
						0,
						58,
						34,
						44,
						30,
						27
					]
				},
				{
					"name": "Unknown",
					"data": [
						1,
						8,
						5,
						9,
						3,
						10,
						27,
						25,
						30,
						31
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						31,
						45,
						38,
						37,
						15,
						233,
						214,
						201,
						203,
						165
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_4_2.png"
};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 4.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for BC <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 20,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					28,
					14,
					25,
					27,
					{
						"y": 1,
						"color": "white"
					},
					14,
					17,
					16,
					20,
					14,
					{
						"y": 1,
						"color": "white"
					},
					10,
					8,
					6,
					8,
					6,
					{
						"y": 1,
						"color": "white"
					},
					5,
					11,
					16,
					10,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 23,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					12,
					22,
					11,
					10,
					{
						"y": 1,
						"color": "white"
					},
					17,
					18,
					10,
					17,
					13,
					{
						"y": 1,
						"color": "white"
					},
					8,
					10,
					7,
					8,
					11,
					{
						"y": 1,
						"color": "white"
					},
					10,
					15,
					11,
					10,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					5,
					7,
					10,
					5,
					{
						"y": 1,
						"color": "white"
					},
					14,
					7,
					3,
					10,
					3,
					{
						"y": 1,
						"color": "white"
					},
					9,
					8,
					5,
					3,
					2,
					{
						"y": 1,
						"color": "white"
					},
					11,
					13,
					6,
					5,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					3,
					6,
					4,
					8,
					{
						"y": 1,
						"color": "white"
					},
					13,
					10,
					11,
					8,
					3,
					{
						"y": 1,
						"color": "white"
					},
					10,
					7,
					9,
					7,
					4,
					{
						"y": 1,
						"color": "white"
					},
					10,
					10,
					10,
					6,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					4,
					5,
					3,
					3,
					{
						"y": 1,
						"color": "white"
					},
					10,
					11,
					8,
					9,
					7,
					{
						"y": 1,
						"color": "white"
					},
					24,
					13,
					13,
					9,
					6,
					{
						"y": 1,
						"color": "white"
					},
					27,
					16,
					25,
					19,
					11
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						20,
						28,
						14,
						25,
						27,
						14,
						17,
						16,
						20,
						14,
						10,
						8,
						6,
						8,
						6,
						5,
						11,
						16,
						10,
						6
					]
				},
				{
					"name": "Stage 1",
					"data": [
						23,
						12,
						22,
						11,
						10,
						17,
						18,
						10,
						17,
						13,
						8,
						10,
						7,
						8,
						11,
						10,
						15,
						11,
						10,
						3
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						11,
						5,
						7,
						10,
						5,
						14,
						7,
						3,
						10,
						3,
						9,
						8,
						5,
						3,
						2,
						11,
						13,
						6,
						5,
						2
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						4,
						3,
						6,
						4,
						8,
						13,
						10,
						11,
						8,
						3,
						10,
						7,
						9,
						7,
						4,
						10,
						10,
						10,
						6,
						3
					]
				},
				{
					"name": "Stage 3",
					"data": [
						4,
						4,
						5,
						3,
						3,
						10,
						11,
						8,
						9,
						7,
						24,
						13,
						13,
						9,
						6,
						27,
						16,
						25,
						19,
						11
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						7,
						4,
						11,
						9,
						2,
						14,
						12,
						11,
						12,
						3,
						7,
						10,
						5,
						8,
						6,
						7,
						5,
						12,
						6
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						62,
						59,
						58,
						64,
						62,
						70,
						77,
						60,
						75,
						52,
						64,
						53,
						50,
						40,
						37,
						69,
						72,
						73,
						62,
						31
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_4_3.png"
};

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 4.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for BC <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 37,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					54,
					35,
					49,
					39,
					{
						"y": 1,
						"color": "white"
					},
					6,
					4,
					4,
					8,
					7,
					{
						"y": 1,
						"color": "white"
					},
					4,
					4,
					13,
					3,
					5
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 36,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					31,
					36,
					31,
					25,
					{
						"y": 1,
						"color": "white"
					},
					6,
					10,
					1,
					5,
					4,
					{
						"y": 1,
						"color": "white"
					},
					13,
					13,
					10,
					7,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 29,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					19,
					14,
					18,
					7,
					{
						"y": 1,
						"color": "white"
					},
					6,
					1,
					1,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					7,
					10,
					4,
					6,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 24,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					14,
					21,
					17,
					13,
					{
						"y": 1,
						"color": "white"
					},
					1,
					4,
					4,
					null,
					3,
					{
						"y": 1,
						"color": "white"
					},
					9,
					10,
					9,
					7,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 24,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					16,
					17,
					14,
					19,
					{
						"y": 1,
						"color": "white"
					},
					5,
					4,
					5,
					2,
					1,
					{
						"y": 1,
						"color": "white"
					},
					30,
					18,
					24,
					20,
					6
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						37,
						54,
						35,
						49,
						39,
						6,
						4,
						4,
						8,
						7,
						4,
						4,
						13,
						3,
						5,
						1,
						1,
						0,
						2,
						1,
						1,
						1,
						0,
						1,
						1
					]
				},
				{
					"name": "Stage 1",
					"data": [
						36,
						31,
						36,
						31,
						25,
						6,
						10,
						1,
						5,
						4,
						13,
						13,
						10,
						7,
						6,
						1,
						1,
						1,
						2,
						0,
						2,
						0,
						2,
						1,
						2
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						29,
						19,
						14,
						18,
						7,
						6,
						1,
						1,
						0,
						1,
						7,
						10,
						4,
						6,
						3,
						2,
						0,
						1,
						2,
						0,
						1,
						3,
						1,
						2,
						1
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						24,
						14,
						21,
						17,
						13,
						1,
						4,
						4,
						0,
						3,
						9,
						10,
						9,
						7,
						2,
						1,
						1,
						1,
						0,
						0,
						2,
						1,
						1,
						1,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						24,
						16,
						17,
						14,
						19,
						5,
						4,
						5,
						2,
						1,
						30,
						18,
						24,
						20,
						6,
						1,
						3,
						1,
						1,
						0,
						5,
						3,
						4,
						3,
						1
					]
				},
				{
					"name": "Unknown",
					"data": [
						4,
						19,
						15,
						17,
						24,
						1,
						3,
						2,
						1,
						2,
						5,
						10,
						9,
						16,
						6,
						1,
						1,
						1,
						0,
						1,
						0,
						2,
						4,
						5,
						2
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						154,
						153,
						138,
						146,
						127,
						25,
						26,
						17,
						16,
						18,
						68,
						65,
						69,
						59,
						28,
						7,
						7,
						5,
						7,
						2,
						11,
						10,
						12,
						13,
						7
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_4_4.png"
};

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for BC, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 91.4132721361637,
						"dataLabels": {
							"enabled": true,
							"format": "9560"
						}
					},
					{
						"y": 76.56339644291451,
						"dataLabels": {
							"enabled": true,
							"format": "8007"
						}
					},
					{
						"y": 72.32740485752534,
						"dataLabels": {
							"enabled": true,
							"format": "7564"
						}
					},
					{
						"y": 66.75272518646013,
						"dataLabels": {
							"enabled": true,
							"format": "6981"
						}
					},
					{
						"y": 56.25358577165807,
						"dataLabels": {
							"enabled": true,
							"format": "5883"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -8.586727863836296,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.244769874476983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.532658923441991,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.707562136435753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.728405672539747,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=10458"
			}
		],
		"dataTable": {
			"Overall HA": [
				10458,
				9560,
				8007,
				7564,
				6981,
				5883
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_1.png"
};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for BC by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.07771056305259,
						"dataLabels": {
							"enabled": true,
							"format": "7915",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.1172638436482,
						"dataLabels": {
							"enabled": true,
							"format": "6629",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.0456026058632,
						"dataLabels": {
							"enabled": true,
							"format": "6279",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.33410888785481,
						"dataLabels": {
							"enabled": true,
							"format": "5874",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.42252210330386,
						"dataLabels": {
							"enabled": true,
							"format": "5022",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 88.34586466165413,
						"dataLabels": {
							"enabled": true,
							"format": "1645",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.00644468313641,
						"dataLabels": {
							"enabled": true,
							"format": "1378",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.01181525241675,
						"dataLabels": {
							"enabled": true,
							"format": "1285",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.452201933404936,
						"dataLabels": {
							"enabled": true,
							"format": "1107",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.2406015037594,
						"dataLabels": {
							"enabled": true,
							"format": "861",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.922289436947416,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.24763108022742,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.279831045406547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.450071667462975,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.504596527068436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -11.654135338345862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.23100303951368,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.7489114658925935,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.852140077821007,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=8596"
			},
			{
				"x": 9,
				"text": "Women<br>n=1862"
			}
		],
		"dataTable": {
			"Men": [
				8596,
				7915,
				6629,
				6279,
				5874,
				5022
			],
			"Women": [
				1862,
				1645,
				1378,
				1285,
				1107,
				861
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_2.png"
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.5370741482966,
						"dataLabels": {
							"enabled": true,
							"format": "342",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.31663326653307,
						"dataLabels": {
							"enabled": true,
							"format": "291",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.10821643286573,
						"dataLabels": {
							"enabled": true,
							"format": "270",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 44.68937875751503,
						"dataLabels": {
							"enabled": true,
							"format": "223",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 37.27454909819639,
						"dataLabels": {
							"enabled": true,
							"format": "186",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 91.93916349809886,
						"dataLabels": {
							"enabled": true,
							"format": "1209",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.6425855513308,
						"dataLabels": {
							"enabled": true,
							"format": "1021",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.00380228136882,
						"dataLabels": {
							"enabled": true,
							"format": "960",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.57414448669202,
						"dataLabels": {
							"enabled": true,
							"format": "836",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.22053231939164,
						"dataLabels": {
							"enabled": true,
							"format": "713",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.22367846221057,
						"dataLabels": {
							"enabled": true,
							"format": "2111",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.19528178243775,
						"dataLabels": {
							"enabled": true,
							"format": "1767",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.47706422018348,
						"dataLabels": {
							"enabled": true,
							"format": "1659",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.5744866754041,
						"dataLabels": {
							"enabled": true,
							"format": "1501",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.16732197466142,
						"dataLabels": {
							"enabled": true,
							"format": "1217",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.91115311909263,
						"dataLabels": {
							"enabled": true,
							"format": "5898",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.63074984247007,
						"dataLabels": {
							"enabled": true,
							"format": "4928",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.64524259609325,
						"dataLabels": {
							"enabled": true,
							"format": "4675",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.64398235664775,
						"dataLabels": {
							"enabled": true,
							"format": "4421",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.341524889729044,
						"dataLabels": {
							"enabled": true,
							"format": "3767",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.462925851703403,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.912280701754387,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.216494845360821,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.407407407407405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.59192825112108,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -8.060836501901136,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.550041356492972,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.974534769833495,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.916666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.712918660287077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.776321537789432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.29559450497394,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.112054329371819,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.920719520319786,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.088846880907374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.44625296710749,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.133928571428569,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.433155080213902,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.793033250395837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=499"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1315"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2289"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6348"
			}
		],
		"dataTable": {
			"< 30": [
				499,
				342,
				291,
				270,
				223,
				186
			],
			"30–39": [
				1315,
				1209,
				1021,
				960,
				836,
				713
			],
			"40–49": [
				2289,
				2111,
				1767,
				1659,
				1501,
				1217
			],
			"≥ 50": [
				6348,
				5898,
				4928,
				4675,
				4421,
				3767
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.4,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.14823782620392,
						"dataLabels": {
							"enabled": true,
							"format": "3611"
						}
					},
					{
						"y": 88.29701372074254,
						"dataLabels": {
							"enabled": true,
							"format": "3282"
						}
					},
					{
						"y": 84.36911487758945,
						"dataLabels": {
							"enabled": true,
							"format": "3136"
						}
					},
					{
						"y": 79.74172719935432,
						"dataLabels": {
							"enabled": true,
							"format": "2964"
						}
					},
					{
						"y": 70.16411084207694,
						"dataLabels": {
							"enabled": true,
							"format": "2608"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.90467815687653,
						"dataLabels": {
							"enabled": true,
							"format": "2755"
						}
					},
					{
						"y": 88.53323953570172,
						"dataLabels": {
							"enabled": true,
							"format": "2517"
						}
					},
					{
						"y": 83.2219486457967,
						"dataLabels": {
							"enabled": true,
							"format": "2366"
						}
					},
					{
						"y": 73.97115722827998,
						"dataLabels": {
							"enabled": true,
							"format": "2103"
						}
					},
					{
						"y": 57.580021104467114,
						"dataLabels": {
							"enabled": true,
							"format": "1637"
						}
					},
					{
						"y": null
					},
					{
						"y": 81.9394561313494,
						"dataLabels": {
							"enabled": true,
							"format": "3194"
						}
					},
					{
						"y": 56.64443304258594,
						"dataLabels": {
							"enabled": true,
							"format": "2208"
						}
					},
					{
						"y": 52.89892252437147,
						"dataLabels": {
							"enabled": true,
							"format": "2062"
						}
					},
					{
						"y": 49.10210364289379,
						"dataLabels": {
							"enabled": true,
							"format": "1914"
						}
					},
					{
						"y": 42.02154951257055,
						"dataLabels": {
							"enabled": true,
							"format": "1638"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.8517621737960686,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.111049570756025,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.448507007921998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.484693877551017,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.01079622132254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0953218431234664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.638838475499089,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.999205403257846,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.115807269653422,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.15882073228721,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -18.06054386865059,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.8703819661866,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.612318840579712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.177497575169733,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.420062695924763,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=3717"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=2843"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3898"
			}
		],
		"dataTable": {
			"MSM": [
				3717,
				3611,
				3282,
				3136,
				2964,
				2608
			],
			"Non-MSM": [
				2843,
				2755,
				2517,
				2366,
				2103,
				1637
			],
			"Unknown": [
				3898,
				3194,
				2208,
				2062,
				1914,
				1638
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_4.png"
};

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 91.92546583850931,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#043f61"
					},
					{
						"y": 83.22981366459628,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.88198757763976,
						"dataLabels": {
							"enabled": false,
							"format": "127"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.08074534161491,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#09472e"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "92"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.6969696969697,
						"dataLabels": {
							"enabled": false,
							"format": "500"
						},
						"color": "#043f61"
					},
					{
						"y": 80.3030303030303,
						"dataLabels": {
							"enabled": false,
							"format": "424"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.70454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "405"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.07575757575758,
						"dataLabels": {
							"enabled": false,
							"format": "370"
						},
						"color": "#09472e"
					},
					{
						"y": 62.689393939393945,
						"dataLabels": {
							"enabled": false,
							"format": "331"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.41185647425897,
						"dataLabels": {
							"enabled": false,
							"format": "618"
						},
						"color": "#043f61"
					},
					{
						"y": 87.05148205928236,
						"dataLabels": {
							"enabled": false,
							"format": "558"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.52730109204369,
						"dataLabels": {
							"enabled": false,
							"format": "529"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.53510140405616,
						"dataLabels": {
							"enabled": false,
							"format": "497"
						},
						"color": "#09472e"
					},
					{
						"y": 66.45865834633385,
						"dataLabels": {
							"enabled": false,
							"format": "426"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.24046920821115,
						"dataLabels": {
							"enabled": false,
							"format": "2345"
						},
						"color": "#043f61"
					},
					{
						"y": 90.74151654796816,
						"dataLabels": {
							"enabled": false,
							"format": "2166"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.92919983242564,
						"dataLabels": {
							"enabled": false,
							"format": "2075"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.32635106828656,
						"dataLabels": {
							"enabled": false,
							"format": "1989"
						},
						"color": "#09472e"
					},
					{
						"y": 73.69082530372853,
						"dataLabels": {
							"enabled": false,
							"format": "1759"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 96.92307692307692,
						"dataLabels": {
							"enabled": false,
							"format": "63"
						},
						"color": "#043f61"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "55"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.84615384615385,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#0d4440"
					},
					{
						"y": 55.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#09472e"
					},
					{
						"y": 49.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.89905362776025,
						"dataLabels": {
							"enabled": false,
							"format": "304"
						},
						"color": "#043f61"
					},
					{
						"y": 90.53627760252367,
						"dataLabels": {
							"enabled": false,
							"format": "287"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.2807570977918,
						"dataLabels": {
							"enabled": false,
							"format": "264"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.93059936908517,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#09472e"
					},
					{
						"y": 50.1577287066246,
						"dataLabels": {
							"enabled": false,
							"format": "159"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.8,
						"dataLabels": {
							"enabled": false,
							"format": "726"
						},
						"color": "#043f61"
					},
					{
						"y": 87.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "655"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.13333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "616"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.39999999999999,
						"dataLabels": {
							"enabled": false,
							"format": "528"
						},
						"color": "#09472e"
					},
					{
						"y": 51.733333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "388"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.19298245614036,
						"dataLabels": {
							"enabled": false,
							"format": "1662"
						},
						"color": "#043f61"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "1520"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.09356725146199,
						"dataLabels": {
							"enabled": false,
							"format": "1438"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "1330"
						},
						"color": "#09472e"
					},
					{
						"y": 61.87134502923976,
						"dataLabels": {
							"enabled": false,
							"format": "1058"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 47.985347985347985,
						"dataLabels": {
							"enabled": false,
							"format": "131"
						},
						"color": "#043f61"
					},
					{
						"y": 37.362637362637365,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#0c4250"
					},
					{
						"y": 34.798534798534796,
						"dataLabels": {
							"enabled": false,
							"format": "95"
						},
						"color": "#0d4440"
					},
					{
						"y": 28.93772893772894,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#09472e"
					},
					{
						"y": 22.71062271062271,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.95744680851064,
						"dataLabels": {
							"enabled": false,
							"format": "404"
						},
						"color": "#043f61"
					},
					{
						"y": 65.95744680851064,
						"dataLabels": {
							"enabled": false,
							"format": "310"
						},
						"color": "#0c4250"
					},
					{
						"y": 61.91489361702127,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0d4440"
					},
					{
						"y": 54.680851063829785,
						"dataLabels": {
							"enabled": false,
							"format": "257"
						},
						"color": "#09472e"
					},
					{
						"y": 47.4468085106383,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.5072463768116,
						"dataLabels": {
							"enabled": false,
							"format": "767"
						},
						"color": "#043f61"
					},
					{
						"y": 61.76142697881828,
						"dataLabels": {
							"enabled": false,
							"format": "554"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.30211817168339,
						"dataLabels": {
							"enabled": false,
							"format": "514"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.06577480490524,
						"dataLabels": {
							"enabled": false,
							"format": "476"
						},
						"color": "#09472e"
					},
					{
						"y": 44.927536231884055,
						"dataLabels": {
							"enabled": false,
							"format": "403"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 84.04444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "1891"
						},
						"color": "#043f61"
					},
					{
						"y": 55.2,
						"dataLabels": {
							"enabled": false,
							"format": "1242"
						},
						"color": "#0c4250"
					},
					{
						"y": 51.644444444444446,
						"dataLabels": {
							"enabled": false,
							"format": "1162"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.977777777777774,
						"dataLabels": {
							"enabled": false,
							"format": "1102"
						},
						"color": "#09472e"
					},
					{
						"y": 42.22222222222222,
						"dataLabels": {
							"enabled": false,
							"format": "950"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -8.074534161490687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.459459459459463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.223880597014929,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.960629921259837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.303030303030298,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.200000000000003,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.481132075471694,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.64197530864198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.540540540540544,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5881435257410277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.708737864077666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.197132616487455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.049149338374294,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.7595307917888547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.6332622601279265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.201292705447834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.144578313253011,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.56359979889392,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -3.076923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.698412698412698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.727272727272732,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.100946372239744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.592105263157898,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.013937282229966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.833333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.923444976076556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.200000000000003,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.779614325068875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.954198473282446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.515151515151516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.8070175438596467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.5439229843562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.394736842105264,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.510431154381081,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.451127819548876,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -52.01465201465201,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.137404580152676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.8627450980392135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.84210526315789,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.518987341772156,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.04255319148936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.267326732673265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.129032258064515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.683848797250862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.229571984435795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.492753623188403,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77053455019557,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.220216606498198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.392996108949412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.336134453781513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -15.955555555555556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.3204653622422,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.441223832528175,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.163511187607572,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.793103448275868,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=161"
			},
			{
				"x": 9,
				"text": "30-39<br>n=528"
			},
			{
				"x": 15,
				"text": "40-49<br>n=641"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2387"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=65"
			},
			{
				"x": 34,
				"text": "30-39<br>n=317"
			},
			{
				"x": 40,
				"text": "40-49<br>n=750"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1710"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=273"
			},
			{
				"x": 59,
				"text": "30-39<br>n=470"
			},
			{
				"x": 65,
				"text": "40-49<br>n=897"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2250"
			}
		],
		"dataTable": {
			"MSM:<30": [
				161,
				148,
				134,
				127,
				108,
				92
			],
			"MSM:30-39": [
				528,
				500,
				424,
				405,
				370,
				331
			],
			"MSM:40-49": [
				641,
				618,
				558,
				529,
				497,
				426
			],
			"MSM:>=50": [
				2387,
				2345,
				2166,
				2075,
				1989,
				1759
			],
			"Non-MSM:<30": [
				65,
				63,
				55,
				48,
				36,
				32
			],
			"Non-MSM:30-39": [
				317,
				304,
				287,
				264,
				209,
				159
			],
			"Non-MSM:40-49": [
				750,
				726,
				655,
				616,
				528,
				388
			],
			"Non-MSM:>=50": [
				1710,
				1662,
				1520,
				1438,
				1330,
				1058
			],
			"Unknown:<30": [
				273,
				131,
				102,
				95,
				79,
				62
			],
			"Unknown:30-39": [
				470,
				404,
				310,
				291,
				257,
				223
			],
			"Unknown:40-49": [
				897,
				767,
				554,
				514,
				476,
				403
			],
			"Unknown:>=50": [
				2250,
				1891,
				1242,
				1162,
				1102,
				950
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.875,
						"dataLabels": {
							"enabled": true,
							"format": "2325"
						}
					},
					{
						"y": 88.41666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "2122"
						}
					},
					{
						"y": 83.125,
						"dataLabels": {
							"enabled": true,
							"format": "1995"
						}
					},
					{
						"y": 73.70833333333333,
						"dataLabels": {
							"enabled": true,
							"format": "1769"
						}
					},
					{
						"y": 56.375,
						"dataLabels": {
							"enabled": true,
							"format": "1353"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.3145016908693,
						"dataLabels": {
							"enabled": true,
							"format": "4892"
						}
					},
					{
						"y": 88.74079968171871,
						"dataLabels": {
							"enabled": true,
							"format": "4461"
						}
					},
					{
						"y": 84.80206882832704,
						"dataLabels": {
							"enabled": true,
							"format": "4263"
						}
					},
					{
						"y": 79.72946091108017,
						"dataLabels": {
							"enabled": true,
							"format": "4008"
						}
					},
					{
						"y": 69.42510443604536,
						"dataLabels": {
							"enabled": true,
							"format": "3490"
						}
					},
					{
						"y": null
					},
					{
						"y": 77.27572559366754,
						"dataLabels": {
							"enabled": true,
							"format": "2343"
						}
					},
					{
						"y": 46.965699208443276,
						"dataLabels": {
							"enabled": true,
							"format": "1424"
						}
					},
					{
						"y": 43.073878627968334,
						"dataLabels": {
							"enabled": true,
							"format": "1306"
						}
					},
					{
						"y": 39.70976253298153,
						"dataLabels": {
							"enabled": true,
							"format": "1204"
						}
					},
					{
						"y": 34.300791556728235,
						"dataLabels": {
							"enabled": true,
							"format": "1040"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.731182795698922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.984919886899154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.32832080200501,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.516110797060485,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.685498309130696,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.810302534750614,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.438466711499666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.981703026037999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.924151696606788,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -22.724274406332455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.223218096457536,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.286516853932579,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.810107197549765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.621262458471762,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=2400"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=5027"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3032"
			}
		],
		"dataTable": {
			"IDU": [
				2400,
				2325,
				2122,
				1995,
				1769,
				1353
			],
			"Non-IDU": [
				5027,
				4892,
				4461,
				4263,
				4008,
				3490
			],
			"Unknown": [
				3032,
				2343,
				1424,
				1306,
				1204,
				1040
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_6.png"
};

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -145,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.29256489221294,
						"dataLabels": {
							"enabled": true,
							"format": "2166"
						}
					},
					{
						"y": 86.09766827980643,
						"dataLabels": {
							"enabled": true,
							"format": "1957"
						}
					},
					{
						"y": 82.71007479102508,
						"dataLabels": {
							"enabled": true,
							"format": "1880"
						}
					},
					{
						"y": 76.46282446106467,
						"dataLabels": {
							"enabled": true,
							"format": "1738"
						}
					},
					{
						"y": 65.55213374395072,
						"dataLabels": {
							"enabled": true,
							"format": "1490"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.94594594594594,
						"dataLabels": {
							"enabled": true,
							"format": "639"
						}
					},
					{
						"y": 81.38138138138137,
						"dataLabels": {
							"enabled": true,
							"format": "542"
						}
					},
					{
						"y": 78.37837837837837,
						"dataLabels": {
							"enabled": true,
							"format": "522"
						}
					},
					{
						"y": 71.47147147147147,
						"dataLabels": {
							"enabled": true,
							"format": "476"
						}
					},
					{
						"y": 53.153153153153156,
						"dataLabels": {
							"enabled": true,
							"format": "354"
						}
					},
					{
						"y": null
					},
					{
						"y": 91.18644067796609,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": 78.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "232"
						}
					},
					{
						"y": 75.9322033898305,
						"dataLabels": {
							"enabled": true,
							"format": "224"
						}
					},
					{
						"y": 63.05084745762712,
						"dataLabels": {
							"enabled": true,
							"format": "186"
						}
					},
					{
						"y": 38.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "114"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.70284661069016,
						"dataLabels": {
							"enabled": true,
							"format": "4722"
						}
					},
					{
						"y": 85.31640385009216,
						"dataLabels": {
							"enabled": true,
							"format": "4166"
						}
					},
					{
						"y": 81.93733360638952,
						"dataLabels": {
							"enabled": true,
							"format": "4001"
						}
					},
					{
						"y": 76.26459143968872,
						"dataLabels": {
							"enabled": true,
							"format": "3724"
						}
					},
					{
						"y": 66.63936104853573,
						"dataLabels": {
							"enabled": true,
							"format": "3254"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.08050089445437,
						"dataLabels": {
							"enabled": true,
							"format": "1063"
						}
					},
					{
						"y": 86.8515205724508,
						"dataLabels": {
							"enabled": true,
							"format": "971"
						}
					},
					{
						"y": 83.54203935599284,
						"dataLabels": {
							"enabled": true,
							"format": "934"
						}
					},
					{
						"y": 76.47584973166369,
						"dataLabels": {
							"enabled": true,
							"format": "855"
						}
					},
					{
						"y": 59.83899821109123,
						"dataLabels": {
							"enabled": true,
							"format": "669"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.707435107787061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.649122807017541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9345937659683194,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5531914893617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.269275028768702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.054054054054057,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.179968701095458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.690036900369009,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.812260536398464,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.630252100840334,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.813559322033903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.754646840148698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.964285714285708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.70967741935484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.297153389309848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.774671749258792,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9606337013922244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.923269182704328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.620837808807739,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.919499105545622,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.65475070555033,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.810504634397527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.458244111349034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.75438596491228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2273"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=666"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=295"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4883"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1118"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2273,
				2166,
				1957,
				1880,
				1738,
				1490
			],
			"Interior Health": [
				666,
				639,
				542,
				522,
				476,
				354
			],
			"Northern Health": [
				295,
				269,
				232,
				224,
				186,
				114
			],
			"Vancouver Coastal Health": [
				4883,
				4722,
				4166,
				4001,
				3724,
				3254
			],
			"Vancouver Island Health": [
				1118,
				1063,
				971,
				934,
				855,
				669
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 6.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					22.35772357723577,
					17.490494296577946,
					16.728624535315987,
					15.827338129496402,
					16.117216117216117,
					20.74688796680498,
					20.5607476635514,
					{
						"y": 22.48803827751196,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					11.788617886178862,
					8.365019011406844,
					7.806691449814126,
					7.194244604316546,
					6.593406593406594,
					9.54356846473029,
					9.345794392523365,
					{
						"y": 9.569377990430622,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					6.504065040650407,
					6.844106463878327,
					6.691449814126393,
					6.83453237410072,
					6.593406593406594,
					6.224066390041494,
					8.411214953271028,
					{
						"y": 8.61244019138756,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					25.609756097560975,
					26.996197718631176,
					26.765799256505574,
					26.978417266187048,
					24.54212454212454,
					23.236514522821576,
					22.897196261682243,
					{
						"y": 18.660287081339714,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					15.447154471544716,
					17.490494296577946,
					15.613382899628252,
					16.18705035971223,
					15.75091575091575,
					15.767634854771783,
					19.626168224299064,
					{
						"y": 19.617224880382775,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					23.577235772357724,
					22.433460076045627,
					21.933085501858738,
					21.223021582733814,
					22.344322344322347,
					25.72614107883817,
					26.168224299065418,
					{
						"y": 26.31578947368421,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					246,
					263,
					269,
					278,
					273,
					241,
					214,
					{
						"y": 209,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_6_1.png"
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 6.2,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 97,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					101,
					107,
					108,
					107,
					86,
					68,
					67
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 79,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					98,
					98,
					107,
					106,
					94,
					89,
					89
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 43,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					40,
					43,
					43,
					43,
					41,
					38,
					35
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					14,
					12,
					11,
					9,
					12,
					12,
					12
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					10,
					9,
					9,
					8,
					8,
					7,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 246,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					263,
					269,
					278,
					273,
					241,
					214,
					209
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_6_2.png"
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 20,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					66,
					55,
					43,
					60,
					43,
					57,
					47,
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					136,
					117,
					128,
					123,
					130,
					144,
					165,
					{
						"y": 160,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_7.png"
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "bc",
	"id": 8,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in BC, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 22,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					22,
					16,
					23,
					14,
					19,
					22,
					16
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					7,
					8,
					15,
					8,
					11,
					7,
					12
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					9,
					9,
					8,
					11,
					11,
					9,
					9
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					8,
					5,
					6,
					5,
					9,
					4,
					7
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					3,
					4,
					6,
					3,
					4,
					3,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 370,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					480,
					420,
					440,
					{
						"y": 410,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					420,
					485,
					410
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 64,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					49,
					42,
					58,
					41,
					54,
					45,
					47
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_bc_8.png"
};

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 10,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 20,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					30,
					18,
					19,
					16,
					11,
					20,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					4,
					3,
					6,
					2,
					4,
					5,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": -10,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					1,
					1,
					0,
					3,
					2,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					1,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 25,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					36,
					22,
					25,
					21,
					17,
					25,
					13
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_10.png"
};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 11,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 1315,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					1239,
					1217,
					1296,
					1295,
					1263,
					1231,
					1293
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 134,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					151,
					157,
					132,
					140,
					133,
					139,
					149
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					8,
					10,
					10,
					5,
					5,
					9,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 22,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					26,
					24,
					17,
					24,
					26,
					22,
					19
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					3,
					3,
					3,
					2,
					4,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					2,
					1,
					0,
					0,
					1,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 1480,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					1429,
					1412,
					1458,
					1466,
					1432,
					1404,
					1473
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_11.png"
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 12,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Fraser Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					29,
					24,
					18,
					14,
					17,
					24,
					{
						"y": 18,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					1.8,
					1.5,
					1.1,
					0.8,
					1,
					1.4,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					34,
					33,
					25,
					19,
					20,
					25,
					{
						"y": 25,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					2.1,
					2,
					1.5,
					1.1,
					1.2,
					1.4,
					{
						"y": 1.4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					24,
					22,
					17,
					19,
					11,
					24,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					1.5,
					1.3,
					1,
					1.1,
					0.6,
					1.4,
					{
						"y": 0.9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_12.png"
};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 13,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_13.png"
};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Fraser Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					14.483,
					14.887,
					15.091,
					16.092,
					15.84,
					16.844,
					17.1,
					18.525,
					19.207,
					17.925,
					17.16,
					18.261,
					18.274,
					17.938,
					17.552,
					19.339,
					20.08,
					19.177,
					18.425,
					{
						"y": 19.15,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_1.png"
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for Fraser Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					6.936,
					7.154,
					7.36,
					7.55,
					7.586,
					8.133,
					8.084,
					8.788,
					9.313,
					8.564,
					8.217,
					8.764,
					8.683,
					8.734,
					8.539,
					9.354,
					9.681,
					9.216,
					8.669,
					{
						"y": 9.088,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7.1,
					7.321,
					7.461,
					8.098,
					7.847,
					8.405,
					8.651,
					9.352,
					9.578,
					9.128,
					8.727,
					9.237,
					9.4,
					9.02,
					8.845,
					9.817,
					10.215,
					9.788,
					9.541,
					{
						"y": 9.921,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.021,
					0.035,
					0.017,
					0.021,
					0.024,
					0.018,
					0.027,
					0.038,
					0.032,
					0.033,
					0.04,
					0.037,
					0.034,
					0.025,
					0.032,
					0.031,
					0.022,
					0.041,
					0.029,
					{
						"y": 0.033,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_2.png"
};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Fraser Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.4,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4.281,
					4.503,
					4.417,
					4.58,
					4.592,
					5.073,
					5.077,
					5.135,
					5.549,
					5.43,
					5.196,
					5.484,
					5.429,
					5.779,
					5.633,
					5.779,
					5.96,
					6.002,
					5.87,
					{
						"y": 5.832,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3.452,
					3.576,
					3.555,
					3.911,
					3.783,
					3.976,
					3.928,
					4.557,
					4.557,
					4.163,
					4.092,
					4.441,
					4.483,
					4.268,
					4.193,
					4.731,
					4.839,
					4.475,
					4.311,
					{
						"y": 4.582,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.479,
					2.467,
					2.546,
					2.75,
					2.646,
					2.758,
					2.85,
					3.108,
					3.135,
					2.819,
					2.792,
					2.888,
					2.953,
					2.741,
					2.699,
					3.076,
					3.002,
					2.981,
					2.832,
					{
						"y": 3.041,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					3.842,
					3.962,
					4.318,
					4.426,
					4.432,
					4.747,
					4.902,
					5.374,
					5.682,
					5.309,
					4.898,
					5.221,
					5.246,
					4.99,
					4.89,
					5.613,
					6.114,
					5.587,
					5.225,
					{
						"y": 5.586,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_3.png"
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.4,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for Fraser Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 100,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					426,
					377,
					253,
					423,
					383,
					288,
					338,
					347,
					284,
					200,
					176,
					223,
					157,
					159,
					136,
					137,
					162,
					132,
					186,
					{
						"y": 108,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_4.png"
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Fraser Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser East",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.747,
					1.913,
					2.538,
					2.348,
					2.343,
					2.429,
					2.305,
					2.453,
					2.424,
					2.328,
					2.339,
					2.534,
					2.672,
					2.428,
					2.563,
					2.735,
					2.743,
					2.759,
					2.778,
					{
						"y": 2.846,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser East</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser North",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7.027,
					6.978,
					6.924,
					7.386,
					7.356,
					7.794,
					7.981,
					8.764,
					9.243,
					8.574,
					8.096,
					8.594,
					8.373,
					8.415,
					8.289,
					9.225,
					9.353,
					8.872,
					8.156,
					{
						"y": 8.561,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser North</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser South",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5.709,
					5.996,
					5.629,
					6.358,
					6.141,
					6.621,
					6.814,
					7.308,
					7.54,
					7.023,
					6.725,
					7.133,
					7.229,
					7.095,
					6.7,
					7.379,
					7.984,
					7.546,
					7.491,
					{
						"y": 7.725,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser South</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_5.png"
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.6,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in Fraser Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.4,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser East",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.871,
					0.947,
					1.301,
					1.192,
					1.178,
					1.215,
					1.156,
					1.183,
					1.184,
					1.092,
					1.142,
					1.229,
					1.303,
					1.199,
					1.287,
					1.367,
					1.31,
					1.388,
					1.339,
					{
						"y": 1.394,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser East</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser North",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3.487,
					3.35,
					3.34,
					3.428,
					3.483,
					3.727,
					3.822,
					4.167,
					4.495,
					4.181,
					3.852,
					4.114,
					3.983,
					4.155,
					4.002,
					4.493,
					4.511,
					4.195,
					3.769,
					{
						"y": 4.023,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser North</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser South",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.578,
					2.857,
					2.719,
					2.93,
					2.925,
					3.191,
					3.106,
					3.438,
					3.634,
					3.291,
					3.223,
					3.421,
					3.397,
					3.38,
					3.25,
					3.494,
					3.86,
					3.633,
					3.561,
					{
						"y": 3.671,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser South</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_6.png"
};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 1.7,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Fraser Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.4,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser East",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.807,
					0.903,
					1.179,
					1.103,
					1.14,
					1.167,
					1.081,
					1.193,
					1.191,
					1.201,
					1.146,
					1.271,
					1.343,
					1.2,
					1.24,
					1.331,
					1.379,
					1.321,
					1.382,
					{
						"y": 1.434,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser East</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser North",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3.448,
					3.499,
					3.476,
					3.817,
					3.672,
					3.923,
					4.056,
					4.473,
					4.635,
					4.322,
					4.174,
					4.377,
					4.3,
					4.185,
					4.237,
					4.686,
					4.801,
					4.626,
					4.342,
					{
						"y": 4.5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser North</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser South",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.845,
					2.919,
					2.806,
					3.178,
					3.035,
					3.315,
					3.514,
					3.686,
					3.752,
					3.605,
					3.407,
					3.589,
					3.757,
					3.635,
					3.368,
					3.8,
					4.035,
					3.841,
					3.817,
					{
						"y": 3.987,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser South</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_1_7.png"
};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 2.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Fraser Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 200,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Fraser East",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2069.1933665151223,
					1997.550407793385,
					1955.9341411603634,
					2243.5897435897436,
					2473.131708400114,
					2931.4640138824457,
					3366.1635254090834,
					3373.5317776880274,
					3458.7056405993862,
					{
						"y": 3613.216620209627,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser East</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser North",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2705.9360166015313,
					2715.1953231585676,
					2809.2424367483477,
					3396.398015044576,
					4283.546594368401,
					4452.080828452857,
					4861.580840156094,
					5412.350474081671,
					5117.149707651537,
					{
						"y": 5197.020627563637,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser North</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Fraser South",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1935.57283204044,
					1993.1768355224779,
					2073.3234642412763,
					2483.3414982893423,
					2825.650676641236,
					3126.662234042553,
					3550.9937104401192,
					3827.033294117933,
					3635.732663196314,
					{
						"y": 3735.035970289567,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser South</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Fraser Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2250.8488217733698,
					2267.0649481968244,
					2330.5767568597003,
					2786.5477336741924,
					3313.7770680248564,
					3590.969161713251,
					4009.2585552743635,
					4339.022468454596,
					4152.463519779481,
					{
						"y": 4254.170337321321,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_2_1.png"
};

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 2.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for Fraser Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 200,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2150.66541426099,
					2171.0456439529603,
					2229.9944006158103,
					2758.0037078377172,
					3377.108702345185,
					3619.9725830061107,
					4029.94382682198,
					4331.997769331897,
					4111.613899665123,
					{
						"y": 4187.507422050763,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2342.6208014795766,
					2352.4928580177643,
					2422.5105707664093,
					2804.9568163427994,
					3240.3426623630835,
					3552.264584719159,
					3978.023187555034,
					4329.992012330262,
					4180.296902084537,
					{
						"y": 4308.21696245977,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_2_2.png"
};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 2.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Fraser Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 300,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2215.9101164895287,
					2220.94024759347,
					2244.388626932021,
					2482.2378691815084,
					2690.793650793651,
					2743.9879270202237,
					3024.0851262992965,
					3260.214673254007,
					3326.079824711891,
					{
						"y": 3478.7195147533907,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4369.62620227339,
					4459.502543860831,
					4507.7063363209745,
					5030.03003003003,
					5649.535953929609,
					6036.839227890156,
					6537.3294855111435,
					6979.340926736731,
					6852.66571457878,
					{
						"y": 7125.203214179014,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2658.3462599613977,
					2642.2565792813657,
					2718.433681178027,
					3241.756301234936,
					3888.5193455916124,
					4189.802927205033,
					4707.415466417835,
					5085.174261120809,
					4748.013803065564,
					{
						"y": 4838.703230731721,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1162.6460191612223,
					1211.3704703048159,
					1344.2015617689906,
					2024.5552584817024,
					2846.697555587707,
					3328.360098689051,
					3832.9008025725016,
					4201.965159675327,
					3785.788382574343,
					{
						"y": 3773.9357338729205,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_2_3.png"
};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 3.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Fraser Health <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					11,
					16,
					17,
					18,
					17,
					15,
					13,
					19,
					18,
					17,
					13,
					12,
					9,
					9,
					11,
					13,
					16,
					13,
					20,
					10
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					10,
					12,
					13,
					11,
					11,
					15,
					15,
					17,
					15,
					12,
					12,
					8,
					9,
					8,
					11,
					7,
					10,
					10,
					9,
					8
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_3_1.png"
};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 3.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Fraser Health by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4,
					6,
					2,
					6,
					1,
					2,
					2,
					4,
					3,
					3,
					2,
					1,
					4,
					0,
					1,
					3,
					3,
					7,
					6,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7,
					10,
					15,
					12,
					16,
					13,
					11,
					15,
					15,
					14,
					11,
					11,
					5,
					9,
					9,
					10,
					13,
					6,
					14,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_3_2.png"
};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 3.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Fraser Health by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					4,
					4,
					3,
					4,
					3,
					4,
					6,
					2,
					8,
					2,
					6,
					4,
					5,
					3,
					7,
					5,
					3,
					5,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3,
					5,
					4,
					5,
					4,
					3,
					3,
					7,
					4,
					5,
					3,
					4,
					1,
					2,
					2,
					1,
					4,
					4,
					8,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					3,
					1,
					4,
					2,
					6,
					3,
					3,
					4,
					4,
					2,
					4,
					1,
					2,
					2,
					2,
					4,
					2,
					3,
					5,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					4,
					6,
					5,
					8,
					3,
					6,
					3,
					2,
					8,
					2,
					4,
					1,
					2,
					0,
					4,
					1,
					5,
					3,
					2,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_3_3.png"
};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 3.4,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Fraser Health by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					11,
					5,
					3,
					8,
					11,
					7,
					8,
					8,
					7,
					8,
					11,
					11,
					6,
					7,
					2,
					5,
					8,
					6,
					3,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					5,
					3,
					1,
					0,
					3,
					0,
					0,
					1,
					0,
					1,
					0,
					1,
					3,
					1,
					2,
					0,
					0,
					0,
					1,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					3,
					7,
					7,
					7,
					3,
					10,
					8,
					6,
					6,
					8,
					5,
					4,
					4,
					3,
					5,
					3,
					3,
					5,
					4,
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					1,
					0,
					1,
					0,
					0,
					0,
					1,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					1,
					2,
					0,
					0,
					1,
					0,
					1,
					0,
					2,
					6,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_3_4.png"
};

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 3.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Fraser Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser East",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					0,
					2,
					2,
					1,
					1,
					2,
					1,
					5,
					1,
					0,
					0,
					1,
					0,
					1,
					0,
					3,
					1,
					2,
					4,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser East</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Fraser North",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					5,
					5,
					10,
					8,
					10,
					5,
					5,
					6,
					7,
					8,
					8,
					4,
					4,
					6,
					10,
					6,
					9,
					4,
					5,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser North</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Fraser South",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					6,
					9,
					5,
					9,
					6,
					8,
					7,
					8,
					10,
					9,
					5,
					7,
					5,
					2,
					1,
					4,
					6,
					7,
					11,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser South</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					1,
					1,
					2,
					0,
					1,
					3,
					1,
					3,
					1,
					0,
					0,
					1,
					0,
					1,
					0,
					1,
					0,
					1,
					4,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					4,
					4,
					9,
					7,
					4,
					5,
					6,
					5,
					4,
					6,
					7,
					2,
					5,
					4,
					10,
					3,
					8,
					4,
					1,
					1
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					5,
					7,
					2,
					4,
					6,
					7,
					8,
					9,
					10,
					6,
					5,
					5,
					4,
					3,
					1,
					3,
					2,
					5,
					4,
					5
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_3_5.png"
};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 4.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for Fraser Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					6,
					5,
					12,
					11
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					8,
					15,
					15,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					8,
					6,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					2,
					7,
					7,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					12,
					14,
					10,
					8
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"Fraser Health"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						6,
						6,
						5,
						12,
						11
					]
				},
				{
					"name": "Stage 1",
					"data": [
						10,
						8,
						15,
						15,
						8
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						6,
						8,
						6,
						3,
						2
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						8,
						2,
						7,
						7,
						3
					]
				},
				{
					"name": "Stage 3",
					"data": [
						15,
						12,
						14,
						10,
						8
					]
				},
				{
					"name": "Unknown",
					"data": [
						2,
						10,
						6,
						8,
						4
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						47,
						46,
						53,
						55,
						36
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_4_1.png"
};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 4.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for Fraser Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					null,
					1,
					3,
					2,
					{
						"y": 1,
						"color": "white"
					},
					6,
					6,
					4,
					9,
					9
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					3,
					3,
					3,
					3,
					{
						"y": 1,
						"color": "white"
					},
					6,
					5,
					12,
					12,
					5
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					5,
					6,
					6,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					1,
					2,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					7,
					1,
					5,
					7,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					4,
					1,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					14,
					8,
					13,
					8,
					8
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						0,
						0,
						1,
						3,
						2,
						6,
						6,
						4,
						9,
						9
					]
				},
				{
					"name": "Stage 1",
					"data": [
						4,
						3,
						3,
						3,
						3,
						6,
						5,
						12,
						12,
						5
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						2,
						0,
						0,
						0,
						5,
						6,
						6,
						3,
						2
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						1,
						1,
						2,
						0,
						1,
						7,
						1,
						5,
						7,
						2
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						4,
						1,
						2,
						0,
						14,
						8,
						13,
						8,
						8
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						4,
						1,
						3,
						0,
						2,
						6,
						5,
						5,
						4
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						7,
						14,
						8,
						11,
						6,
						40,
						32,
						45,
						44,
						30
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_4_2.png"
};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 4.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Fraser Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					4,
					null,
					4,
					8,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					1,
					5,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					1,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					3,
					1,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					3,
					9,
					5,
					3,
					{
						"y": 1,
						"color": "white"
					},
					3,
					3,
					2,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					1,
					4,
					3,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					3,
					3,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					1,
					1,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					3,
					1,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					2,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					3,
					2,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					1,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					3,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					null,
					2,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					3,
					2,
					1,
					2,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					1,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					3,
					3,
					3,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					6,
					4,
					4,
					3,
					4,
					{
						"y": 1,
						"color": "white"
					},
					5,
					4,
					7,
					4,
					2
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						4,
						4,
						0,
						4,
						8,
						0,
						1,
						1,
						5,
						1,
						1,
						0,
						1,
						2,
						0,
						1,
						1,
						3,
						1,
						2
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						3,
						9,
						5,
						3,
						3,
						3,
						2,
						3,
						1,
						1,
						1,
						1,
						4,
						3,
						3,
						1,
						3,
						3,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						2,
						1,
						1,
						2,
						0,
						3,
						3,
						1,
						1,
						1,
						1,
						1,
						2,
						0,
						0,
						0,
						3,
						2,
						0,
						1
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						3,
						0,
						1,
						1,
						1,
						0,
						0,
						3,
						1,
						0,
						2,
						0,
						2,
						3,
						1,
						3,
						2,
						1,
						2,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						1,
						0,
						0,
						1,
						3,
						3,
						3,
						3,
						1,
						6,
						4,
						4,
						3,
						4,
						5,
						4,
						7,
						4,
						2
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						2,
						0,
						3,
						1,
						0,
						4,
						2,
						3,
						1,
						2,
						3,
						4,
						0,
						1,
						0,
						1,
						0,
						2,
						1
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						13,
						11,
						11,
						15,
						14,
						9,
						14,
						12,
						16,
						5,
						13,
						9,
						14,
						12,
						9,
						12,
						12,
						16,
						12,
						8
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_4_3.png"
};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 4.4,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for Fraser Health <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					6,
					2,
					7,
					7,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					3,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					3,
					1,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					3,
					11,
					9,
					4,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					null,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					5,
					3,
					4,
					2,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					3,
					4,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					4,
					1,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					3,
					3,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					2,
					3,
					3,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					5,
					4,
					4,
					4,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					5,
					6,
					9,
					6,
					3
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						6,
						6,
						2,
						7,
						7,
						0,
						0,
						0,
						3,
						2,
						0,
						0,
						3,
						1,
						2,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						3,
						11,
						9,
						4,
						2,
						2,
						0,
						3,
						1,
						5,
						3,
						4,
						2,
						3,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						2,
						3,
						4,
						2,
						0,
						1,
						1,
						1,
						0,
						0,
						1,
						4,
						1,
						0,
						1,
						2,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						1
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						5,
						0,
						3,
						3,
						2,
						0,
						0,
						1,
						0,
						0,
						3,
						2,
						3,
						3,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						5,
						5,
						4,
						4,
						4,
						3,
						1,
						0,
						0,
						1,
						5,
						6,
						9,
						6,
						3,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						4,
						3,
						3,
						1,
						0,
						2,
						0,
						0,
						0,
						2,
						4,
						3,
						4,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						1
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						21,
						21,
						27,
						28,
						18,
						6,
						6,
						2,
						6,
						4,
						16,
						19,
						23,
						16,
						12,
						3,
						0,
						0,
						2,
						0,
						1,
						0,
						1,
						3,
						2
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_4_4.png"
};

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 130,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Fraser Health, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -55,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.29256489221294,
						"dataLabels": {
							"enabled": true,
							"format": "2166"
						}
					},
					{
						"y": 86.09766827980643,
						"dataLabels": {
							"enabled": true,
							"format": "1957"
						}
					},
					{
						"y": 82.71007479102508,
						"dataLabels": {
							"enabled": true,
							"format": "1880"
						}
					},
					{
						"y": 76.46282446106467,
						"dataLabels": {
							"enabled": true,
							"format": "1738"
						}
					},
					{
						"y": 65.55213374395072,
						"dataLabels": {
							"enabled": true,
							"format": "1490"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.707435107787061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.649122807017541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9345937659683194,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5531914893617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.269275028768702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=2273"
			}
		],
		"dataTable": {
			"Overall HA": [
				2273,
				2166,
				1957,
				1880,
				1738,
				1490
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_1.png"
};

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Fraser Health by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.54140127388536,
						"dataLabels": {
							"enabled": true,
							"format": "1650",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.56629994209612,
						"dataLabels": {
							"enabled": true,
							"format": "1495",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.26577880718008,
						"dataLabels": {
							"enabled": true,
							"format": "1438",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.40185292414591,
						"dataLabels": {
							"enabled": true,
							"format": "1354",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.38448176027794,
						"dataLabels": {
							"enabled": true,
							"format": "1181",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.5054945054945,
						"dataLabels": {
							"enabled": true,
							"format": "516",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": true,
							"format": "462",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.95238095238095,
						"dataLabels": {
							"enabled": true,
							"format": "442",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.32967032967034,
						"dataLabels": {
							"enabled": true,
							"format": "384",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.59340659340659,
						"dataLabels": {
							"enabled": true,
							"format": "309",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.458598726114649,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.393939393939398,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.8127090301003363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.841446453407507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.776957163958647,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.494505494505497,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.465116279069765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.329004329004327,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.122171945701355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.53125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=1727"
			},
			{
				"x": 9,
				"text": "Women<br>n=546"
			}
		],
		"dataTable": {
			"Men": [
				1727,
				1650,
				1495,
				1438,
				1354,
				1181
			],
			"Women": [
				546,
				516,
				462,
				442,
				384,
				309
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_2.png"
};

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 79.6875,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.875,
						"dataLabels": {
							"enabled": true,
							"format": "92",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.625,
						"dataLabels": {
							"enabled": true,
							"format": "84",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.03125,
						"dataLabels": {
							"enabled": true,
							"format": "73",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.875,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.01661129568106,
						"dataLabels": {
							"enabled": true,
							"format": "286",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.38538205980066,
						"dataLabels": {
							"enabled": true,
							"format": "254",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.734219269103,
						"dataLabels": {
							"enabled": true,
							"format": "240",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.10299003322258,
						"dataLabels": {
							"enabled": true,
							"format": "208",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.797342192691026,
						"dataLabels": {
							"enabled": true,
							"format": "183",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.23655913978494,
						"dataLabels": {
							"enabled": true,
							"format": "537",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.91756272401435,
						"dataLabels": {
							"enabled": true,
							"format": "485",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "465",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.26881720430107,
						"dataLabels": {
							"enabled": true,
							"format": "420",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.903225806451616,
						"dataLabels": {
							"enabled": true,
							"format": "351",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.49805447470817,
						"dataLabels": {
							"enabled": true,
							"format": "1240",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.62645914396887,
						"dataLabels": {
							"enabled": true,
							"format": "1126",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.90272373540856,
						"dataLabels": {
							"enabled": true,
							"format": "1091",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.70038910505836,
						"dataLabels": {
							"enabled": true,
							"format": "1037",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.72762645914396,
						"dataLabels": {
							"enabled": true,
							"format": "896",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -20.3125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.80392156862745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.095238095238093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.808219178082197,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.983388704318936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.188811188811187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.511811023622048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.01923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.7634408602150504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.68342644320298,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.123711340206182,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.428571428571427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5019455252918275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.193548387096772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.1083481349911235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.949587534372135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.596914175506269,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=128"
			},
			{
				"x": 9,
				"text": "30–39<br>n=301"
			},
			{
				"x": 15,
				"text": "40–49<br>n=558"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1285"
			}
		],
		"dataTable": {
			"< 30": [
				128,
				102,
				92,
				84,
				73,
				60
			],
			"30–39": [
				301,
				286,
				254,
				240,
				208,
				183
			],
			"40–49": [
				558,
				537,
				485,
				465,
				420,
				351
			],
			"≥ 50": [
				1285,
				1240,
				1126,
				1091,
				1037,
				896
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.4,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -75,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.53739612188366,
						"dataLabels": {
							"enabled": true,
							"format": "697"
						}
					},
					{
						"y": 90.99722991689751,
						"dataLabels": {
							"enabled": true,
							"format": "657"
						}
					},
					{
						"y": 87.95013850415513,
						"dataLabels": {
							"enabled": true,
							"format": "635"
						}
					},
					{
						"y": 84.07202216066482,
						"dataLabels": {
							"enabled": true,
							"format": "607"
						}
					},
					{
						"y": 74.79224376731301,
						"dataLabels": {
							"enabled": true,
							"format": "540"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.50259067357513,
						"dataLabels": {
							"enabled": true,
							"format": "745"
						}
					},
					{
						"y": 89.50777202072538,
						"dataLabels": {
							"enabled": true,
							"format": "691"
						}
					},
					{
						"y": 85.10362694300518,
						"dataLabels": {
							"enabled": true,
							"format": "657"
						}
					},
					{
						"y": 77.07253886010362,
						"dataLabels": {
							"enabled": true,
							"format": "595"
						}
					},
					{
						"y": 63.730569948186535,
						"dataLabels": {
							"enabled": true,
							"format": "492"
						}
					},
					{
						"y": null
					},
					{
						"y": 92.93966623876764,
						"dataLabels": {
							"enabled": true,
							"format": "724"
						}
					},
					{
						"y": 78.17715019255456,
						"dataLabels": {
							"enabled": true,
							"format": "609"
						}
					},
					{
						"y": 75.4813863928113,
						"dataLabels": {
							"enabled": true,
							"format": "588"
						}
					},
					{
						"y": 68.80616174582799,
						"dataLabels": {
							"enabled": true,
							"format": "536"
						}
					},
					{
						"y": 58.793324775353014,
						"dataLabels": {
							"enabled": true,
							"format": "458"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.4626038781163437,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.7388809182209455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.34855403348554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.409448818897643,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.037891268533773,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.497409326424872,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.24832214765101,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.920405209840806,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.43683409436834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.310924369747905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.060333761232352,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.883977900552482,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.843537414965985,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.552238805970152,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=722"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=772"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=779"
			}
		],
		"dataTable": {
			"MSM": [
				722,
				697,
				657,
				635,
				607,
				540
			],
			"Non-MSM": [
				772,
				745,
				691,
				657,
				595,
				492
			],
			"Unknown": [
				779,
				724,
				609,
				588,
				536,
				458
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_4.png"
};

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.5,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#043f61"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0c4250"
					},
					{
						"y": 85,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#043f61"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.56140350877193,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.17543859649122,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#09472e"
					},
					{
						"y": 65.78947368421053,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.61016949152543,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#043f61"
					},
					{
						"y": 91.52542372881356,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.98305084745762,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.89830508474576,
						"dataLabels": {
							"enabled": false,
							"format": "99"
						},
						"color": "#09472e"
					},
					{
						"y": 70.33898305084746,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "438"
						},
						"color": "#043f61"
					},
					{
						"y": 94,
						"dataLabels": {
							"enabled": false,
							"format": "423"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "411"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.44444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "398"
						},
						"color": "#09472e"
					},
					{
						"y": 79.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "358"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#043f61"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0c4250"
					},
					{
						"y": 63.1578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.1578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#09472e"
					},
					{
						"y": 57.89473684210527,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.3855421686747,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#043f61"
					},
					{
						"y": 95.18072289156626,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.95180722891565,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.28915662650603,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#09472e"
					},
					{
						"y": 59.036144578313255,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.1038961038961,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#043f61"
					},
					{
						"y": 89.17748917748918,
						"dataLabels": {
							"enabled": false,
							"format": "206"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.4155844155844,
						"dataLabels": {
							"enabled": false,
							"format": "195"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.59307359307358,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#09472e"
					},
					{
						"y": 58.44155844155844,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.80365296803653,
						"dataLabels": {
							"enabled": false,
							"format": "424"
						},
						"color": "#043f61"
					},
					{
						"y": 89.49771689497716,
						"dataLabels": {
							"enabled": false,
							"format": "392"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.0730593607306,
						"dataLabels": {
							"enabled": false,
							"format": "377"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.59360730593608,
						"dataLabels": {
							"enabled": false,
							"format": "353"
						},
						"color": "#09472e"
					},
					{
						"y": 67.8082191780822,
						"dataLabels": {
							"enabled": false,
							"format": "297"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 67.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 58.57142857142858,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0c4250"
					},
					{
						"y": 54.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0d4440"
					},
					{
						"y": 44.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 35.714285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#043f61"
					},
					{
						"y": 82.6923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.84615384615384,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#09472e"
					},
					{
						"y": 56.730769230769226,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.17224880382776,
						"dataLabels": {
							"enabled": false,
							"format": "201"
						},
						"color": "#043f61"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "165"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.24880382775119,
						"dataLabels": {
							"enabled": false,
							"format": "151"
						},
						"color": "#09472e"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.21410579345087,
						"dataLabels": {
							"enabled": false,
							"format": "378"
						},
						"color": "#043f61"
					},
					{
						"y": 78.33753148614609,
						"dataLabels": {
							"enabled": false,
							"format": "311"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.32241813602015,
						"dataLabels": {
							"enabled": false,
							"format": "303"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.04030226700252,
						"dataLabels": {
							"enabled": false,
							"format": "286"
						},
						"color": "#09472e"
					},
					{
						"y": 60.70528967254408,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.499999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.714285714285716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.161616161616166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.6666666666666616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.424657534246578,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.8368794326241176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1630170316301665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.050251256281406,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.6144578313253017,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.2499999999999956,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.594936708860756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.808219178082197,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8961038961038974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.207207207207212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.339805825242716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.82051282051282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.588235294117652,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1963470319634757,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.547169811320753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.826530612244894,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.366047745358094,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.864022662889521,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -32.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.765957446808507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.42105263157895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.354838709677423,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.244897959183676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.07317073170732,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.235294117647056,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8277511961722466,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.925373134328357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.508771929824561,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.484848484848484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.92052980132451,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.7858942065491235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.72486772486772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5723472668810254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.610561056105611,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.73426573426573,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=40"
			},
			{
				"x": 9,
				"text": "30-39<br>n=114"
			},
			{
				"x": 15,
				"text": "40-49<br>n=118"
			},
			{
				"x": 21,
				"text": ">=50<br>n=450"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=19"
			},
			{
				"x": 34,
				"text": "30-39<br>n=83"
			},
			{
				"x": 40,
				"text": "40-49<br>n=231"
			},
			{
				"x": 46,
				"text": ">=50<br>n=438"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=70"
			},
			{
				"x": 59,
				"text": "30-39<br>n=104"
			},
			{
				"x": 65,
				"text": "40-49<br>n=209"
			},
			{
				"x": 71,
				"text": ">=50<br>n=397"
			}
		],
		"dataTable": {
			"MSM:<30": [
				40,
				37,
				36,
				34,
				30,
				24
			],
			"MSM:30-39": [
				114,
				108,
				90,
				85,
				80,
				75
			],
			"MSM:40-49": [
				118,
				114,
				108,
				105,
				99,
				83
			],
			"MSM:>=50": [
				450,
				438,
				423,
				411,
				398,
				358
			],
			"Non-MSM:<30": [
				19,
				18,
				15,
				12,
				12,
				11
			],
			"Non-MSM:30-39": [
				83,
				80,
				79,
				73,
				60,
				49
			],
			"Non-MSM:40-49": [
				231,
				222,
				206,
				195,
				170,
				135
			],
			"Non-MSM:>=50": [
				438,
				424,
				392,
				377,
				353,
				297
			],
			"Unknown:<30": [
				70,
				47,
				41,
				38,
				31,
				25
			],
			"Unknown:30-39": [
				104,
				98,
				86,
				82,
				68,
				59
			],
			"Unknown:40-49": [
				209,
				201,
				171,
				165,
				151,
				133
			],
			"Unknown:>=50": [
				397,
				378,
				311,
				303,
				286,
				241
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.6,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.42857142857143,
						"dataLabels": {
							"enabled": true,
							"format": "459"
						}
					},
					{
						"y": 90.12605042016807,
						"dataLabels": {
							"enabled": true,
							"format": "429"
						}
					},
					{
						"y": 85.92436974789915,
						"dataLabels": {
							"enabled": true,
							"format": "409"
						}
					},
					{
						"y": 77.31092436974791,
						"dataLabels": {
							"enabled": true,
							"format": "368"
						}
					},
					{
						"y": 60.924369747899156,
						"dataLabels": {
							"enabled": true,
							"format": "290"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "1247"
						}
					},
					{
						"y": 90.62015503875969,
						"dataLabels": {
							"enabled": true,
							"format": "1169"
						}
					},
					{
						"y": 87.36434108527132,
						"dataLabels": {
							"enabled": true,
							"format": "1127"
						}
					},
					{
						"y": 82.24806201550388,
						"dataLabels": {
							"enabled": true,
							"format": "1061"
						}
					},
					{
						"y": 72.17054263565892,
						"dataLabels": {
							"enabled": true,
							"format": "931"
						}
					},
					{
						"y": null
					},
					{
						"y": 90.72978303747534,
						"dataLabels": {
							"enabled": true,
							"format": "460"
						}
					},
					{
						"y": 70.80867850098619,
						"dataLabels": {
							"enabled": true,
							"format": "359"
						}
					},
					{
						"y": 67.85009861932939,
						"dataLabels": {
							"enabled": true,
							"format": "344"
						}
					},
					{
						"y": 60.946745562130175,
						"dataLabels": {
							"enabled": true,
							"format": "309"
						}
					},
					{
						"y": 53.05719921104537,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.5359477124183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.66200466200466,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.024449877750607,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.19565217391305,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.255012028869289,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.59281437125748,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.856255545696543,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.252591894439213,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.270216962524657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.95652173913043,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.178272980501396,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.174418604651159,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.944983818770229,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=476"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=1290"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=507"
			}
		],
		"dataTable": {
			"IDU": [
				476,
				459,
				429,
				409,
				368,
				290
			],
			"Non-IDU": [
				1290,
				1247,
				1169,
				1127,
				1061,
				931
			],
			"Unknown": [
				507,
				460,
				359,
				344,
				309,
				269
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_6.png"
};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 5.7,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by HSDA, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -80,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "357"
						}
					},
					{
						"y": 81.55080213903744,
						"dataLabels": {
							"enabled": true,
							"format": "305"
						}
					},
					{
						"y": 77.00534759358288,
						"dataLabels": {
							"enabled": true,
							"format": "288"
						}
					},
					{
						"y": 68.71657754010695,
						"dataLabels": {
							"enabled": true,
							"format": "257"
						}
					},
					{
						"y": 56.14973262032086,
						"dataLabels": {
							"enabled": true,
							"format": "210"
						}
					},
					{
						"y": null
					},
					{
						"y": 94.51345755693582,
						"dataLabels": {
							"enabled": true,
							"format": "913"
						}
					},
					{
						"y": 84.26501035196688,
						"dataLabels": {
							"enabled": true,
							"format": "814"
						}
					},
					{
						"y": 80.74534161490683,
						"dataLabels": {
							"enabled": true,
							"format": "780"
						}
					},
					{
						"y": 75.56935817805382,
						"dataLabels": {
							"enabled": true,
							"format": "730"
						}
					},
					{
						"y": 65.42443064182196,
						"dataLabels": {
							"enabled": true,
							"format": "632"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.15795090715048,
						"dataLabels": {
							"enabled": true,
							"format": "901"
						}
					},
					{
						"y": 89.43436499466382,
						"dataLabels": {
							"enabled": true,
							"format": "838"
						}
					},
					{
						"y": 86.65955176093917,
						"dataLabels": {
							"enabled": true,
							"format": "812"
						}
					},
					{
						"y": 80.14941302027748,
						"dataLabels": {
							"enabled": true,
							"format": "751"
						}
					},
					{
						"y": 69.15688367129135,
						"dataLabels": {
							"enabled": true,
							"format": "648"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.565826330532216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.573770491803276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.763888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.287937743190664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.486542443064179,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.843373493975905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.176904176904173,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.41025641025641,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.424657534246576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.84204909284952,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.992230854605996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1026252983293534,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.512315270935965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.715046604527291,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser East<br>n=374"
			},
			{
				"x": 9,
				"text": "Fraser North<br>n=966"
			},
			{
				"x": 15,
				"text": "Fraser South<br>n=937"
			}
		],
		"dataTable": {
			"Fraser East": [
				374,
				357,
				305,
				288,
				257,
				210
			],
			"Fraser North": [
				966,
				913,
				814,
				780,
				730,
				632
			],
			"Fraser South": [
				937,
				901,
				838,
				812,
				751,
				648
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_7.png"
};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 6.1,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					24.675324675324674,
					18.478260869565215,
					17.5,
					14.457831325301203,
					12.162162162162163,
					15.686274509803921,
					13.725490196078432,
					{
						"y": 15.789473684210526,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					14.285714285714285,
					9.782608695652174,
					11.25,
					10.843373493975903,
					8.108108108108109,
					11.76470588235294,
					9.803921568627452,
					{
						"y": 7.894736842105263,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5.194805194805195,
					7.608695652173914,
					5,
					8.433734939759036,
					9.45945945945946,
					13.725490196078432,
					21.568627450980394,
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					25.97402597402597,
					26.08695652173913,
					27.500000000000004,
					27.710843373493976,
					28.37837837837838,
					27.450980392156865,
					37.254901960784316,
					{
						"y": 34.21052631578947,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					6.493506493506493,
					11.956521739130435,
					10,
					14.457831325301203,
					14.864864864864865,
					15.686274509803921,
					15.686274509803921,
					{
						"y": 15.789473684210526,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					25.97402597402597,
					23.91304347826087,
					21.25,
					19.27710843373494,
					20.27027027027027,
					23.52941176470588,
					19.607843137254903,
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					77,
					92,
					80,
					83,
					74,
					51,
					51,
					{
						"y": 38,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_6_1.png"
};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 6.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 35,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					38,
					36,
					33,
					27,
					14,
					11,
					12
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 19,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					32,
					23,
					30,
					31,
					23,
					26,
					15
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					13,
					15,
					14,
					13,
					12,
					11,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					4,
					3,
					3,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					5,
					3,
					3,
					3,
					2,
					3,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 77,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					92,
					80,
					83,
					74,
					51,
					51,
					38
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_6_2.png"
};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 7,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					15,
					11,
					15,
					11,
					14,
					20,
					17,
					{
						"y": 15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					48,
					32,
					40,
					30,
					30,
					35,
					44,
					{
						"y": 39,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_7.png"
};

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "fha",
	"id": 8,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in Fraser Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					3,
					4,
					5,
					4,
					7,
					7,
					4
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					0,
					3,
					0,
					2,
					2,
					2,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					2,
					1,
					2,
					3,
					3,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					2,
					2,
					0,
					3,
					3,
					1,
					4
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					0,
					4,
					2,
					0,
					2,
					2,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 290,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					290,
					305,
					560,
					{
						"y": 405,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					350,
					433,
					270
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					7,
					14,
					9,
					12,
					17,
					16,
					13
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_fha_8.png"
};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 10,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					2,
					11,
					4,
					5,
					1,
					5,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					2,
					0,
					0,
					1,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					0,
					1,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					4,
					12,
					4,
					6,
					1,
					5,
					4
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_10.png"
};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 11,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 280,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					262,
					261,
					266,
					300,
					283,
					264,
					274
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 26,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					26,
					34,
					22,
					32,
					32,
					34,
					54
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					2,
					1,
					1,
					1,
					0,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					6,
					7,
					6,
					4,
					3,
					8,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					1,
					2,
					0,
					2,
					1,
					1,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					2,
					1,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 317,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					297,
					305,
					297,
					340,
					319,
					308,
					341
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_11.png"
};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 12,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Interior Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					2,
					4,
					7,
					6,
					6,
					7,
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					0.3,
					0.6,
					1,
					0.8,
					0.8,
					0.9,
					{
						"y": 0.9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					8,
					11,
					9,
					8,
					7,
					8,
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.1,
					1.5,
					1.2,
					1.1,
					0.9,
					1.1,
					{
						"y": 0.8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2,
					5,
					7,
					5,
					5,
					4,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					0.3,
					0.7,
					1,
					0.7,
					0.7,
					0.5,
					{
						"y": 0.5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_12.png"
};

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 13,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_13.png"
};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Interior Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					5.53,
					5.596,
					5.863,
					6.613,
					7.04,
					7.884,
					9.117,
					10.46,
					9.851,
					9.006,
					8.792,
					9.887,
					9.697,
					9.409,
					9.681,
					9.965,
					10.216,
					9.571,
					13.463,
					{
						"y": 23.843,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_1.png"
};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for Interior Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2.644,
					2.694,
					2.767,
					3.209,
					3.45,
					3.885,
					4.479,
					5.143,
					4.869,
					4.396,
					4.282,
					4.692,
					4.75,
					4.683,
					4.777,
					4.778,
					4.938,
					4.726,
					6.713,
					{
						"y": 12.223,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.765,
					2.695,
					2.866,
					3.188,
					3.4,
					3.766,
					4.38,
					5.091,
					4.815,
					4.378,
					4.276,
					4.886,
					4.698,
					4.474,
					4.68,
					4.955,
					5.047,
					4.63,
					6.577,
					{
						"y": 11.403,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.035,
					0.044,
					0.028,
					0.036,
					0.06,
					0.054,
					0.07,
					0.066,
					0.054,
					0.047,
					0.063,
					0.057,
					0.048,
					0.051,
					0.062,
					0.059,
					0.059,
					0.059,
					0.054,
					{
						"y": 0.093,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_2.png"
};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Interior Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.717,
					1.754,
					1.83,
					1.948,
					2.007,
					2.214,
					2.367,
					2.609,
					2.532,
					2.564,
					2.477,
					2.599,
					2.632,
					2.614,
					2.665,
					2.76,
					2.755,
					2.649,
					3.385,
					{
						"y": 5.382,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1.152,
					1.195,
					1.156,
					1.346,
					1.391,
					1.517,
					1.574,
					1.852,
					1.804,
					1.66,
					1.669,
					1.878,
					1.797,
					1.824,
					1.868,
					1.95,
					1.891,
					1.79,
					2.217,
					{
						"y": 3.609,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.826,
					0.831,
					0.902,
					0.984,
					1.047,
					1.123,
					1.268,
					1.522,
					1.373,
					1.252,
					1.224,
					1.406,
					1.315,
					1.273,
					1.307,
					1.393,
					1.344,
					1.309,
					1.672,
					{
						"y": 2.812,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1.745,
					1.653,
					1.769,
					2.154,
					2.463,
					2.847,
					3.716,
					4.314,
					4.021,
					3.341,
					3.246,
					3.747,
					3.75,
					3.494,
					3.676,
					3.684,
					4.052,
					3.663,
					6.065,
					{
						"y": 11.901,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_3.png"
};

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.4,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for Interior Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 40,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					86,
					163,
					202,
					180,
					130,
					179,
					188,
					160,
					113,
					185,
					171,
					252,
					201,
					201,
					162,
					173,
					172,
					156,
					119,
					{
						"y": 124,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_4.png"
};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Interior Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "East Kootenay",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.461,
					0.422,
					0.482,
					0.498,
					0.601,
					0.774,
					0.776,
					0.872,
					0.775,
					0.654,
					0.655,
					0.723,
					0.727,
					0.692,
					0.724,
					0.75,
					0.783,
					0.801,
					1.35,
					{
						"y": 2.859,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">East Kootenay</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Kootenay Boundary",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.643,
					0.618,
					0.708,
					0.765,
					0.812,
					0.815,
					1.024,
					1.118,
					1.064,
					0.982,
					1.026,
					0.978,
					0.95,
					0.918,
					1.072,
					0.956,
					0.969,
					0.982,
					1.457,
					{
						"y": 2.563,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Kootenay Boundary</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Okanagan",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.761,
					2.81,
					2.901,
					3.329,
					3.403,
					4.005,
					4.566,
					5.113,
					4.776,
					4.537,
					4.479,
					5.272,
					4.98,
					5.112,
					5.009,
					5.16,
					5.369,
					4.978,
					6.977,
					{
						"y": 12.96,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Okanagan</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Thompson Cariboo Shuswap",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1.665,
					1.746,
					1.772,
					2.021,
					2.224,
					2.29,
					2.751,
					3.357,
					3.236,
					2.833,
					2.632,
					2.914,
					3.04,
					2.687,
					2.876,
					3.099,
					3.095,
					2.81,
					3.679,
					{
						"y": 5.461,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Thompson Cariboo Shuswap</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_5.png"
};

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.6,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in Interior Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "East Kootenay",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.218,
					0.196,
					0.238,
					0.252,
					0.327,
					0.404,
					0.398,
					0.426,
					0.389,
					0.323,
					0.324,
					0.358,
					0.373,
					0.355,
					0.387,
					0.391,
					0.409,
					0.396,
					0.721,
					{
						"y": 1.509,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">East Kootenay</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Kootenay Boundary",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.306,
					0.294,
					0.345,
					0.383,
					0.431,
					0.412,
					0.522,
					0.577,
					0.559,
					0.487,
					0.516,
					0.495,
					0.458,
					0.483,
					0.538,
					0.461,
					0.491,
					0.5,
					0.733,
					{
						"y": 1.298,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Kootenay Boundary</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Okanagan",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.298,
					1.379,
					1.369,
					1.616,
					1.654,
					1.926,
					2.201,
					2.437,
					2.244,
					2.164,
					2.127,
					2.415,
					2.378,
					2.441,
					2.333,
					2.385,
					2.449,
					2.338,
					3.401,
					{
						"y": 6.607,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Okanagan</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Thompson Cariboo Shuswap",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0.822,
					0.825,
					0.815,
					0.958,
					1.038,
					1.143,
					1.358,
					1.703,
					1.677,
					1.422,
					1.315,
					1.424,
					1.541,
					1.404,
					1.519,
					1.541,
					1.589,
					1.492,
					1.858,
					{
						"y": 2.809,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Thompson Cariboo Shuswap</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_6.png"
};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 1.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Interior Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "East Kootenay",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.236,
					0.218,
					0.231,
					0.225,
					0.26,
					0.349,
					0.367,
					0.439,
					0.376,
					0.313,
					0.322,
					0.344,
					0.341,
					0.322,
					0.328,
					0.348,
					0.37,
					0.384,
					0.622,
					{
						"y": 1.343,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">East Kootenay</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Kootenay Boundary",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.312,
					0.28,
					0.347,
					0.362,
					0.365,
					0.384,
					0.477,
					0.523,
					0.491,
					0.466,
					0.48,
					0.466,
					0.48,
					0.418,
					0.52,
					0.482,
					0.461,
					0.468,
					0.703,
					{
						"y": 1.242,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Kootenay Boundary</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Okanagan",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.399,
					1.316,
					1.42,
					1.616,
					1.646,
					1.935,
					2.21,
					2.543,
					2.426,
					2.231,
					2.205,
					2.665,
					2.443,
					2.517,
					2.511,
					2.632,
					2.748,
					2.489,
					3.46,
					{
						"y": 6.211,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Okanagan</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Thompson Cariboo Shuswap",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0.818,
					0.881,
					0.868,
					0.985,
					1.129,
					1.098,
					1.326,
					1.586,
					1.522,
					1.368,
					1.269,
					1.411,
					1.434,
					1.217,
					1.321,
					1.493,
					1.468,
					1.289,
					1.792,
					{
						"y": 2.607,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Thompson Cariboo Shuswap</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_1_7.png"
};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 2.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Interior Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 500,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "East Kootenay",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1634.8140495867767,
					1834.4809666103677,
					1707.6493868812042,
					1829.706593478403,
					2049.690254475921,
					2476.900884978753,
					3533.2114090042414,
					3987.4204068954805,
					3889.7619387768354,
					{
						"y": 4887.875529530645,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">East Kootenay</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Kootenay Boundary",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2358.9257342012197,
					2312.9339161738235,
					2261.912355680296,
					2230.7415221530387,
					2764.606814354191,
					3363.693750563622,
					4782.430738533166,
					5651.4572658855395,
					5394.844726862765,
					{
						"y": 5779.2290946343965,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Kootenay Boundary</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Okanagan",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2166.1710808381163,
					2161.749525057037,
					2192.4524393191314,
					2350.262526274134,
					2717.338472183306,
					3057.5519307889876,
					4065.378028976366,
					4942.0228825898,
					5068.41596909208,
					{
						"y": 5479.1683262965025,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 4,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Okanagan</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Thompson Cariboo Shuswap",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1826.0524116768722,
					1927.8924129438956,
					2012.161871113494,
					2097.1925716778,
					2698.947387665742,
					3191.3981212731287,
					4219.686213578361,
					5174.439663930878,
					4950.430244532491,
					{
						"y": 5398.843880427182,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Thompson Cariboo Shuswap</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Interior Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2026.762017614979,
					2072.183206446978,
					2093.648480579677,
					2205.6385433185023,
					2646.222195140191,
					3069.4958253270333,
					4132.330705259747,
					4988.151563376388,
					4946.462424614734,
					{
						"y": 5425.757488282747,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 25,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_2_1.png"
};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 2.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for Interior Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 200,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1985.8913124821165,
					1992.3772803066813,
					2040.6193555503469,
					2169.085497223471,
					2647.660645584157,
					3045.1647299473384,
					4180.668434557616,
					5008.11976182032,
					4958.239636003916,
					{
						"y": 5382.843309515442,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1934.1992454221254,
					2008.1074574050538,
					2044.9310362136566,
					2193.7781548818543,
					2604.374145130692,
					3055.316410085735,
					4023.9251605332634,
					4904.452577417046,
					4876.251190659905,
					{
						"y": 5408.523146690513,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_2_2.png"
};

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 2.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Interior Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 400,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2332.4808184143226,
					2341.0814318896023,
					2387.997715828272,
					2391.499235353056,
					2736.165693518971,
					3163.3775622460203,
					3774.7685579344525,
					4381.050787304297,
					4472.643875101509,
					{
						"y": 4904.830973758442,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3926.6169154228855,
					4134.915677701437,
					4198.607585392213,
					4349.191987735304,
					5089.273511176273,
					5670.240313641973,
					6911.395997918539,
					7905.059892124128,
					8234.516099607772,
					{
						"y": 8483.472514133502,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2479.175304360936,
					2518.99914677461,
					2589.979186760749,
					2811.590854190079,
					3278.4227252091578,
					3813.238121395221,
					4907.914495185937,
					5860.299484638694,
					5717.893812112227,
					{
						"y": 6073.335083573991,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1126.8511466531268,
					1185.4096196544879,
					1198.7571348756971,
					1382.1323319554767,
					1834.70711756041,
					2206.0438889838165,
					3548.311976784456,
					4524.368795665671,
					4325.534373194685,
					{
						"y": 4936.295684398322,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_2_3.png"
};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 3.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Interior Health <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					4,
					4,
					6,
					5,
					1,
					7,
					6,
					6,
					2,
					4,
					2,
					2,
					2,
					0,
					3,
					2,
					6,
					1,
					4,
					5
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					2,
					4,
					5,
					5,
					1,
					7,
					6,
					6,
					2,
					3,
					2,
					2,
					2,
					0,
					2,
					3,
					5,
					1,
					4,
					6
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_3_1.png"
};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 3.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Interior Health by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0,
					1,
					0,
					0,
					0,
					0,
					2,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					2,
					1,
					2,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4,
					3,
					6,
					5,
					1,
					7,
					4,
					5,
					1,
					4,
					2,
					2,
					2,
					0,
					3,
					1,
					4,
					0,
					2,
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_3_2.png"
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 3.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Interior Health by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					1,
					2,
					2,
					0,
					5,
					2,
					2,
					0,
					1,
					1,
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					2,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1,
					3,
					2,
					0,
					0,
					0,
					1,
					1,
					0,
					1,
					1,
					0,
					1,
					0,
					2,
					1,
					1,
					0,
					0,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					1,
					1,
					1,
					2,
					1,
					3,
					0,
					1,
					0,
					0,
					1,
					0,
					0,
					1,
					4,
					0,
					1,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					1,
					2,
					0,
					0,
					2,
					0,
					2,
					1,
					0,
					1,
					0,
					0,
					0,
					0,
					1,
					1,
					1,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_3_3.png"
};

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 3.4,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Interior Health by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					2,
					2,
					5,
					3,
					0,
					4,
					3,
					5,
					1,
					3,
					2,
					2,
					1,
					0,
					3,
					1,
					2,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -5,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0,
					2,
					1,
					1,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					3,
					1,
					1,
					1,
					1,
					2,
					0,
					2,
					3,
					1,
					1,
					1,
					0,
					0,
					1,
					0,
					0,
					1,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 5,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 20,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					3,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_3_4.png"
};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 3.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Interior Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "East Kootenay",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					0,
					1,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">East Kootenay</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Kootenay Boundary",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					2,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Kootenay Boundary</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Okanagan",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					1,
					2,
					2,
					1,
					0,
					4,
					4,
					2,
					0,
					3,
					2,
					1,
					1,
					0,
					1,
					2,
					2,
					0,
					3,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Okanagan</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Thompson Cariboo Shuswap",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"index": 30,
				"data": [
					2,
					2,
					4,
					2,
					1,
					3,
					2,
					2,
					2,
					1,
					0,
					1,
					1,
					0,
					2,
					0,
					1,
					1,
					0,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Thompson Cariboo Shuswap</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					0,
					0,
					0,
					1,
					0,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					0,
					1,
					1
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					0,
					2,
					3,
					0,
					0,
					4,
					4,
					3,
					0,
					2,
					2,
					1,
					2,
					0,
					1,
					3,
					2,
					0,
					3,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "ShortDash",
				"index": 31,
				"data": [
					1,
					2,
					2,
					3,
					1,
					2,
					1,
					2,
					2,
					1,
					0,
					1,
					0,
					0,
					1,
					0,
					1,
					1,
					0,
					1
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_3_5.png"
};

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 4.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for Interior Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					5,
					null,
					2,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					3,
					3,
					3,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					1,
					3,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					2,
					3,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					3,
					10,
					1,
					2
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"Interior Health"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						5,
						0,
						2,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						3,
						3,
						3,
						3
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						2,
						1,
						3,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						3,
						2,
						3,
						4,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						6,
						3,
						10,
						1,
						2
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						2,
						0,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						14,
						15,
						19,
						13,
						6
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_4_1.png"
};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 4.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for Interior Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					4,
					null,
					2,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					1,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					3,
					2,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					1,
					3,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					2,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					2,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					5,
					3,
					8,
					null,
					2
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						0,
						1,
						0,
						0,
						0,
						1,
						4,
						0,
						2,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						1,
						1,
						0,
						1,
						0,
						2,
						2,
						3,
						2,
						3
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						0,
						0,
						0,
						0,
						0,
						2,
						1,
						3,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						0,
						1,
						0,
						0,
						3,
						1,
						2,
						4,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						0,
						2,
						1,
						0,
						5,
						3,
						8,
						0,
						2
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						2,
						0,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						3,
						2,
						3,
						2,
						0,
						11,
						12,
						16,
						11,
						6
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_4_2.png"
};

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 4.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Interior Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					3,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					2,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					1,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					null,
					1,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					null,
					1,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					2,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					1,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					2,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					1,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					3,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					4,
					null,
					4,
					1,
					1
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						3,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						2,
						0,
						2,
						1,
						1,
						0,
						1,
						1,
						0,
						0,
						1,
						0,
						0,
						1,
						2,
						0,
						2,
						0,
						1,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						0,
						1,
						1,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						1,
						0,
						2,
						1,
						1,
						1,
						1,
						0,
						2,
						0,
						0,
						0,
						1,
						1,
						0,
						1,
						1,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						0,
						0,
						2,
						0,
						0,
						2,
						2,
						1,
						0,
						1,
						0,
						1,
						3,
						0,
						0,
						4,
						0,
						4,
						1,
						1
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						5,
						3,
						8,
						4,
						2,
						3,
						6,
						3,
						3,
						1,
						1,
						1,
						4,
						4,
						2,
						5,
						5,
						4,
						2,
						1
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_4_3.png"
};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 4.4,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for Interior Health <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					4,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					3,
					2,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					1,
					null,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					1,
					1,
					3,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					1,
					2,
					4,
					1,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					1,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					1,
					3,
					null,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					5,
					null,
					5,
					1,
					null
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						4,
						0,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						0,
						0,
						3,
						2,
						2,
						0,
						2,
						0,
						0,
						0,
						2,
						1,
						0,
						1,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						0,
						1,
						1,
						3,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						2,
						1,
						2,
						4,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						1,
						3,
						0,
						2,
						0,
						2,
						1,
						0,
						0,
						5,
						0,
						5,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						4,
						7,
						10,
						11,
						5,
						0,
						4,
						1,
						0,
						0,
						8,
						4,
						7,
						2,
						1,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_4_4.png"
};

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Interior Health, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.94594594594594,
						"dataLabels": {
							"enabled": true,
							"format": "639"
						}
					},
					{
						"y": 81.38138138138137,
						"dataLabels": {
							"enabled": true,
							"format": "542"
						}
					},
					{
						"y": 78.37837837837837,
						"dataLabels": {
							"enabled": true,
							"format": "522"
						}
					},
					{
						"y": 71.47147147147147,
						"dataLabels": {
							"enabled": true,
							"format": "476"
						}
					},
					{
						"y": 53.153153153153156,
						"dataLabels": {
							"enabled": true,
							"format": "354"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.054054054054057,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.179968701095458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.690036900369009,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.812260536398464,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.630252100840334,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=666"
			}
		],
		"dataTable": {
			"Overall HA": [
				666,
				639,
				542,
				522,
				476,
				354
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_1.png"
};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Interior Health by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.1977186311787,
						"dataLabels": {
							"enabled": true,
							"format": "506",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.12927756653993,
						"dataLabels": {
							"enabled": true,
							"format": "432",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.89733840304183,
						"dataLabels": {
							"enabled": true,
							"format": "415",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.00380228136882,
						"dataLabels": {
							"enabled": true,
							"format": "384",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.80228136882129,
						"dataLabels": {
							"enabled": true,
							"format": "283",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.68345323741008,
						"dataLabels": {
							"enabled": true,
							"format": "133",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.13669064748201,
						"dataLabels": {
							"enabled": true,
							"format": "110",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.97841726618705,
						"dataLabels": {
							"enabled": true,
							"format": "107",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.18705035971223,
						"dataLabels": {
							"enabled": true,
							"format": "92",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.07913669064749,
						"dataLabels": {
							"enabled": true,
							"format": "71",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.802281368821292,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.62450592885376,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.935185185185186,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.469879518072286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -26.302083333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.316546762589923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.29323308270677,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.7272727272727226,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.018691588785048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.826086956521742,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=526"
			},
			{
				"x": 9,
				"text": "Women<br>n=139"
			}
		],
		"dataTable": {
			"Men": [
				526,
				506,
				432,
				415,
				384,
				283
			],
			"Women": [
				139,
				133,
				110,
				107,
				92,
				71
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_2.png"
};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.3,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 84.375,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": true,
							"format": "20",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.125,
						"dataLabels": {
							"enabled": true,
							"format": "17",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.875,
						"dataLabels": {
							"enabled": true,
							"format": "15",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.36619718309859,
						"dataLabels": {
							"enabled": true,
							"format": "67",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.69014084507043,
						"dataLabels": {
							"enabled": true,
							"format": "58",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.87323943661971,
						"dataLabels": {
							"enabled": true,
							"format": "56",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.01408450704226,
						"dataLabels": {
							"enabled": true,
							"format": "49",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.929577464788736,
						"dataLabels": {
							"enabled": true,
							"format": "39",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.26865671641791,
						"dataLabels": {
							"enabled": true,
							"format": "129",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.1044776119403,
						"dataLabels": {
							"enabled": true,
							"format": "106",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.11940298507463,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.92537313432835,
						"dataLabels": {
							"enabled": true,
							"format": "87",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 44.02985074626866,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.74418604651163,
						"dataLabels": {
							"enabled": true,
							"format": "416",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.7906976744186,
						"dataLabels": {
							"enabled": true,
							"format": "356",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": true,
							"format": "344",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.11627906976744,
						"dataLabels": {
							"enabled": true,
							"format": "323",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.04651162790698,
						"dataLabels": {
							"enabled": true,
							"format": "241",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -15.625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.518518518518523,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.000000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.633802816901412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.432835820895528,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.408163265306122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.731343283582089,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.829457364341085,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.7735849056603765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.18390804597702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2558139534883734,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.423076923076927,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3707865168539297,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.104651162790697,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25.386996904024773,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=32"
			},
			{
				"x": 9,
				"text": "30–39<br>n=71"
			},
			{
				"x": 15,
				"text": "40–49<br>n=134"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=430"
			}
		],
		"dataTable": {
			"< 30": [
				32,
				27,
				22,
				20,
				17,
				15
			],
			"30–39": [
				71,
				67,
				58,
				56,
				49,
				39
			],
			"40–49": [
				134,
				129,
				106,
				102,
				87,
				59
			],
			"≥ 50": [
				430,
				416,
				356,
				344,
				323,
				241
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_3.png"
};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.4,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.78899082568807,
						"dataLabels": {
							"enabled": true,
							"format": "211"
						}
					},
					{
						"y": 89.44954128440367,
						"dataLabels": {
							"enabled": true,
							"format": "195"
						}
					},
					{
						"y": 87.1559633027523,
						"dataLabels": {
							"enabled": true,
							"format": "190"
						}
					},
					{
						"y": 82.11009174311926,
						"dataLabels": {
							"enabled": true,
							"format": "179"
						}
					},
					{
						"y": 60.09174311926605,
						"dataLabels": {
							"enabled": true,
							"format": "131"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.0464135021097,
						"dataLabels": {
							"enabled": true,
							"format": "230"
						}
					},
					{
						"y": 83.96624472573839,
						"dataLabels": {
							"enabled": true,
							"format": "199"
						}
					},
					{
						"y": 80.59071729957806,
						"dataLabels": {
							"enabled": true,
							"format": "191"
						}
					},
					{
						"y": 70.88607594936708,
						"dataLabels": {
							"enabled": true,
							"format": "168"
						}
					},
					{
						"y": 54.85232067510548,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.36492890995261,
						"dataLabels": {
							"enabled": true,
							"format": "197"
						}
					},
					{
						"y": 70.14218009478674,
						"dataLabels": {
							"enabled": true,
							"format": "148"
						}
					},
					{
						"y": 66.82464454976304,
						"dataLabels": {
							"enabled": true,
							"format": "141"
						}
					},
					{
						"y": 61.137440758293835,
						"dataLabels": {
							"enabled": true,
							"format": "129"
						}
					},
					{
						"y": 44.07582938388626,
						"dataLabels": {
							"enabled": true,
							"format": "93"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.2110091743119296,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5829383886255926,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.564102564102566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.789473684210522,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.815642458100562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9535864978902926,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.478260869565217,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.020100502512558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.041884816753923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.619047619047617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.635071090047395,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.873096446700504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.729729729729726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.510638297872342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.906976744186053,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=218"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=237"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=211"
			}
		],
		"dataTable": {
			"MSM": [
				218,
				211,
				195,
				190,
				179,
				131
			],
			"Non-MSM": [
				237,
				230,
				199,
				191,
				168,
				130
			],
			"Unknown": [
				211,
				197,
				148,
				141,
				129,
				93
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_4.png"
};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.5,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#043f61"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.54838709677419,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#043f61"
					},
					{
						"y": 87.09677419354838,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.09677419354838,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.41935483870968,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#09472e"
					},
					{
						"y": 58.06451612903226,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 56.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.94520547945206,
						"dataLabels": {
							"enabled": false,
							"format": "143"
						},
						"color": "#043f61"
					},
					{
						"y": 89.04109589041096,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.3013698630137,
						"dataLabels": {
							"enabled": false,
							"format": "126"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.56164383561644,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#09472e"
					},
					{
						"y": 61.64383561643836,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.75,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#043f61"
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.25,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.0392156862745,
						"dataLabels": {
							"enabled": false,
							"format": "50"
						},
						"color": "#043f61"
					},
					{
						"y": 84.31372549019608,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.3921568627451,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.70588235294117,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 45.09803921568628,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.95121951219512,
						"dataLabels": {
							"enabled": false,
							"format": "159"
						},
						"color": "#043f61"
					},
					{
						"y": 84.14634146341463,
						"dataLabels": {
							"enabled": false,
							"format": "138"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.09756097560977,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.78048780487805,
						"dataLabels": {
							"enabled": false,
							"format": "121"
						},
						"color": "#09472e"
					},
					{
						"y": 57.3170731707317,
						"dataLabels": {
							"enabled": false,
							"format": "94"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 46.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0d4440"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 69.56521739130434,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0c4250"
					},
					{
						"y": 69.56521739130434,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0d4440"
					},
					{
						"y": 60.86956521739131,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 47.82608695652174,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#043f61"
					},
					{
						"y": 67.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 63.46153846153846,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0d4440"
					},
					{
						"y": 55.769230769230774,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 36.53846153846153,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#043f61"
					},
					{
						"y": 72.5,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#09472e"
					},
					{
						"y": 47.5,
						"dataLabels": {
							"enabled": false,
							"format": "57"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.0547945205479423,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.076923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1746031746031744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.22950819672131,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9607843137254943,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.000000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.303030303030297,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0487804878048808,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.207547169811317,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6231884057971064,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.022556390977442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.314049586776864,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.434782608695656,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.714285714285716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.121212121212121,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.48275862068966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.684210526315784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.298850574712641,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.749999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=11"
			},
			{
				"x": 9,
				"text": "30-39<br>n=31"
			},
			{
				"x": 15,
				"text": "40-49<br>n=30"
			},
			{
				"x": 21,
				"text": ">=50<br>n=146"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=6"
			},
			{
				"x": 34,
				"text": "30-39<br>n=16"
			},
			{
				"x": 40,
				"text": "40-49<br>n=51"
			},
			{
				"x": 46,
				"text": ">=50<br>n=164"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=15"
			},
			{
				"x": 59,
				"text": "30-39<br>n=23"
			},
			{
				"x": 65,
				"text": "40-49<br>n=52"
			},
			{
				"x": 71,
				"text": ">=50<br>n=120"
			}
		],
		"dataTable": {
			"MSM:<30": [
				11,
				9,
				9,
				9,
				8,
				6
			],
			"MSM:30-39": [
				31,
				29,
				27,
				27,
				24,
				18
			],
			"MSM:40-49": [
				30,
				29,
				28,
				28,
				25,
				17
			],
			"MSM:>=50": [
				146,
				143,
				130,
				126,
				122,
				90
			],
			"Non-MSM:<30": [
				6,
				6,
				4,
				4,
				3,
				3
			],
			"Non-MSM:30-39": [
				16,
				15,
				14,
				13,
				11,
				10
			],
			"Non-MSM:40-49": [
				51,
				50,
				43,
				41,
				33,
				23
			],
			"Non-MSM:>=50": [
				164,
				159,
				138,
				133,
				121,
				94
			],
			"Unknown:<30": [
				15,
				11,
				9,
				7,
				6,
				6
			],
			"Unknown:30-39": [
				23,
				23,
				16,
				16,
				14,
				11
			],
			"Unknown:40-49": [
				52,
				49,
				35,
				33,
				29,
				19
			],
			"Unknown:>=50": [
				120,
				114,
				87,
				85,
				80,
				57
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_5.png"
};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.6,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.35449735449735,
						"dataLabels": {
							"enabled": true,
							"format": "184"
						}
					},
					{
						"y": 83.5978835978836,
						"dataLabels": {
							"enabled": true,
							"format": "158"
						}
					},
					{
						"y": 79.36507936507937,
						"dataLabels": {
							"enabled": true,
							"format": "150"
						}
					},
					{
						"y": 69.31216931216932,
						"dataLabels": {
							"enabled": true,
							"format": "131"
						}
					},
					{
						"y": 52.38095238095239,
						"dataLabels": {
							"enabled": true,
							"format": "99"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.12643678160919,
						"dataLabels": {
							"enabled": true,
							"format": "338"
						}
					},
					{
						"y": 88.2183908045977,
						"dataLabels": {
							"enabled": true,
							"format": "307"
						}
					},
					{
						"y": 85.34482758620689,
						"dataLabels": {
							"enabled": true,
							"format": "297"
						}
					},
					{
						"y": 79.88505747126436,
						"dataLabels": {
							"enabled": true,
							"format": "278"
						}
					},
					{
						"y": 58.620689655172406,
						"dataLabels": {
							"enabled": true,
							"format": "204"
						}
					},
					{
						"y": null
					},
					{
						"y": 91.47286821705426,
						"dataLabels": {
							"enabled": true,
							"format": "118"
						}
					},
					{
						"y": 59.68992248062015,
						"dataLabels": {
							"enabled": true,
							"format": "77"
						}
					},
					{
						"y": 58.139534883720934,
						"dataLabels": {
							"enabled": true,
							"format": "75"
						}
					},
					{
						"y": 51.93798449612403,
						"dataLabels": {
							"enabled": true,
							"format": "67"
						}
					},
					{
						"y": 39.53488372093023,
						"dataLabels": {
							"enabled": true,
							"format": "51"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.645502645502651,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.130434782608692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.063291139240511,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.666666666666671,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.427480916030532,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.8735632183908066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.171597633136097,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.2573289902280145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.3973063973064015,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.618705035971225,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.527131782945741,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.7457627118644,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5974025974025983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.666666666666668,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.880597014925375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=189"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=348"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=129"
			}
		],
		"dataTable": {
			"IDU": [
				189,
				184,
				158,
				150,
				131,
				99
			],
			"Non-IDU": [
				348,
				338,
				307,
				297,
				278,
				204
			],
			"Unknown": [
				129,
				118,
				77,
				75,
				67,
				51
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_6.png"
};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 5.7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Interior Health by HSDA, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": true,
							"format": "42"
						}
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": true,
							"format": "30"
						}
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": true,
							"format": "30"
						}
					},
					{
						"y": 61.36363636363637,
						"dataLabels": {
							"enabled": true,
							"format": "27"
						}
					},
					{
						"y": 40.909090909090914,
						"dataLabels": {
							"enabled": true,
							"format": "18"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.875,
						"dataLabels": {
							"enabled": true,
							"format": "62"
						}
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": true,
							"format": "56"
						}
					},
					{
						"y": 82.8125,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 79.6875,
						"dataLabels": {
							"enabled": true,
							"format": "51"
						}
					},
					{
						"y": 59.375,
						"dataLabels": {
							"enabled": true,
							"format": "38"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.32768361581921,
						"dataLabels": {
							"enabled": true,
							"format": "341"
						}
					},
					{
						"y": 84.18079096045197,
						"dataLabels": {
							"enabled": true,
							"format": "298"
						}
					},
					{
						"y": 80.50847457627118,
						"dataLabels": {
							"enabled": true,
							"format": "285"
						}
					},
					{
						"y": 74.29378531073446,
						"dataLabels": {
							"enabled": true,
							"format": "263"
						}
					},
					{
						"y": 56.49717514124294,
						"dataLabels": {
							"enabled": true,
							"format": "200"
						}
					},
					{
						"y": null
					},
					{
						"y": 94.6341463414634,
						"dataLabels": {
							"enabled": true,
							"format": "194"
						}
					},
					{
						"y": 77.07317073170732,
						"dataLabels": {
							"enabled": true,
							"format": "158"
						}
					},
					{
						"y": 75.1219512195122,
						"dataLabels": {
							"enabled": true,
							"format": "154"
						}
					},
					{
						"y": 65.85365853658537,
						"dataLabels": {
							"enabled": true,
							"format": "135"
						}
					},
					{
						"y": 47.80487804878049,
						"dataLabels": {
							"enabled": true,
							"format": "98"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.35714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7735849056603765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.49019607843137,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.672316384180796,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.609970674486803,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.36241610738255,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.719298245614037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.954372623574148,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.36585365853659,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.556701030927837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5316455696202556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.337662337662337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.4074074074074,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "East Kootenay<br>n=44"
			},
			{
				"x": 9,
				"text": "Kootenay Boundary<br>n=64"
			},
			{
				"x": 15,
				"text": "Okanagan<br>n=354"
			},
			{
				"x": 21,
				"text": "Thompson Cariboo Shuswap<br>n=205"
			}
		],
		"dataTable": {
			"East Kootenay": [
				44,
				42,
				30,
				30,
				27,
				18
			],
			"Kootenay Boundary": [
				64,
				62,
				56,
				53,
				51,
				38
			],
			"Okanagan": [
				354,
				341,
				298,
				285,
				263,
				200
			],
			"Thompson Cariboo Shuswap": [
				205,
				194,
				158,
				154,
				135,
				98
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_7.png"
};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 6.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					5.555555555555555,
					0,
					4.761904761904762,
					10.526315789473683,
					16.666666666666664,
					20,
					20,
					{
						"y": 16.666666666666664,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 18,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					4.761904761904762,
					5.263157894736842,
					5.555555555555555,
					6.666666666666667,
					0,
					{
						"y": 16.666666666666664,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -5,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					4.761904761904762,
					5.263157894736842,
					5.555555555555555,
					6.666666666666667,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 18,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					44.44444444444444,
					50,
					33.33333333333333,
					21.052631578947366,
					22.22222222222222,
					6.666666666666667,
					10,
					{
						"y": 8.333333333333332,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					5.555555555555555,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					33.33333333333333,
					27.77777777777778,
					33.33333333333333,
					31.57894736842105,
					27.77777777777778,
					26.666666666666668,
					20,
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					18,
					18,
					21,
					19,
					18,
					15,
					10,
					{
						"y": 12,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_6_1.png"
};

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 6.2,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					7,
					8,
					8,
					7,
					7,
					6,
					7
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					8,
					10,
					9,
					9,
					7,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					3,
					2,
					1,
					1,
					0,
					1,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					0,
					1,
					1,
					1,
					1,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 18,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					18,
					21,
					19,
					18,
					15,
					10,
					12
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_6_2.png"
};

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 7,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					5,
					1,
					2,
					3,
					4,
					5,
					1,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					8,
					9,
					10,
					13,
					14,
					11,
					10,
					{
						"y": 19,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_7.png"
};

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "iha",
	"id": 8,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in Interior Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					1,
					1,
					2,
					2,
					3,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					0,
					0,
					1,
					1,
					1,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					0,
					1,
					0,
					1,
					1,
					0,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					0,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 515,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					530,
					460,
					580,
					{
						"y": 450,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					650,
					40,
					140
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					1,
					2,
					3,
					4,
					5,
					1,
					3
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_iha_8.png"
};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 10,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					5,
					2,
					1,
					1,
					0,
					2,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					2,
					0,
					0,
					0,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					1,
					0,
					1,
					0,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					1,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					8,
					2,
					2,
					1,
					1,
					3,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_10.png"
};

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 11,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 104,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					110,
					101,
					112,
					101,
					106,
					85,
					111
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					17,
					22,
					10,
					10,
					18,
					19,
					21
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					2,
					1,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					12,
					11,
					10,
					5,
					8,
					4,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					2,
					0,
					0,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 127,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					139,
					136,
					135,
					116,
					132,
					109,
					141
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_11.png"
};

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 12,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Northern Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					3,
					6,
					1,
					6,
					10,
					5,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					1.1,
					2.1,
					0.4,
					2.1,
					3.5,
					1.8,
					{
						"y": 1.1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 14,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					10,
					12,
					7,
					9,
					5,
					3,
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					3.6,
					4.2,
					2.5,
					3.1,
					1.7,
					1,
					{
						"y": 2.7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					8,
					5,
					3,
					8,
					9,
					5,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					2.9,
					1.8,
					1.1,
					2.8,
					3.1,
					1.7,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -4,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_12.png"
};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 13,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_13.png"
};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Northern Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					2.963,
					2.852,
					2.987,
					3.73,
					3.177,
					3.222,
					3.188,
					3.676,
					3.395,
					3.105,
					3.087,
					3.746,
					3.659,
					3.465,
					3.381,
					3.887,
					4.116,
					3.559,
					3.594,
					{
						"y": 4.003,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_1.png"
};

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for Northern Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.496,
					1.463,
					1.509,
					1.908,
					1.64,
					1.614,
					1.617,
					1.884,
					1.696,
					1.543,
					1.519,
					1.857,
					1.826,
					1.718,
					1.683,
					1.909,
					2.085,
					1.842,
					1.789,
					{
						"y": 2.049,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1.314,
					1.279,
					1.359,
					1.62,
					1.439,
					1.455,
					1.423,
					1.634,
					1.547,
					1.405,
					1.433,
					1.757,
					1.713,
					1.621,
					1.584,
					1.855,
					1.896,
					1.593,
					1.713,
					{
						"y": 1.851,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.016,
					0.019,
					0.017,
					0.019,
					0.027,
					0.028,
					0.024,
					0.014,
					0.016,
					0.032,
					0.014,
					0.012,
					0.025,
					0.024,
					0.016,
					0.019,
					0.012,
					0.012,
					0.011,
					{
						"y": 0.012,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_2.png"
};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Northern Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.927,
					1,
					0.983,
					1.009,
					1.048,
					1.057,
					1.094,
					1.097,
					1.024,
					1.035,
					0.981,
					1.051,
					1.098,
					1.076,
					1.039,
					1.132,
					1.22,
					1.1,
					1.108,
					{
						"y": 1.156,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.619,
					0.56,
					0.581,
					0.646,
					0.615,
					0.617,
					0.6,
					0.747,
					0.649,
					0.614,
					0.627,
					0.752,
					0.708,
					0.706,
					0.7,
					0.826,
					0.811,
					0.722,
					0.706,
					{
						"y": 0.833,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.436,
					0.434,
					0.455,
					0.553,
					0.503,
					0.495,
					0.465,
					0.591,
					0.498,
					0.461,
					0.466,
					0.587,
					0.586,
					0.536,
					0.551,
					0.627,
					0.678,
					0.501,
					0.524,
					{
						"y": 0.637,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0.844,
					0.766,
					0.866,
					1.337,
					0.936,
					0.925,
					0.903,
					1.096,
					1.085,
					0.868,
					0.889,
					1.235,
					1.171,
					1.041,
					0.992,
					1.198,
					1.284,
					1.124,
					1.175,
					{
						"y": 1.285,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_3.png"
};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.4,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for Northern Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 20,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					137,
					91,
					102,
					183,
					71,
					125,
					124,
					144,
					136,
					125,
					121,
					120,
					95,
					102,
					98,
					104,
					123,
					112,
					81,
					{
						"y": 91,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_4.png"
};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Northern Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.486,
					0.44,
					0.44,
					0.423,
					0.484,
					0.548,
					0.613,
					0.56,
					0.522,
					0.439,
					0.458,
					0.604,
					0.617,
					0.52,
					0.51,
					0.6,
					0.652,
					0.555,
					0.517,
					{
						"y": 0.529,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1.892,
					1.822,
					1.891,
					2.594,
					2.035,
					2.015,
					1.892,
					2.339,
					2.198,
					1.957,
					1.937,
					2.348,
					2.29,
					2.187,
					2.162,
					2.502,
					2.596,
					2.132,
					2.176,
					{
						"y": 2.486,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.585,
					0.59,
					0.65,
					0.707,
					0.656,
					0.653,
					0.677,
					0.774,
					0.672,
					0.704,
					0.689,
					0.79,
					0.747,
					0.749,
					0.704,
					0.783,
					0.859,
					0.869,
					0.9,
					{
						"y": 0.985,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_5.png"
};

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.6,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in Northern Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.25,
					0.24,
					0.219,
					0.213,
					0.238,
					0.297,
					0.317,
					0.277,
					0.259,
					0.22,
					0.224,
					0.301,
					0.314,
					0.26,
					0.251,
					0.287,
					0.329,
					0.275,
					0.255,
					{
						"y": 0.249,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.933,
					0.91,
					0.94,
					1.321,
					1.046,
					0.966,
					0.931,
					1.156,
					1.094,
					0.926,
					0.915,
					1.111,
					1.115,
					1.069,
					1.048,
					1.196,
					1.29,
					1.082,
					1.071,
					{
						"y": 1.249,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.313,
					0.313,
					0.35,
					0.374,
					0.356,
					0.351,
					0.369,
					0.451,
					0.343,
					0.397,
					0.38,
					0.445,
					0.397,
					0.389,
					0.384,
					0.426,
					0.466,
					0.485,
					0.463,
					{
						"y": 0.551,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_6.png"
};

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 1.7,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Northern Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.236,
					0.199,
					0.22,
					0.209,
					0.245,
					0.246,
					0.293,
					0.281,
					0.263,
					0.216,
					0.234,
					0.3,
					0.301,
					0.257,
					0.258,
					0.311,
					0.323,
					0.278,
					0.261,
					{
						"y": 0.28,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.806,
					0.804,
					0.841,
					1.083,
					0.896,
					0.909,
					0.828,
					1.034,
					0.958,
					0.89,
					0.893,
					1.114,
					1.069,
					1.01,
					1.009,
					1.194,
					1.186,
					0.934,
					1.02,
					{
						"y": 1.139,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.272,
					0.276,
					0.298,
					0.328,
					0.298,
					0.3,
					0.302,
					0.319,
					0.326,
					0.299,
					0.306,
					0.343,
					0.343,
					0.354,
					0.317,
					0.35,
					0.387,
					0.381,
					0.432,
					{
						"y": 0.432,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_1_7.png"
};

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 2.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Northern Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 400,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2288.312122732594,
					2250.682596430888,
					2341.923839394029,
					2578.094223726637,
					2584.444730334348,
					2573.0249664049793,
					3058.227264873582,
					3103.234564986424,
					3438.2687859994403,
					{
						"y": 3467.307412261541,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2360.9261382655204,
					2449.2637291603032,
					2566.7438053846586,
					3232.1530937940115,
					3822.074154591077,
					4632.6678945177155,
					5438.740411323633,
					5319.789588245964,
					5577.589951366093,
					{
						"y": 5736.0521420558625,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2160.2465749704684,
					2249.6943350088304,
					2264.406779661017,
					2667.6368828601244,
					3157.9092273171536,
					3566.4653191518637,
					4079.6298892471614,
					4367.559313406668,
					4552.934722984092,
					{
						"y": 4943.018947074041,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					2291.0420292392855,
					2350.023870770064,
					2434.29419245443,
					2928.107997198186,
					3347.791062942131,
					3850.106810998902,
					4501.1939316813705,
					4532.442575429123,
					4797.131169542297,
					{
						"y": 4979.8776647416125,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_2_1.png"
};

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 2.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for Northern Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 200,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2412.1037886677327,
					2544.1458311998013,
					2625.8348976295456,
					3123.1774174734633,
					3635.7303028323863,
					4234.933132634748,
					4908.610015219351,
					4899.898963439733,
					5023.711385897265,
					{
						"y": 5283.065893546992,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2107.6842655514897,
					2124.0241158002946,
					2214.394594817287,
					2701.6068065921677,
					3035.2680948674883,
					3441.139830768079,
					4053.492527390335,
					4135.833613633815,
					4532.10588798867,
					{
						"y": 4659.29992946741,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_2_2.png"
};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 2.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Northern Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 300,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2399.779412418725,
					2474.7970380943884,
					2612.9026520339376,
					2998.567848191908,
					3120.4631405373434,
					3213.897546910509,
					3606.8948251722313,
					3620.8449902792927,
					3678.3318120653803,
					{
						"y": 3891.4104003698912,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4263.723182642101,
					4339.1601799229675,
					4446.25850340136,
					4762.554212923816,
					5253.288328109513,
					5787.362885447929,
					6220.54920652115,
					6747.778537252222,
					7156.071533903531,
					{
						"y": 7314.499749413099,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2452.6375496313103,
					2544.186046511628,
					2677.2103658536585,
					3217.7059996553335,
					3650.7053648177175,
					4373.881235893844,
					5313.5652832638925,
					5361.737446396459,
					5936.580218803799,
					{
						"y": 6102.09270486994,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1209.3381940549634,
					1257.52401402579,
					1303.7795327482618,
					2018.354581069674,
					2778.689305486456,
					3672.8661677924297,
					4593.148639681486,
					4445.526501181053,
					4763.891291297402,
					{
						"y": 4930.26989063911,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_2_3.png"
};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 3.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Northern Health <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					5,
					4,
					2,
					1,
					2,
					2,
					1,
					2,
					4,
					4,
					2,
					1,
					0,
					0,
					1,
					3,
					1,
					2,
					1,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					5,
					3,
					2,
					1,
					2,
					2,
					1,
					3,
					4,
					4,
					2,
					1,
					1,
					0,
					1,
					2,
					2,
					2,
					1,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_3_1.png"
};

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 3.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Northern Health by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0,
					1,
					1,
					0,
					0,
					2,
					1,
					2,
					0,
					3,
					1,
					0,
					0,
					0,
					1,
					0,
					1,
					2,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					5,
					3,
					1,
					1,
					2,
					0,
					0,
					0,
					4,
					1,
					1,
					1,
					0,
					0,
					0,
					3,
					0,
					0,
					1,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_3_2.png"
};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 3.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Northern Health by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					2,
					1,
					0,
					0,
					0,
					0,
					2,
					0,
					1,
					2,
					1,
					0,
					0,
					1,
					2,
					1,
					2,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					1,
					0,
					2,
					1,
					0,
					0,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					4,
					2,
					0,
					0,
					0,
					1,
					1,
					0,
					2,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_3_3.png"
};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 3.4,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Northern Health by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					2,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2,
					1,
					0,
					0,
					1,
					1,
					1,
					0,
					0,
					2,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0,
					1,
					3,
					1,
					1,
					0,
					1,
					1,
					0,
					0,
					3,
					3,
					1,
					1,
					0,
					0,
					1,
					1,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					1,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 20,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					1,
					1,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_3_4.png"
};

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 3.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Northern Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Northeast",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					0,
					0,
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northeast</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Northern Interior",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					2,
					3,
					1,
					1,
					1,
					1,
					1,
					2,
					3,
					2,
					1,
					1,
					0,
					0,
					0,
					2,
					0,
					2,
					1,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Interior</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Northwest",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					3,
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					1,
					2,
					1,
					0,
					0,
					0,
					1,
					1,
					1,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northwest</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					0,
					0,
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					3,
					3,
					1,
					1,
					1,
					1,
					1,
					3,
					3,
					2,
					1,
					1,
					0,
					0,
					0,
					1,
					1,
					2,
					1,
					2
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					2,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					1,
					2,
					1,
					0,
					1,
					0,
					1,
					1,
					1,
					0,
					0,
					0
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_3_5.png"
};

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 4.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for Northern Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					4,
					null,
					4,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					1,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					3,
					null,
					2,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					3,
					2,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					2,
					3,
					4,
					null
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"Northern Health"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						2,
						4,
						0,
						4,
						2
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						0,
						1,
						1,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						3,
						0,
						2,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						4,
						3,
						2,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						7,
						2,
						3,
						4,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						2,
						0,
						1,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						17,
						14,
						6,
						12,
						3
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_4_1.png"
};

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 4.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for Northern Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					2,
					null,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					2,
					null,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					null,
					1,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					3,
					null,
					2,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					1,
					2,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					1,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					6,
					2,
					2,
					3,
					null
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						2,
						0,
						3,
						1,
						1,
						2,
						0,
						1,
						1
					]
				},
				{
					"name": "Stage 1",
					"data": [
						0,
						0,
						0,
						1,
						0,
						3,
						0,
						1,
						0,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						0,
						0,
						0,
						0,
						0,
						1,
						3,
						0,
						2,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						2,
						1,
						2,
						0,
						0,
						2,
						2,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						0,
						1,
						1,
						0,
						6,
						2,
						2,
						3,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						0,
						0,
						0,
						0,
						2,
						0,
						1,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						4,
						3,
						3,
						5,
						1,
						13,
						11,
						3,
						7,
						2
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_4_2.png"
};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 4.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Northern Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					1,
					null,
					4,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					3,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					2,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					1,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					null,
					1,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					2,
					1,
					3,
					null
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						0,
						1,
						0,
						4,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						3,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						0,
						0,
						0,
						0,
						1,
						2,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						2,
						0,
						0,
						0,
						0,
						1,
						0,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						0,
						2,
						0,
						0,
						0,
						3,
						1,
						1,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						0,
						0,
						0,
						0,
						0,
						2,
						0,
						1,
						0,
						0,
						2,
						0,
						1,
						1,
						0,
						3,
						2,
						1,
						3,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						1,
						4,
						0,
						4,
						2,
						6,
						2,
						3,
						3,
						0,
						3,
						2,
						1,
						2,
						1,
						7,
						6,
						2,
						3,
						0
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_4_3.png"
};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 4.4,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for Northern Health <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					1,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					1,
					1,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					5,
					2,
					1,
					4,
					null
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						3,
						1,
						1,
						1,
						0,
						1,
						1,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						0,
						1,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						0,
						0,
						0,
						2,
						1,
						1,
						0,
						0,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						0,
						0,
						5,
						2,
						1,
						4,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						3,
						2,
						0,
						0,
						0,
						4,
						2,
						2,
						3,
						1,
						9,
						6,
						2,
						6,
						2,
						1,
						3,
						0,
						1,
						0,
						0,
						1,
						2,
						2,
						0
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_4_4.png"
};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Northern Health, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 91.18644067796609,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": 78.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "232"
						}
					},
					{
						"y": 75.9322033898305,
						"dataLabels": {
							"enabled": true,
							"format": "224"
						}
					},
					{
						"y": 63.05084745762712,
						"dataLabels": {
							"enabled": true,
							"format": "186"
						}
					},
					{
						"y": 38.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "114"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -8.813559322033903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.754646840148698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.964285714285708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.70967741935484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=295"
			}
		],
		"dataTable": {
			"Overall HA": [
				295,
				269,
				232,
				224,
				186,
				114
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_1.png"
};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Northern Health by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.73743016759776,
						"dataLabels": {
							"enabled": true,
							"format": "166",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.77094972067039,
						"dataLabels": {
							"enabled": true,
							"format": "141",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.53631284916202,
						"dataLabels": {
							"enabled": true,
							"format": "137",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.4804469273743,
						"dataLabels": {
							"enabled": true,
							"format": "119",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 41.899441340782126,
						"dataLabels": {
							"enabled": true,
							"format": "75",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 89.65517241379311,
						"dataLabels": {
							"enabled": true,
							"format": "104",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.44827586206897,
						"dataLabels": {
							"enabled": true,
							"format": "91",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"format": "87",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.758620689655174,
						"dataLabels": {
							"enabled": true,
							"format": "67",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 33.62068965517241,
						"dataLabels": {
							"enabled": true,
							"format": "39",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.2625698324022325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.06024096385542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.8368794326241176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.138686131386857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -36.97478991596639,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -10.344827586206895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.395604395604391,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.988505747126442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -41.7910447761194,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=179"
			},
			{
				"x": 9,
				"text": "Women<br>n=116"
			}
		],
		"dataTable": {
			"Men": [
				179,
				166,
				141,
				137,
				119,
				75
			],
			"Women": [
				116,
				104,
				91,
				87,
				67,
				39
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_2.png"
};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 61.904761904761905,
						"dataLabels": {
							"enabled": true,
							"format": "13",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": true,
							"format": "9",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": true,
							"format": "9",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 23.809523809523807,
						"dataLabels": {
							"enabled": true,
							"format": "5",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 14.285714285714285,
						"dataLabels": {
							"enabled": true,
							"format": "3",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": true,
							"format": "48",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.31372549019608,
						"dataLabels": {
							"enabled": true,
							"format": "43",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.35294117647058,
						"dataLabels": {
							"enabled": true,
							"format": "42",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.86274509803921,
						"dataLabels": {
							"enabled": true,
							"format": "29",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 35.294117647058826,
						"dataLabels": {
							"enabled": true,
							"format": "18",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.2972972972973,
						"dataLabels": {
							"enabled": true,
							"format": "72",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.08108108108108,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.02702702702703,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.16216216216216,
						"dataLabels": {
							"enabled": true,
							"format": "46",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 32.432432432432435,
						"dataLabels": {
							"enabled": true,
							"format": "24",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 91.94630872483222,
						"dataLabels": {
							"enabled": true,
							"format": "137",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.53691275167785,
						"dataLabels": {
							"enabled": true,
							"format": "120",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.85234899328859,
						"dataLabels": {
							"enabled": true,
							"format": "116",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.14093959731544,
						"dataLabels": {
							"enabled": true,
							"format": "106",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.308724832214764,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -38.095238095238095,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -30.76923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.416666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.3255813953488413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -30.952380952380953,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -37.93103448275862,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.298245614035093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -47.82608695652174,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -8.053691275167784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.408759124087588,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.62068965517241,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -34.905660377358494,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=21"
			},
			{
				"x": 9,
				"text": "30–39<br>n=51"
			},
			{
				"x": 15,
				"text": "40–49<br>n=74"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=149"
			}
		],
		"dataTable": {
			"< 30": [
				21,
				13,
				9,
				9,
				5,
				3
			],
			"30–39": [
				51,
				48,
				43,
				42,
				29,
				18
			],
			"40–49": [
				74,
				72,
				60,
				57,
				46,
				24
			],
			"≥ 50": [
				149,
				137,
				120,
				116,
				106,
				69
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.4,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -160,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.34883720930233,
						"dataLabels": {
							"enabled": true,
							"format": "41"
						}
					},
					{
						"y": 69.76744186046511,
						"dataLabels": {
							"enabled": true,
							"format": "30"
						}
					},
					{
						"y": 67.44186046511628,
						"dataLabels": {
							"enabled": true,
							"format": "29"
						}
					},
					{
						"y": 60.46511627906976,
						"dataLabels": {
							"enabled": true,
							"format": "26"
						}
					},
					{
						"y": 41.86046511627907,
						"dataLabels": {
							"enabled": true,
							"format": "18"
						}
					},
					{
						"y": null
					},
					{
						"y": 94.64285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "159"
						}
					},
					{
						"y": 86.30952380952381,
						"dataLabels": {
							"enabled": true,
							"format": "145"
						}
					},
					{
						"y": 84.52380952380952,
						"dataLabels": {
							"enabled": true,
							"format": "142"
						}
					},
					{
						"y": 67.26190476190477,
						"dataLabels": {
							"enabled": true,
							"format": "113"
						}
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": true,
							"format": "63"
						}
					},
					{
						"y": null
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "70"
						}
					},
					{
						"y": 67.85714285714286,
						"dataLabels": {
							"enabled": true,
							"format": "57"
						}
					},
					{
						"y": 63.095238095238095,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 55.952380952380956,
						"dataLabels": {
							"enabled": true,
							"format": "47"
						}
					},
					{
						"y": 39.285714285714285,
						"dataLabels": {
							"enabled": true,
							"format": "33"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.82926829268293,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3333333333333326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.344827586206895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.76923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.35714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.805031446540879,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0689655172413834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.4225352112676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.24778761061947,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.571428571428573,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.017543859649122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.32075471698113,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.78723404255319,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=43"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=168"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=84"
			}
		],
		"dataTable": {
			"MSM": [
				43,
				41,
				30,
				29,
				26,
				18
			],
			"Non-MSM": [
				168,
				159,
				145,
				142,
				113,
				63
			],
			"Unknown": [
				84,
				70,
				57,
				53,
				47,
				33
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_4.png"
};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#043f61"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0c4250"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0d4440"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#043f61"
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.10344827586206,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0d4440"
					},
					{
						"y": 51.724137931034484,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#09472e"
					},
					{
						"y": 20.689655172413794,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0c4250"
					},
					{
						"y": 82,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 66,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 30,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.90243902439023,
						"dataLabels": {
							"enabled": false,
							"format": "77"
						},
						"color": "#043f61"
					},
					{
						"y": 89.02439024390245,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.58536585365853,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.26829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 51.21951219512195,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#043f61"
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 23.076923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#043f61"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#043f61"
					},
					{
						"y": 70.58823529411765,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 47.05882352941176,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 29.411764705882355,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#043f61"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0c4250"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#09472e"
					},
					{
						"y": 42.5,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.833333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.17647058823529,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3809523809523836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.512195121951216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -54.54545454545454,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.0975609756097615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.1948051948051965,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.73972602739726,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.450704225352112,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.38461538461538,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -53.84615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.166666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=2"
			},
			{
				"x": 9,
				"text": "30-39<br>n=7"
			},
			{
				"x": 15,
				"text": "40-49<br>n=8"
			},
			{
				"x": 21,
				"text": ">=50<br>n=26"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=7"
			},
			{
				"x": 34,
				"text": "30-39<br>n=29"
			},
			{
				"x": 40,
				"text": "40-49<br>n=50"
			},
			{
				"x": 46,
				"text": ">=50<br>n=82"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=13"
			},
			{
				"x": 59,
				"text": "30-39<br>n=15"
			},
			{
				"x": 65,
				"text": "40-49<br>n=17"
			},
			{
				"x": 71,
				"text": ">=50<br>n=40"
			}
		],
		"dataTable": {
			"MSM:<30": [
				2,
				2,
				0,
				0,
				0,
				0
			],
			"MSM:30-39": [
				7,
				7,
				4,
				4,
				4,
				4
			],
			"MSM:40-49": [
				8,
				8,
				6,
				6,
				5,
				4
			],
			"MSM:>=50": [
				26,
				24,
				19,
				19,
				17,
				10
			],
			"Non-MSM:<30": [
				7,
				6,
				3,
				3,
				0,
				0
			],
			"Non-MSM:30-39": [
				29,
				28,
				28,
				27,
				15,
				6
			],
			"Non-MSM:40-49": [
				50,
				48,
				42,
				41,
				33,
				15
			],
			"Non-MSM:>=50": [
				82,
				77,
				73,
				71,
				65,
				42
			],
			"Unknown:<30": [
				13,
				6,
				6,
				6,
				5,
				3
			],
			"Unknown:30-39": [
				15,
				13,
				11,
				11,
				10,
				8
			],
			"Unknown:40-49": [
				17,
				16,
				12,
				10,
				8,
				5
			],
			"Unknown:>=50": [
				40,
				35,
				28,
				26,
				24,
				17
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.6,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.06299212598425,
						"dataLabels": {
							"enabled": true,
							"format": "122"
						}
					},
					{
						"y": 85.8267716535433,
						"dataLabels": {
							"enabled": true,
							"format": "109"
						}
					},
					{
						"y": 84.25196850393701,
						"dataLabels": {
							"enabled": true,
							"format": "107"
						}
					},
					{
						"y": 68.50393700787401,
						"dataLabels": {
							"enabled": true,
							"format": "87"
						}
					},
					{
						"y": 40.94488188976378,
						"dataLabels": {
							"enabled": true,
							"format": "52"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.80530973451327,
						"dataLabels": {
							"enabled": true,
							"format": "106"
						}
					},
					{
						"y": 78.76106194690266,
						"dataLabels": {
							"enabled": true,
							"format": "89"
						}
					},
					{
						"y": 76.99115044247787,
						"dataLabels": {
							"enabled": true,
							"format": "87"
						}
					},
					{
						"y": 62.83185840707964,
						"dataLabels": {
							"enabled": true,
							"format": "71"
						}
					},
					{
						"y": 37.16814159292036,
						"dataLabels": {
							"enabled": true,
							"format": "42"
						}
					},
					{
						"y": null
					},
					{
						"y": 74.54545454545455,
						"dataLabels": {
							"enabled": true,
							"format": "41"
						}
					},
					{
						"y": 61.81818181818181,
						"dataLabels": {
							"enabled": true,
							"format": "34"
						}
					},
					{
						"y": 54.54545454545454,
						"dataLabels": {
							"enabled": true,
							"format": "30"
						}
					},
					{
						"y": 50.90909090909091,
						"dataLabels": {
							"enabled": true,
							"format": "28"
						}
					},
					{
						"y": 36.36363636363637,
						"dataLabels": {
							"enabled": true,
							"format": "20"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.937007874015752,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.655737704918034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.834862385321101,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.691588785046733,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40.22988505747126,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.194690265486724,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.0377358490566,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.2471910112359605,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.39080459770115,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40.845070422535215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -25.454545454545453,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.07317073170732,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=127"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=113"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=55"
			}
		],
		"dataTable": {
			"IDU": [
				127,
				122,
				109,
				107,
				87,
				52
			],
			"Non-IDU": [
				113,
				106,
				89,
				87,
				71,
				42
			],
			"Unknown": [
				55,
				41,
				34,
				30,
				28,
				20
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_6.png"
};

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 5.7,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by HSDA, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 94.87179487179486,
						"dataLabels": {
							"enabled": true,
							"format": "37"
						}
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": true,
							"format": "24"
						}
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": true,
							"format": "24"
						}
					},
					{
						"y": 51.28205128205128,
						"dataLabels": {
							"enabled": true,
							"format": "20"
						}
					},
					{
						"y": 30.76923076923077,
						"dataLabels": {
							"enabled": true,
							"format": "12"
						}
					},
					{
						"y": null
					},
					{
						"y": 91.8918918918919,
						"dataLabels": {
							"enabled": true,
							"format": "170"
						}
					},
					{
						"y": 79.45945945945945,
						"dataLabels": {
							"enabled": true,
							"format": "147"
						}
					},
					{
						"y": 77.83783783783784,
						"dataLabels": {
							"enabled": true,
							"format": "144"
						}
					},
					{
						"y": 65.4054054054054,
						"dataLabels": {
							"enabled": true,
							"format": "121"
						}
					},
					{
						"y": 40.54054054054054,
						"dataLabels": {
							"enabled": true,
							"format": "75"
						}
					},
					{
						"y": null
					},
					{
						"y": 88.73239436619718,
						"dataLabels": {
							"enabled": true,
							"format": "63"
						}
					},
					{
						"y": 85.91549295774648,
						"dataLabels": {
							"enabled": true,
							"format": "61"
						}
					},
					{
						"y": 78.87323943661971,
						"dataLabels": {
							"enabled": true,
							"format": "56"
						}
					},
					{
						"y": 63.38028169014085,
						"dataLabels": {
							"enabled": true,
							"format": "45"
						}
					},
					{
						"y": 38.028169014084504,
						"dataLabels": {
							"enabled": true,
							"format": "27"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -5.128205128205132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.13513513513513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.108108108108103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.529411764705879,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0408163265306145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.972222222222221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.01652892561983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -11.267605633802813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1746031746031744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.196721311475407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.64285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Northeast<br>n=39"
			},
			{
				"x": 9,
				"text": "Northern Interior<br>n=185"
			},
			{
				"x": 15,
				"text": "Northwest<br>n=71"
			}
		],
		"dataTable": {
			"Northeast": [
				39,
				37,
				24,
				24,
				20,
				12
			],
			"Northern Interior": [
				185,
				170,
				147,
				144,
				121,
				75
			],
			"Northwest": [
				71,
				63,
				61,
				56,
				45,
				27
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_7.png"
};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 6.1,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					36.36363636363637,
					20,
					16.666666666666664,
					9.090909090909092,
					11.11111111111111,
					33.33333333333333,
					66.66666666666666,
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					27.27272727272727,
					20,
					16.666666666666664,
					9.090909090909092,
					22.22222222222222,
					33.33333333333333,
					66.66666666666666,
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 20,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					18.181818181818183,
					13.333333333333334,
					16.666666666666664,
					9.090909090909092,
					11.11111111111111,
					33.33333333333333,
					33.33333333333333,
					{
						"y": 25,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 30,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					36.36363636363637,
					46.666666666666664,
					58.333333333333336,
					54.54545454545454,
					33.33333333333333,
					33.33333333333333,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					9.090909090909092,
					6.666666666666667,
					8.333333333333332,
					0,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					36.36363636363637,
					26.666666666666668,
					33.33333333333333,
					27.27272727272727,
					11.11111111111111,
					33.33333333333333,
					33.33333333333333,
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					11,
					15,
					12,
					11,
					9,
					3,
					3,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_6_1.png"
};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 6.2,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					5,
					3,
					4,
					4,
					1,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					6,
					5,
					4,
					3,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					1,
					2,
					2,
					1,
					1,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					1,
					0,
					0,
					1,
					1,
					2,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					2,
					2,
					1,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					15,
					12,
					11,
					9,
					3,
					3,
					4
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_6_2.png"
};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 7,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					1,
					3,
					1,
					1,
					0,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3,
					6,
					7,
					3,
					5,
					12,
					5,
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_7.png"
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "nha",
	"id": 8,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in Northern Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					0,
					1,
					0,
					0,
					1,
					0,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					0,
					0,
					1,
					1,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					0,
					0,
					1,
					0,
					0,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					0,
					0,
					1,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 1230,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					0,
					850,
					130,
					{
						"y": 410,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					880,
					0,
					465
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					0,
					1,
					3,
					1,
					1,
					0,
					4
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_nha_8.png"
};

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 10,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 26,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					52,
					38,
					33,
					34,
					25,
					24,
					33
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					4,
					11,
					7,
					5,
					10,
					6,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": -15,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					3,
					3,
					3,
					1,
					0,
					0,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					2,
					1,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 32,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					61,
					53,
					43,
					40,
					35,
					30,
					47
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_10.png"
};

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 11,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 2948,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					2833,
					2772,
					2907,
					2897,
					2852,
					2819,
					2922
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 281,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					288,
					315,
					311,
					307,
					302,
					304,
					317
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					12,
					12,
					12,
					6,
					10,
					11,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 66,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					58,
					66,
					57,
					63,
					64,
					54,
					66
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					15,
					21,
					15,
					13,
					9,
					8,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					3,
					4,
					2,
					1,
					2,
					2,
					5
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 3308,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					3209,
					3190,
					3304,
					3287,
					3239,
					3198,
					3330
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_11.png"
};

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 12,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Vancouver Coastal Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					50,
					37,
					37,
					29,
					24,
					27,
					{
						"y": 17,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					4.5,
					3.3,
					3.3,
					2.6,
					2.1,
					2.3,
					{
						"y": 1.5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					69,
					53,
					48,
					44,
					39,
					32,
					{
						"y": 32,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					6.3,
					4.8,
					4.3,
					3.9,
					3.4,
					2.7,
					{
						"y": 2.7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					55,
					36,
					40,
					35,
					39,
					43,
					{
						"y": 21,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					5,
					3.3,
					3.6,
					3.1,
					3.4,
					3.7,
					{
						"y": 1.8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_12.png"
};

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 13,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_13.png"
};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Vancouver Coastal Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					38.366,
					43.013,
					41.587,
					45.53,
					44.835,
					45.524,
					44.664,
					49.02,
					48.049,
					46.655,
					45.173,
					48.515,
					47.129,
					46.484,
					44.567,
					48.648,
					47.758,
					46.6,
					45.133,
					{
						"y": 48.23,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_1.png"
};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for Vancouver Coastal Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					17.88,
					20.058,
					19.598,
					21.848,
					21.645,
					21.823,
					21.21,
					23.017,
					23.072,
					22.226,
					20.961,
					22.596,
					22.128,
					21.893,
					20.811,
					22.113,
					21.914,
					21.133,
					20.452,
					{
						"y": 21.712,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					18.304,
					20.399,
					19.835,
					21.746,
					21.416,
					21.892,
					21.693,
					24.109,
					23.334,
					22.681,
					22.298,
					23.926,
					23.387,
					22.862,
					22.115,
					24.874,
					24.365,
					23.768,
					23.29,
					{
						"y": 25.297,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.177,
					0.198,
					0.145,
					0.199,
					0.204,
					0.161,
					0.188,
					0.182,
					0.202,
					0.183,
					0.244,
					0.378,
					0.374,
					0.37,
					0.349,
					0.521,
					0.556,
					0.77,
					0.675,
					{
						"y": 0.826,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_2.png"
};

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Vancouver Coastal Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					9.016,
					10.224,
					9.886,
					10.185,
					10.288,
					11.393,
					11.087,
					11.15,
					11.253,
					11.635,
					11.133,
					11.224,
					11.535,
					12.553,
					11.676,
					11.904,
					12.603,
					13.234,
					12.811,
					{
						"y": 13.015,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7.589,
					8.139,
					7.682,
					8.848,
					8.943,
					9.152,
					8.637,
					9.942,
					9.773,
					9.402,
					8.836,
					10.031,
					9.846,
					9.758,
					9.371,
					10.557,
					10.689,
					10.408,
					10.061,
					{
						"y": 11.436,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5.685,
					6.105,
					5.941,
					6.543,
					6.378,
					6.461,
					6.307,
					7.075,
					6.911,
					6.422,
					6.202,
					6.529,
					6.474,
					6.245,
					5.998,
					6.778,
					6.443,
					5.936,
					6.143,
					{
						"y": 6.567,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					13.96,
					16.051,
					15.976,
					18.081,
					17.521,
					16.756,
					16.951,
					19.022,
					18.549,
					17.515,
					17.155,
					18.807,
					17.746,
					16.259,
					15.958,
					17.914,
					16.787,
					15.703,
					15.111,
					{
						"y": 16.475,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_3.png"
};

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.4,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for Vancouver Coastal Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					2.005,
					2.358,
					2.009,
					1.737,
					1.57,
					1.648,
					1.573,
					1.712,
					1.441,
					1.565,
					1.67,
					1.615,
					1.24,
					1.359,
					1.292,
					1.14,
					0.923,
					0.929,
					0.716,
					{
						"y": 0.395,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_4.png"
};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4.347,
					4.825,
					5.33,
					5.815,
					5.625,
					6.122,
					5.979,
					6.242,
					6.086,
					6.37,
					6.317,
					6.986,
					6.923,
					6.818,
					6.728,
					7.481,
					5.644,
					4.674,
					4.048,
					{
						"y": 4.337,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4.789,
					4.835,
					4.664,
					5.126,
					4.489,
					4.23,
					4.781,
					5.719,
					5.501,
					5.294,
					5.342,
					5.459,
					4.669,
					5.029,
					4.795,
					5.398,
					5.432,
					5.326,
					5.39,
					{
						"y": 5.773,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					29.23,
					33.353,
					31.593,
					34.589,
					34.721,
					35.148,
					33.904,
					37.059,
					36.459,
					34.99,
					33.488,
					36.07,
					35.537,
					34.637,
					33.044,
					35.767,
					36.682,
					36.6,
					35.695,
					{
						"y": 38.12,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_5.png"
};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.6,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2.239,
					2.477,
					2.799,
					3.095,
					2.959,
					3.276,
					3.157,
					3.149,
					3.203,
					3.344,
					3.277,
					3.687,
					3.778,
					3.648,
					3.579,
					3.976,
					3.007,
					2.482,
					2.034,
					{
						"y": 2.175,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.585,
					2.57,
					2.438,
					2.754,
					2.454,
					2.25,
					2.578,
					3.038,
					3.073,
					2.908,
					2.839,
					2.884,
					2.452,
					2.693,
					2.585,
					2.775,
					2.879,
					2.803,
					2.915,
					{
						"y": 3.024,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					13.056,
					15.011,
					14.361,
					15.999,
					16.232,
					16.297,
					15.475,
					16.83,
					16.796,
					15.974,
					14.845,
					16.025,
					15.898,
					15.552,
					14.647,
					15.362,
					16.028,
					15.848,
					15.503,
					{
						"y": 16.513,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_6.png"
};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 1.7,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2.06,
					2.241,
					2.503,
					2.673,
					2.626,
					2.821,
					2.79,
					3.035,
					2.854,
					2.996,
					3.022,
					3.272,
					3.121,
					3.157,
					3.128,
					3.498,
					2.617,
					2.178,
					1.996,
					{
						"y": 2.147,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.186,
					2.253,
					2.207,
					2.368,
					2.032,
					1.976,
					2.197,
					2.679,
					2.425,
					2.385,
					2.5,
					2.57,
					2.214,
					2.335,
					2.208,
					2.603,
					2.553,
					2.521,
					2.47,
					{
						"y": 2.749,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					14.058,
					15.905,
					15.125,
					16.705,
					16.758,
					17.095,
					16.706,
					18.395,
					18.055,
					17.3,
					16.776,
					18.084,
					18.052,
					17.37,
					16.779,
					18.773,
					19.195,
					19.069,
					18.824,
					{
						"y": 20.401,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_1_7.png"
};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 2.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Vancouver Coastal Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2668.8252301156476,
					2668.3267329967225,
					2773.817192238378,
					3270.705590017698,
					4071.720348994435,
					6388.317941209595,
					8196.68099071338,
					8583.838072990251,
					8996.626526157477,
					{
						"y": 7496.188642326985,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1762.2769885994753,
					1839.7886874198507,
					1910.704537221749,
					2427.3530077741716,
					3044.1747548740022,
					7975.261047288788,
					8615.994890241032,
					9016.01148204067,
					8192.983176223246,
					{
						"y": 8710.798253243622,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					5487.577306459544,
					5494.87249698871,
					5777.638335543213,
					7931.187903159546,
					11258.939525992595,
					12501.04147572945,
					13802.727704521294,
					13885.672301531593,
					13692.651703360612,
					{
						"y": 14225.35459224093,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					4125.812037455745,
					4140.310731825397,
					4342.639850787271,
					5797.376213961661,
					8021.480793922817,
					10179.669338895044,
					11488.312989229491,
					11699.598737743832,
					11533.309047819079,
					{
						"y": 11567.565845512043,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_1.png"
};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 2.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for Vancouver Coastal Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					3547.8001534713367,
					3531.3736857549793,
					3737.2274734219236,
					5313.277233744587,
					7692.454241891011,
					9862.438637513504,
					11295.887738000945,
					11383.922583760293,
					11097.21637907332,
					{
						"y": 10984.032421213036,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4397.860500297153,
					4470.781959557682,
					4658.359457689548,
					6123.611558201527,
					8255.784370285697,
					10389.497893674306,
					11567.24896906581,
					11901.636094587098,
					11752.30971296218,
					{
						"y": 11771.67836000877,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_2.png"
};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 2.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Vancouver Coastal Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4310.523295274384,
					4296.8851143160455,
					4495.821099583813,
					5484.071092790784,
					6604.916942150891,
					7584.350029632355,
					8443.885311238406,
					8681.535566736206,
					8896.487726746922,
					{
						"y": 9472.521332140595,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7339.1271198051,
					7557.498823515396,
					7670.024280597158,
					9438.834026384977,
					12019.63909669463,
					13991.712944655537,
					15760.339025874839,
					16384.346618650623,
					16383.412267016085,
					{
						"y": 16639.794836280216,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					4523.555817538769,
					4442.830848207501,
					4655.287704146975,
					6190.186801765217,
					8887.547099703323,
					10774.506158631231,
					11983.008628055017,
					12218.234900553494,
					11765.50413896051,
					{
						"y": 11648.84041088637,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1877.2685067949692,
					1948.1072351598614,
					2234.5294103503275,
					4232.160987165803,
					7360.97221343123,
					10911.53112109832,
					12486.278486340667,
					12478.271521401823,
					11839.081512135723,
					{
						"y": 11275.77189418512,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_3.png"
};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 3.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					49,
					32,
					27,
					38,
					34,
					33,
					24,
					21,
					32,
					36,
					29,
					27,
					24,
					26,
					18,
					31,
					16,
					19,
					24,
					16
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					54,
					36,
					32,
					45,
					40,
					35,
					23,
					22,
					36,
					44,
					31,
					33,
					24,
					27,
					19,
					37,
					22,
					23,
					34,
					19
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_1.png"
};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 3.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4,
					3,
					3,
					4,
					1,
					5,
					5,
					2,
					5,
					4,
					2,
					0,
					2,
					2,
					3,
					3,
					2,
					2,
					0,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					44,
					29,
					24,
					34,
					33,
					28,
					19,
					19,
					27,
					32,
					27,
					27,
					22,
					24,
					14,
					28,
					14,
					17,
					23,
					{
						"y": 13,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_2.png"
};

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 3.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 4,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					12,
					6,
					9,
					9,
					9,
					10,
					5,
					6,
					9,
					8,
					10,
					9,
					9,
					8,
					6,
					8,
					2,
					3,
					10,
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					16,
					13,
					7,
					9,
					9,
					9,
					5,
					8,
					8,
					14,
					13,
					10,
					5,
					9,
					5,
					9,
					3,
					10,
					7,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					7,
					5,
					5,
					6,
					9,
					4,
					6,
					4,
					5,
					3,
					3,
					4,
					6,
					6,
					4,
					9,
					5,
					3,
					2,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					14,
					8,
					6,
					14,
					7,
					10,
					8,
					3,
					10,
					11,
					3,
					4,
					4,
					3,
					3,
					5,
					5,
					3,
					5,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_3.png"
};

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 3.4,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					20,
					28,
					36,
					21,
					18,
					26,
					26,
					22,
					13,
					16,
					22,
					27,
					19,
					24,
					15,
					19,
					11,
					21,
					6,
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2,
					4,
					3,
					2,
					1,
					2,
					2,
					4,
					3,
					0,
					1,
					2,
					3,
					2,
					3,
					3,
					5,
					4,
					3,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 3,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2,
					4,
					7,
					6,
					4,
					6,
					5,
					6,
					6,
					4,
					5,
					5,
					5,
					0,
					4,
					3,
					1,
					3,
					2,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					2,
					2,
					2,
					0,
					1,
					0,
					0,
					2,
					1,
					1,
					0,
					0,
					1,
					0,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					1,
					1,
					3,
					1,
					2,
					2,
					1,
					0,
					2,
					1,
					2,
					1,
					1,
					1,
					2,
					0,
					1,
					3,
					5,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -5,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_4.png"
};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 3.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Vancouver Coastal Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "North Shore / Coast Garibaldi",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					3,
					3,
					3,
					2,
					0,
					1,
					5,
					0,
					3,
					3,
					3,
					3,
					1,
					0,
					0,
					4,
					1,
					1,
					3,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Shore / Coast Garibaldi</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Richmond",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					1,
					2,
					0,
					1,
					4,
					2,
					0,
					0,
					4,
					1,
					2,
					2,
					3,
					0,
					1,
					0,
					0,
					1,
					3,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Richmond</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Vancouver",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					45,
					27,
					24,
					35,
					30,
					30,
					19,
					21,
					25,
					32,
					24,
					22,
					20,
					26,
					17,
					27,
					15,
					17,
					18,
					{
						"y": 15,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					2,
					3,
					3,
					2,
					2,
					1,
					4,
					0,
					2,
					3,
					3,
					2,
					1,
					2,
					0,
					3,
					0,
					1,
					3,
					1
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					1,
					3,
					0,
					1,
					2,
					2,
					0,
					0,
					6,
					2,
					1,
					3,
					2,
					0,
					1,
					0,
					0,
					1,
					1,
					1
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					51,
					30,
					29,
					42,
					36,
					32,
					19,
					22,
					28,
					39,
					27,
					28,
					21,
					25,
					18,
					34,
					22,
					21,
					30,
					17
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_3_5.png"
};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 4.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for Vancouver Coastal Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 35,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					46,
					45,
					42,
					34
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 39,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					42,
					28,
					25,
					24
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 33,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					17,
					13,
					17,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					19,
					19,
					14,
					13
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 30,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					23,
					24,
					22,
					13
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"Vancouver Coastal Health"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						35,
						46,
						45,
						42,
						34
					]
				},
				{
					"name": "Stage 1",
					"data": [
						39,
						42,
						28,
						25,
						24
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						33,
						17,
						13,
						17,
						10
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						16,
						19,
						19,
						14,
						13
					]
				},
				{
					"name": "Stage 3",
					"data": [
						30,
						23,
						24,
						22,
						13
					]
				},
				{
					"name": "Unknown",
					"data": [
						4,
						12,
						11,
						14,
						8
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						157,
						159,
						140,
						134,
						102
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_4_1.png"
};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 4.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for Vancouver Coastal Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					2,
					8,
					2,
					2,
					{
						"y": 1,
						"color": "white"
					},
					33,
					44,
					37,
					40,
					31
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					8,
					4,
					5,
					1,
					{
						"y": 1,
						"color": "white"
					},
					36,
					34,
					24,
					20,
					23
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					2,
					null,
					2,
					{
						"y": 1,
						"color": "white"
					},
					30,
					15,
					11,
					17,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					2,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					13,
					19,
					16,
					13,
					13
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					5,
					3,
					3,
					null,
					{
						"y": 1,
						"color": "white"
					},
					27,
					18,
					21,
					19,
					13
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						1,
						2,
						8,
						2,
						2,
						33,
						44,
						37,
						40,
						31
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						8,
						4,
						5,
						1,
						36,
						34,
						24,
						20,
						23
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						3,
						2,
						2,
						0,
						2,
						30,
						15,
						11,
						17,
						8
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						3,
						0,
						2,
						1,
						0,
						13,
						19,
						16,
						13,
						13
					]
				},
				{
					"name": "Stage 3",
					"data": [
						3,
						5,
						3,
						3,
						0,
						27,
						18,
						21,
						19,
						13
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						1,
						0,
						5,
						2,
						4,
						11,
						11,
						9,
						6
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						13,
						18,
						19,
						16,
						7,
						143,
						141,
						120,
						118,
						94
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_4_2.png"
};

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 4.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Vancouver Coastal Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 13,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					19,
					13,
					14,
					17,
					{
						"y": 1,
						"color": "white"
					},
					12,
					14,
					15,
					15,
					9,
					{
						"y": 1,
						"color": "white"
					},
					8,
					8,
					5,
					4,
					4,
					{
						"y": 1,
						"color": "white"
					},
					2,
					5,
					12,
					9,
					4
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					9,
					9,
					5,
					5,
					{
						"y": 1,
						"color": "white"
					},
					12,
					14,
					6,
					12,
					12,
					{
						"y": 1,
						"color": "white"
					},
					4,
					9,
					6,
					2,
					6,
					{
						"y": 1,
						"color": "white"
					},
					7,
					10,
					7,
					6,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					5,
					7,
					5,
					{
						"y": 1,
						"color": "white"
					},
					9,
					2,
					2,
					5,
					2,
					{
						"y": 1,
						"color": "white"
					},
					6,
					6,
					3,
					2,
					2,
					{
						"y": 1,
						"color": "white"
					},
					11,
					7,
					3,
					3,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					3,
					3,
					2,
					5,
					{
						"y": 1,
						"color": "white"
					},
					10,
					6,
					6,
					5,
					3,
					{
						"y": 1,
						"color": "white"
					},
					4,
					5,
					3,
					3,
					3,
					{
						"y": 1,
						"color": "white"
					},
					2,
					5,
					7,
					4,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					3,
					3,
					2,
					1,
					{
						"y": 1,
						"color": "white"
					},
					2,
					6,
					3,
					5,
					4,
					{
						"y": 1,
						"color": "white"
					},
					15,
					4,
					5,
					5,
					2,
					{
						"y": 1,
						"color": "white"
					},
					11,
					10,
					13,
					10,
					6
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						13,
						19,
						13,
						14,
						17,
						12,
						14,
						15,
						15,
						9,
						8,
						8,
						5,
						4,
						4,
						2,
						5,
						12,
						9,
						4
					]
				},
				{
					"name": "Stage 1",
					"data": [
						16,
						9,
						9,
						5,
						5,
						12,
						14,
						6,
						12,
						12,
						4,
						9,
						6,
						2,
						6,
						7,
						10,
						7,
						6,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						7,
						2,
						5,
						7,
						5,
						9,
						2,
						2,
						5,
						2,
						6,
						6,
						3,
						2,
						2,
						11,
						7,
						3,
						3,
						1
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						3,
						3,
						2,
						5,
						10,
						6,
						6,
						5,
						3,
						4,
						5,
						3,
						3,
						3,
						2,
						5,
						7,
						4,
						2
					]
				},
				{
					"name": "Stage 3",
					"data": [
						2,
						3,
						3,
						2,
						1,
						2,
						6,
						3,
						5,
						4,
						15,
						4,
						5,
						5,
						2,
						11,
						10,
						13,
						10,
						6
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						2,
						1,
						3,
						0,
						1,
						6,
						3,
						6,
						6,
						0,
						2,
						4,
						3,
						2,
						3,
						2,
						3,
						2,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						38,
						38,
						34,
						33,
						33,
						46,
						48,
						35,
						48,
						36,
						37,
						34,
						26,
						19,
						19,
						36,
						39,
						45,
						34,
						14
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_4_3.png"
};

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 4.4,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for Vancouver Coastal Health <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 26,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					42,
					31,
					38,
					26,
					{
						"y": 1,
						"color": "white"
					},
					6,
					3,
					4,
					1,
					4,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					10,
					1,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 30,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					27,
					21,
					18,
					19,
					{
						"y": 1,
						"color": "white"
					},
					3,
					6,
					null,
					2,
					2,
					{
						"y": 1,
						"color": "white"
					},
					4,
					8,
					6,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 24,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					12,
					9,
					11,
					7,
					{
						"y": 1,
						"color": "white"
					},
					4,
					null,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					4,
					3,
					2,
					4,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 12,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					12,
					13,
					10,
					9,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					3,
					null,
					3,
					{
						"y": 1,
						"color": "white"
					},
					3,
					4,
					2,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					9,
					10,
					10,
					11,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					3,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					11,
					9,
					9,
					7,
					2
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						26,
						42,
						31,
						38,
						26,
						6,
						3,
						4,
						1,
						4,
						3,
						1,
						10,
						1,
						2,
						0,
						0,
						0,
						1,
						1,
						0,
						0,
						0,
						1,
						1
					]
				},
				{
					"name": "Stage 1",
					"data": [
						30,
						27,
						21,
						18,
						19,
						3,
						6,
						0,
						2,
						2,
						4,
						8,
						6,
						4,
						1,
						0,
						1,
						0,
						1,
						0,
						2,
						0,
						1,
						0,
						2
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						24,
						12,
						9,
						11,
						7,
						4,
						0,
						0,
						0,
						1,
						4,
						3,
						2,
						4,
						2,
						0,
						0,
						1,
						1,
						0,
						1,
						2,
						1,
						1,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						12,
						12,
						13,
						10,
						9,
						0,
						2,
						3,
						0,
						3,
						3,
						4,
						2,
						4,
						1,
						0,
						0,
						1,
						0,
						0,
						1,
						1,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						16,
						9,
						10,
						10,
						11,
						1,
						0,
						3,
						2,
						0,
						11,
						9,
						9,
						7,
						2,
						0,
						3,
						1,
						1,
						0,
						2,
						2,
						1,
						2,
						0
					]
				},
				{
					"name": "Unknown",
					"data": [
						3,
						9,
						7,
						7,
						4,
						0,
						0,
						0,
						0,
						1,
						0,
						1,
						1,
						6,
						2,
						1,
						0,
						1,
						0,
						0,
						0,
						2,
						2,
						1,
						1
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						111,
						111,
						91,
						94,
						76,
						14,
						11,
						10,
						5,
						11,
						25,
						26,
						30,
						26,
						10,
						1,
						4,
						4,
						4,
						1,
						6,
						7,
						5,
						5,
						4
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_4_4.png"
};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Vancouver Coastal Health, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.70284661069016,
						"dataLabels": {
							"enabled": true,
							"format": "4722"
						}
					},
					{
						"y": 85.31640385009216,
						"dataLabels": {
							"enabled": true,
							"format": "4166"
						}
					},
					{
						"y": 81.93733360638952,
						"dataLabels": {
							"enabled": true,
							"format": "4001"
						}
					},
					{
						"y": 76.26459143968872,
						"dataLabels": {
							"enabled": true,
							"format": "3724"
						}
					},
					{
						"y": 66.63936104853573,
						"dataLabels": {
							"enabled": true,
							"format": "3254"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.297153389309848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.774671749258792,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9606337013922244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.923269182704328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.620837808807739,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=4883"
			}
		],
		"dataTable": {
			"Overall HA": [
				4883,
				4722,
				4166,
				4001,
				3724,
				3254
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_1.png"
};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Vancouver Coastal Health by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.4766355140187,
						"dataLabels": {
							"enabled": true,
							"format": "4172",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.32710280373831,
						"dataLabels": {
							"enabled": true,
							"format": "3652",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.10280373831776,
						"dataLabels": {
							"enabled": true,
							"format": "3514",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.07943925233644,
						"dataLabels": {
							"enabled": true,
							"format": "3299",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.24766355140187,
						"dataLabels": {
							"enabled": true,
							"format": "2921",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 91.21061359867329,
						"dataLabels": {
							"enabled": true,
							"format": "550",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.24046434494196,
						"dataLabels": {
							"enabled": true,
							"format": "514",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.76285240464345,
						"dataLabels": {
							"enabled": true,
							"format": "487",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.48092868988391,
						"dataLabels": {
							"enabled": true,
							"format": "425",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 55.223880597014926,
						"dataLabels": {
							"enabled": true,
							"format": "333",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.5233644859813054,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.464046021093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.7787513691128094,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.11838360842345,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.458017581085178,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -8.789386401326704,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.545454545454543,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.252918287937747,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.73100616016427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.64705882352941,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=4280"
			},
			{
				"x": 9,
				"text": "Women<br>n=603"
			}
		],
		"dataTable": {
			"Men": [
				4280,
				4172,
				3652,
				3514,
				3299,
				2921
			],
			"Women": [
				603,
				550,
				514,
				487,
				425,
				333
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_2.png"
};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 69.5,
						"dataLabels": {
							"enabled": true,
							"format": "139",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62,
						"dataLabels": {
							"enabled": true,
							"format": "124",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.5,
						"dataLabels": {
							"enabled": true,
							"format": "119",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49,
						"dataLabels": {
							"enabled": true,
							"format": "98",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 42,
						"dataLabels": {
							"enabled": true,
							"format": "84",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.41791044776119,
						"dataLabels": {
							"enabled": true,
							"format": "646",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.43283582089552,
						"dataLabels": {
							"enabled": true,
							"format": "559",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.8507462686567,
						"dataLabels": {
							"enabled": true,
							"format": "535",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.49253731343283,
						"dataLabels": {
							"enabled": true,
							"format": "479",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.23880597014926,
						"dataLabels": {
							"enabled": true,
							"format": "417",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.83301343570058,
						"dataLabels": {
							"enabled": true,
							"format": "1009",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.02879078694818,
						"dataLabels": {
							"enabled": true,
							"format": "886",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.28598848368523,
						"dataLabels": {
							"enabled": true,
							"format": "847",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.76007677543186,
						"dataLabels": {
							"enabled": true,
							"format": "779",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.43570057581574,
						"dataLabels": {
							"enabled": true,
							"format": "661",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.58633456748571,
						"dataLabels": {
							"enabled": true,
							"format": "2929",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.41164591046785,
						"dataLabels": {
							"enabled": true,
							"format": "2597",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.14675193537529,
						"dataLabels": {
							"enabled": true,
							"format": "2500",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.70380343318749,
						"dataLabels": {
							"enabled": true,
							"format": "2368",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.41400201952204,
						"dataLabels": {
							"enabled": true,
							"format": "2092",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -30.500000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.79136690647482,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.0322580645161255,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5820895522388096,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.46749226006192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.2933810375670785,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.467289719626171,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.943632567849683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1669865642994233,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.190287413280476,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.401805869074494,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.028335301062572,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.14762516046213,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4136654325142994,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.334926596107886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.73507893723527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.279999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.655405405405405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=200"
			},
			{
				"x": 9,
				"text": "30–39<br>n=670"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1042"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=2971"
			}
		],
		"dataTable": {
			"< 30": [
				200,
				139,
				124,
				119,
				98,
				84
			],
			"30–39": [
				670,
				646,
				559,
				535,
				479,
				417
			],
			"40–49": [
				1042,
				1009,
				886,
				847,
				779,
				661
			],
			"≥ 50": [
				2971,
				2929,
				2597,
				2500,
				2368,
				2092
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.4,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.50220264317181,
						"dataLabels": {
							"enabled": true,
							"format": "2236"
						}
					},
					{
						"y": 89.95594713656388,
						"dataLabels": {
							"enabled": true,
							"format": "2042"
						}
					},
					{
						"y": 86.6079295154185,
						"dataLabels": {
							"enabled": true,
							"format": "1966"
						}
					},
					{
						"y": 81.71806167400881,
						"dataLabels": {
							"enabled": true,
							"format": "1855"
						}
					},
					{
						"y": 74.00881057268722,
						"dataLabels": {
							"enabled": true,
							"format": "1680"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.8391376451078,
						"dataLabels": {
							"enabled": true,
							"format": "1192"
						}
					},
					{
						"y": 93.61525704809287,
						"dataLabels": {
							"enabled": true,
							"format": "1129"
						}
					},
					{
						"y": 88.80597014925374,
						"dataLabels": {
							"enabled": true,
							"format": "1071"
						}
					},
					{
						"y": 79.60199004975125,
						"dataLabels": {
							"enabled": true,
							"format": "960"
						}
					},
					{
						"y": 62.43781094527363,
						"dataLabels": {
							"enabled": true,
							"format": "753"
						}
					},
					{
						"y": null
					},
					{
						"y": 91.96872778962332,
						"dataLabels": {
							"enabled": true,
							"format": "1294"
						}
					},
					{
						"y": 70.78891257995735,
						"dataLabels": {
							"enabled": true,
							"format": "996"
						}
					},
					{
						"y": 68.51457000710732,
						"dataLabels": {
							"enabled": true,
							"format": "964"
						}
					},
					{
						"y": 64.60554371002132,
						"dataLabels": {
							"enabled": true,
							"format": "909"
						}
					},
					{
						"y": 58.35110163468372,
						"dataLabels": {
							"enabled": true,
							"format": "821"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.49779735682819,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.676207513416811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.72184133202742,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.645981688708035,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.433962264150942,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1608623548922004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.285234899328861,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.137289636846765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.364145658263302,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.562499999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.031272210376683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.02936630602782,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.2128514056224855,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.705394190871371,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.680968096809684,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=2270"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=1206"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=1407"
			}
		],
		"dataTable": {
			"MSM": [
				2270,
				2236,
				2042,
				1966,
				1855,
				1680
			],
			"Non-MSM": [
				1206,
				1192,
				1129,
				1071,
				960,
				753
			],
			"Unknown": [
				1407,
				1294,
				996,
				964,
				909,
				821
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_4.png"
};

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 94.9367088607595,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#043f61"
					},
					{
						"y": 88.60759493670885,
						"dataLabels": {
							"enabled": false,
							"format": "70"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.81012658227847,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.88607594936708,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 64.55696202531645,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.32710280373831,
						"dataLabels": {
							"enabled": false,
							"format": "306"
						},
						"color": "#043f61"
					},
					{
						"y": 81.93146417445483,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.12772585669782,
						"dataLabels": {
							"enabled": false,
							"format": "254"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.02803738317756,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#09472e"
					},
					{
						"y": 64.48598130841121,
						"dataLabels": {
							"enabled": false,
							"format": "207"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.57869249394673,
						"dataLabels": {
							"enabled": false,
							"format": "403"
						},
						"color": "#043f61"
					},
					{
						"y": 89.10411622276028,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.50363196125909,
						"dataLabels": {
							"enabled": false,
							"format": "349"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.90314769975787,
						"dataLabels": {
							"enabled": false,
							"format": "330"
						},
						"color": "#09472e"
					},
					{
						"y": 70.46004842615012,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.7254632807138,
						"dataLabels": {
							"enabled": false,
							"format": "1453"
						},
						"color": "#043f61"
					},
					{
						"y": 92.03843514070007,
						"dataLabels": {
							"enabled": false,
							"format": "1341"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.94989704873026,
						"dataLabels": {
							"enabled": false,
							"format": "1296"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.17501715854495,
						"dataLabels": {
							"enabled": false,
							"format": "1241"
						},
						"color": "#09472e"
					},
					{
						"y": 77.62525737817433,
						"dataLabels": {
							"enabled": false,
							"format": "1131"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0d4440"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.01324503311258,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#043f61"
					},
					{
						"y": 92.05298013245033,
						"dataLabels": {
							"enabled": false,
							"format": "139"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.43046357615894,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.86092715231787,
						"dataLabels": {
							"enabled": false,
							"format": "107"
						},
						"color": "#09472e"
					},
					{
						"y": 54.3046357615894,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.67986798679867,
						"dataLabels": {
							"enabled": false,
							"format": "299"
						},
						"color": "#043f61"
					},
					{
						"y": 91.0891089108911,
						"dataLabels": {
							"enabled": false,
							"format": "276"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.79867986798679,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.24752475247524,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#09472e"
					},
					{
						"y": 56.10561056105611,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.0450204638472,
						"dataLabels": {
							"enabled": false,
							"format": "726"
						},
						"color": "#043f61"
					},
					{
						"y": 94.6793997271487,
						"dataLabels": {
							"enabled": false,
							"format": "694"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.17735334242838,
						"dataLabels": {
							"enabled": false,
							"format": "661"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.4924965893588,
						"dataLabels": {
							"enabled": false,
							"format": "612"
						},
						"color": "#09472e"
					},
					{
						"y": 66.9849931787176,
						"dataLabels": {
							"enabled": false,
							"format": "491"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 44,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 35,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 34,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 28.999999999999996,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#09472e"
					},
					{
						"y": 23,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.4824120603015,
						"dataLabels": {
							"enabled": false,
							"format": "192"
						},
						"color": "#043f61"
					},
					{
						"y": 78.89447236180904,
						"dataLabels": {
							"enabled": false,
							"format": "157"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.38190954773869,
						"dataLabels": {
							"enabled": false,
							"format": "152"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.36180904522614,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#09472e"
					},
					{
						"y": 64.321608040201,
						"dataLabels": {
							"enabled": false,
							"format": "128"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.18960244648318,
						"dataLabels": {
							"enabled": false,
							"format": "308"
						},
						"color": "#043f61"
					},
					{
						"y": 74.00611620795107,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.86544342507645,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.58409785932722,
						"dataLabels": {
							"enabled": false,
							"format": "221"
						},
						"color": "#09472e"
					},
					{
						"y": 61.16207951070336,
						"dataLabels": {
							"enabled": false,
							"format": "200"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.03072983354673,
						"dataLabels": {
							"enabled": false,
							"format": "750"
						},
						"color": "#043f61"
					},
					{
						"y": 71.83098591549296,
						"dataLabels": {
							"enabled": false,
							"format": "561"
						},
						"color": "#0c4250"
					},
					{
						"y": 69.52624839948783,
						"dataLabels": {
							"enabled": false,
							"format": "543"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.94110115236876,
						"dataLabels": {
							"enabled": false,
							"format": "515"
						},
						"color": "#09472e"
					},
					{
						"y": 60.179257362355955,
						"dataLabels": {
							"enabled": false,
							"format": "470"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -5.063291139240511,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.285714285714281,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.417910447761198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.92857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.672897196261683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.052287581699341,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4220532319391594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.236220472440948,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.210526315789469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.421307506053272,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.684863523573206,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.163043478260865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.444126074498568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.818181818181817,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.27453671928620027,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.708189951823807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3557046979865723,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.243827160493829,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.863819500402903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.076923076923073,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9867549668874163,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.081081081081086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.194244604316546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.05426356589147,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.364485981308412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.320132013201325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.710144927536231,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.307984790874528,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.438596491228072,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.9549795361528002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.40771349862259,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.7550432276657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.413010590015123,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.771241830065357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -56.00000000000001,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.45454545454546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.68965517241379,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5175879396984966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.229166666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1847133757961776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.810397553516822,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.892561983471076,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.957446808510635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.502262443438914,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.969270166453265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.2,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.208556149732622,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.156537753222834,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.737864077669899,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=79"
			},
			{
				"x": 9,
				"text": "30-39<br>n=321"
			},
			{
				"x": 15,
				"text": "40-49<br>n=413"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1457"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=20"
			},
			{
				"x": 34,
				"text": "30-39<br>n=151"
			},
			{
				"x": 40,
				"text": "40-49<br>n=303"
			},
			{
				"x": 46,
				"text": ">=50<br>n=733"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=100"
			},
			{
				"x": 59,
				"text": "30-39<br>n=199"
			},
			{
				"x": 65,
				"text": "40-49<br>n=327"
			},
			{
				"x": 71,
				"text": ">=50<br>n=781"
			}
		],
		"dataTable": {
			"MSM:<30": [
				79,
				75,
				70,
				67,
				56,
				51
			],
			"MSM:30-39": [
				321,
				306,
				263,
				254,
				228,
				207
			],
			"MSM:40-49": [
				413,
				403,
				368,
				349,
				330,
				291
			],
			"MSM:>=50": [
				1457,
				1453,
				1341,
				1296,
				1241,
				1131
			],
			"Non-MSM:<30": [
				20,
				20,
				19,
				18,
				13,
				10
			],
			"Non-MSM:30-39": [
				151,
				148,
				139,
				129,
				107,
				82
			],
			"Non-MSM:40-49": [
				303,
				299,
				276,
				263,
				228,
				170
			],
			"Non-MSM:>=50": [
				733,
				726,
				694,
				661,
				612,
				491
			],
			"Unknown:<30": [
				100,
				44,
				35,
				34,
				29,
				23
			],
			"Unknown:30-39": [
				199,
				192,
				157,
				152,
				144,
				128
			],
			"Unknown:40-49": [
				327,
				308,
				242,
				235,
				221,
				200
			],
			"Unknown:>=50": [
				781,
				750,
				561,
				543,
				515,
				470
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.6,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.92294946147473,
						"dataLabels": {
							"enabled": true,
							"format": "1194"
						}
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": true,
							"format": "1136"
						}
					},
					{
						"y": 89.31234465617233,
						"dataLabels": {
							"enabled": true,
							"format": "1078"
						}
					},
					{
						"y": 79.61888980944491,
						"dataLabels": {
							"enabled": true,
							"format": "961"
						}
					},
					{
						"y": 62.46893123446562,
						"dataLabels": {
							"enabled": true,
							"format": "754"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.55015673981191,
						"dataLabels": {
							"enabled": true,
							"format": "2515"
						}
					},
					{
						"y": 89.96865203761756,
						"dataLabels": {
							"enabled": true,
							"format": "2296"
						}
					},
					{
						"y": 86.79467084639498,
						"dataLabels": {
							"enabled": true,
							"format": "2215"
						}
					},
					{
						"y": 82.13166144200626,
						"dataLabels": {
							"enabled": true,
							"format": "2096"
						}
					},
					{
						"y": 74.33385579937304,
						"dataLabels": {
							"enabled": true,
							"format": "1897"
						}
					},
					{
						"y": null
					},
					{
						"y": 90.04444444444445,
						"dataLabels": {
							"enabled": true,
							"format": "1013"
						}
					},
					{
						"y": 65.24444444444445,
						"dataLabels": {
							"enabled": true,
							"format": "734"
						}
					},
					{
						"y": 62.93333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "708"
						}
					},
					{
						"y": 59.28888888888889,
						"dataLabels": {
							"enabled": true,
							"format": "667"
						}
					},
					{
						"y": 53.6,
						"dataLabels": {
							"enabled": true,
							"format": "603"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.0770505385252704,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.8576214405360085,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.1056338028169,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.853432282003705,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.54006243496358,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4498432601880884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.707753479125246,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.527874564459932,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.3724604966139955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.494274809160308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.95555555555555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.54195459032577,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.542234332425065,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.7909604519774005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.595202398800595,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=1207"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=2552"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=1125"
			}
		],
		"dataTable": {
			"IDU": [
				1207,
				1194,
				1136,
				1078,
				961,
				754
			],
			"Non-IDU": [
				2552,
				2515,
				2296,
				2215,
				2096,
				1897
			],
			"Unknown": [
				1125,
				1013,
				734,
				708,
				667,
				603
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_6.png"
};

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 5.7,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by HSDA, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -80,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.51552795031056,
						"dataLabels": {
							"enabled": true,
							"format": "314"
						}
					},
					{
						"y": 91.30434782608695,
						"dataLabels": {
							"enabled": true,
							"format": "294"
						}
					},
					{
						"y": 88.50931677018633,
						"dataLabels": {
							"enabled": true,
							"format": "285"
						}
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": true,
							"format": "276"
						}
					},
					{
						"y": 75.77639751552795,
						"dataLabels": {
							"enabled": true,
							"format": "244"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.25153374233128,
						"dataLabels": {
							"enabled": true,
							"format": "152"
						}
					},
					{
						"y": 84.04907975460122,
						"dataLabels": {
							"enabled": true,
							"format": "137"
						}
					},
					{
						"y": 82.20858895705521,
						"dataLabels": {
							"enabled": true,
							"format": "134"
						}
					},
					{
						"y": 76.07361963190185,
						"dataLabels": {
							"enabled": true,
							"format": "124"
						}
					},
					{
						"y": 70.5521472392638,
						"dataLabels": {
							"enabled": true,
							"format": "115"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.81456200227532,
						"dataLabels": {
							"enabled": true,
							"format": "4255"
						}
					},
					{
						"y": 84.98293515358361,
						"dataLabels": {
							"enabled": true,
							"format": "3735"
						}
					},
					{
						"y": 81.50170648464163,
						"dataLabels": {
							"enabled": true,
							"format": "3582"
						}
					},
					{
						"y": 75.63139931740615,
						"dataLabels": {
							"enabled": true,
							"format": "3324"
						}
					},
					{
						"y": 65.8703071672355,
						"dataLabels": {
							"enabled": true,
							"format": "2895"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.4844720496894457,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.369426751592355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0612244897959218,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.157894736842104,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.594202898550721,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.748466257668717,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.868421052631582,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.1897810218978075,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.462686567164178,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.258064516129037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1854379977246827,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.220916568742657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.0963855421686795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.202680067001676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.906137184115519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "North Shore/Coast Garibaldi<br>n=322"
			},
			{
				"x": 9,
				"text": "Richmond<br>n=163"
			},
			{
				"x": 15,
				"text": "Vancouver<br>n=4395"
			}
		],
		"dataTable": {
			"North Shore / Coast Garibaldi": [
				322,
				314,
				294,
				285,
				276,
				244
			],
			"Richmond": [
				163,
				152,
				137,
				134,
				124,
				115
			],
			"Vancouver": [
				4395,
				4255,
				3735,
				3582,
				3324,
				2895
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_7.png"
};

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 6.1,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					9.821428571428571,
					6.422018348623854,
					6.504065040650407,
					5.426356589147287,
					6.569343065693431,
					9.090909090909092,
					7.017543859649122,
					{
						"y": 7.758620689655173,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					10.714285714285714,
					7.339449541284404,
					6.504065040650407,
					4.651162790697675,
					5.109489051094891,
					8.333333333333332,
					7.894736842105263,
					{
						"y": 7.758620689655173,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 5,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					8.928571428571429,
					8.256880733944955,
					8.130081300813007,
					6.976744186046512,
					5.839416058394161,
					3.787878787878788,
					4.385964912280701,
					{
						"y": 6.896551724137931,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					20.535714285714285,
					21.100917431192663,
					24.390243902439025,
					26.356589147286826,
					24.817518248175183,
					25,
					20.175438596491226,
					{
						"y": 18.103448275862068,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					25.892857142857146,
					29.357798165137616,
					25.203252032520325,
					23.25581395348837,
					21.16788321167883,
					20.454545454545457,
					28.07017543859649,
					{
						"y": 29.310344827586203,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					19.642857142857142,
					18.34862385321101,
					19.51219512195122,
					19.379844961240313,
					21.897810218978105,
					23.484848484848484,
					27.192982456140353,
					{
						"y": 25.862068965517242,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					112,
					109,
					123,
					129,
					137,
					132,
					114,
					{
						"y": 116,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_6_1.png"
};

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 6.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 46,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					44,
					51,
					54,
					61,
					56,
					44,
					40
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 38,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					41,
					47,
					50,
					47,
					48,
					43,
					51
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 17,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					16,
					15,
					18,
					21,
					17,
					18,
					17
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					6,
					6,
					3,
					4,
					7,
					7,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					2,
					4,
					4,
					4,
					4,
					2,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 112,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					109,
					123,
					129,
					137,
					132,
					114,
					116
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_6_2.png"
};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 7,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					31,
					31,
					20,
					35,
					17,
					22,
					21,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					62,
					59,
					60,
					65,
					65,
					73,
					77,
					{
						"y": 74,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_7.png"
};

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "vcha",
	"id": 8,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in Vancouver Coastal Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 12,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					14,
					9,
					12,
					4,
					5,
					13,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					7,
					4,
					9,
					4,
					7,
					4,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					4,
					5,
					6,
					5,
					5,
					2,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					3,
					2,
					5,
					1,
					4,
					2,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					3,
					0,
					3,
					3,
					1,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 380,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					480,
					435,
					400,
					{
						"y": 240,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					420,
					530,
					465
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 31,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					31,
					20,
					35,
					17,
					22,
					21,
					16
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_8.png"
};

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 10,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 580,
			"marginLeft": 80,
			"marginRight": 200,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 10</span>                 <span style=\"display: table-cell;\">Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">16</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% Achieving Prescription Refill Adherence",
					"reserveSpace": false,
					"x": -60
				}
			}
		],
		"series": [
			{
				"name": "≥ 95%",
				"color": "#6bcff6",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 95%</span>",
							"useHTML": true
						}
					},
					10,
					14,
					4,
					12,
					7,
					5,
					10
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "80% to<br>< 95%",
				"color": "url(#polka-dot-2a)",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">80% to<br>< 95%</span>",
							"useHTML": true
						}
					},
					5,
					3,
					1,
					3,
					4,
					1,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "40% to<br>< 80%",
				"color": "url(#polka-dot-2b)",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": -2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">40% to<br>< 80%</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					1,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 40%",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 40%</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 19,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					15,
					17,
					5,
					16,
					11,
					6,
					11
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_10.png"
};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 11,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 550,
			"marginLeft": 160,
			"marginRight": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 160px;\">Figure 11</span>                 <span style=\"display: table-cell;\">Cumulative Resistance Testing Results by Resistance Category for Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">17</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 65,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% DTP Patients",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Suppressed",
				"color": "#560054",
				"data": [
					{
						"y": 539,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#560054",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Suppressed</span>",
							"useHTML": true,
							"x": -45
						}
					},
					512,
					517,
					562,
					545,
					544,
					529,
					549
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Wild Type",
				"color": "#0076a3",
				"data": [
					{
						"y": 58,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#0076a3",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">Wild Type</span>",
							"useHTML": true,
							"x": -45
						}
					},
					68,
					65,
					63,
					57,
					61,
					70,
					73
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Never Genotyped",
				"color": "#086c28",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -4,
							"style": {
								"color": "#086c28",
								"fontSize": "0.52em"
							},
							"format": "<span style=\"padding-left: 4px;\">Never Genotyped</span>",
							"useHTML": true,
							"x": -45
						}
					},
					5,
					3,
					3,
					7,
					5,
					1,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1-Class",
				"color": "#ab9f01",
				"data": [
					{
						"y": 13,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">1-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					15,
					12,
					13,
					8,
					6,
					11,
					9
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2-Class",
				"color": "#a36109",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": -2,
							"style": {
								"color": "#a36109",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">2-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					2,
					1,
					1,
					4,
					5,
					2,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3-Class",
				"color": "#9d070d",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">3-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					2,
					0,
					2,
					1,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "4-Class",
				"color": "",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 14,
							"style": {
								"color": "",
								"fontSize": "0.60em"
							},
							"format": "<span style=\"padding-left: 4px;\">4-Class</span>",
							"useHTML": true,
							"x": -45
						}
					},
					0,
					0,
					0,
					0,
					0,
					0,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 613,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "white",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#231f20",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -45
						}
					},
					602,
					600,
					642,
					623,
					622,
					613,
					636
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_11.png"
};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 12,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 370,
			"marginLeft": 180,
			"marginRight": 160,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 180px;\">Figure 12</span>                 <span style=\"display: table-cell;\">AIDS Case Rate and Reports for Island Health <sup style=\"font-size: 10px;\">18</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Rate per 100,000 population",
					"reserveSpace": false,
					"x": -170
				}
			}
		],
		"series": [
			{
				"name": "AIDS: BCCDC Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 4,
				"data": [
					18,
					16,
					9,
					8,
					7,
					7,
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: BCCDC Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: BCCDC Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 5,
				"data": [
					2.4,
					2.1,
					1.2,
					1.1,
					0.9,
					0.9,
					{
						"y": 1.4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -4,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: BCCDC Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: BCCDC Reports (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": false,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					17,
					6,
					7,
					10,
					13,
					13,
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "CD4<200 at ART Initiation (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "CD4<200 at ART Initiation",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					2.3,
					0.8,
					0.9,
					1.3,
					1.7,
					1.6,
					{
						"y": 0.9,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">CD4<200 at ART Initiation</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "CD4<200 at ART Initiation (PER 100K)",
					"suppressible": false
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": false,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					15,
					13,
					8,
					7,
					8,
					4,
					{
						"y": 10,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "AIDS: DTP Reports (CASES)",
					"suppressible": true
				}
			},
			{
				"name": "AIDS: DTP Reports",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 3,
				"data": [
					2,
					1.7,
					1.1,
					0.9,
					1,
					0.5,
					{
						"y": 1.2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 14,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">AIDS: DTP Reports</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1,
					"title": "AIDS: DTP Reports (PER 100K)",
					"suppressible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_12.png"
};

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 13,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 40,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 13</span>                 <span style=\"display: table-cell;\">HIV-Related Deaths by Year for all BC, 2004-2015 <sup style=\"font-size: 10px;\">19</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"2004",
					"2005",
					"2006",
					"2007",
					"2008",
					"2009",
					"2010",
					"2011",
					"2012",
					"2013",
					"2014",
					"2015"
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"height": "45%",
				"lineColor": "#9d0140",
				"lineWidth": 1,
				"tickColor": "#9d0140",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#9d0140",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#9d0140"
					}
				},
				"title": {
					"text": "Rate per 100<br>HIV+ Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#9d0140"
					}
				}
			},
			{
				"height": "45%",
				"top": "55%",
				"lineColor": "#0076a3",
				"lineWidth": 1,
				"tickColor": "#0076a3",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"minorTickWidth": 1,
				"minorTickInterval": 0.1,
				"minorTickLength": 5,
				"minorTickColor": "#0076a3",
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"labels": {
					"format": "{value:.1f}",
					"style": {
						"color": "#0076a3"
					}
				},
				"title": {
					"text": "Rate per 100,000<br>Population",
					"reserveSpace": false,
					"x": -40,
					"style": {
						"color": "#0076a3"
					}
				}
			}
		],
		"series": [
			{
				"name": "HIV-Related Deaths",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					105,
					146,
					142,
					100,
					79,
					63,
					54,
					59,
					37,
					25,
					22,
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HIV-Related Deaths</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"title": "HIV-Related Deaths",
					"suppressible": false
				}
			},
			{
				"name": "Per 100 HIV+ Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 1,
				"data": [
					1.03,
					1.4,
					1.34,
					0.93,
					0.72,
					0.56,
					0.47,
					0.5,
					0.32,
					0.21,
					0.19,
					0.14
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100 HIV+ Population",
					"suppressible": false
				},
				"yAxis": 0
			},
			{
				"name": "Per 100,000 Population",
				"visible": true,
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 2,
				"data": [
					2.5,
					3.43,
					3.29,
					2.28,
					1.8,
					1.41,
					1.19,
					1.29,
					0.81,
					0.54,
					0.47,
					0.34
				],
				"table": {
					"visible": true,
					"decimalPoint": 2,
					"title": "Per 100,000 Population",
					"suppressible": false
				},
				"yAxis": 1
			}
		],
		"breaks": [
			{
				"x": 0,
				"y": 0,
				"width": 0,
				"height": 0
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_13.png"
};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 300,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.1</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Island Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					4.764,
					4.84,
					4.902,
					5.899,
					6.037,
					6.39,
					6.618,
					7.066,
					7.268,
					6.545,
					6.407,
					6.796,
					6.306,
					6.608,
					6.737,
					7.299,
					7.172,
					7.121,
					7.549,
					{
						"y": 7.711,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_1.png"
};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 290,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.2</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Gender for Island Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2.272,
					2.39,
					2.436,
					2.908,
					3.034,
					3.249,
					3.3,
					3.514,
					3.662,
					3.397,
					3.215,
					3.452,
					3.188,
					3.325,
					3.379,
					3.66,
					3.552,
					3.722,
					3.816,
					{
						"y": 3.844,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.132,
					2.124,
					2.137,
					2.575,
					2.581,
					2.759,
					2.92,
					3.147,
					3.219,
					2.846,
					2.859,
					3.057,
					2.791,
					2.979,
					3.02,
					3.347,
					3.293,
					3.174,
					3.546,
					{
						"y": 3.649,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.007,
					0.01,
					0.004,
					0.009,
					0.008,
					0.011,
					0.013,
					0.016,
					0.011,
					0.009,
					0.009,
					0.008,
					0.009,
					0.015,
					0.015,
					0.008,
					0.007,
					0.012,
					0.022,
					{
						"y": 0.013,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_2.png"
};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 1.3</span>                 <span style=\"display: table-cell;\">HIV Test Episodes by Age Category for Island Health <sup style=\"font-size: 10px;\">1, 2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.642,
					1.689,
					1.776,
					1.994,
					1.948,
					2.025,
					2.2,
					2.253,
					2.204,
					2.174,
					2.146,
					2.242,
					2.05,
					2.327,
					2.357,
					2.517,
					2.381,
					2.512,
					2.679,
					{
						"y": 2.762,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1.063,
					1.114,
					1.067,
					1.328,
					1.308,
					1.378,
					1.336,
					1.531,
					1.488,
					1.426,
					1.374,
					1.537,
					1.405,
					1.437,
					1.461,
					1.667,
					1.556,
					1.646,
					1.723,
					{
						"y": 1.752,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0.671,
					0.691,
					0.658,
					0.812,
					0.814,
					0.902,
					0.912,
					0.963,
					0.955,
					0.882,
					0.905,
					0.968,
					0.879,
					0.88,
					0.902,
					1.07,
					1.03,
					0.953,
					1,
					{
						"y": 1.038,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1.033,
					1.029,
					1.076,
					1.358,
					1.55,
					1.713,
					1.784,
					1.928,
					2.243,
					1.766,
					1.658,
					1.769,
					1.652,
					1.674,
					1.693,
					1.76,
					1.885,
					1.797,
					1.982,
					{
						"y": 1.952,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_3.png"
};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 1.4</span>                 <span style=\"display: table-cell;\">Point-of-Care HIV Tests for Island Health</span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 100,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Point-of-Care HIV Tests",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					353,
					316,
					325,
					407,
					414,
					371,
					385,
					389,
					376,
					293,
					324,
					279,
					318,
					289,
					323,
					284,
					320,
					213,
					165,
					{
						"y": 205,
						"dataLabels": {
							"enabled": false,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_4.png"
};

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 900,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.5</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Island Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1.555,
					1.507,
					1.553,
					1.97,
					2.022,
					2.145,
					2.125,
					2.31,
					2.359,
					2.187,
					2.201,
					2.346,
					2.265,
					2.266,
					2.306,
					2.428,
					2.55,
					2.556,
					2.663,
					{
						"y": 2.803,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.31,
					0.283,
					0.304,
					0.363,
					0.363,
					0.403,
					0.41,
					0.405,
					0.4,
					0.369,
					0.375,
					0.448,
					0.435,
					0.445,
					0.49,
					0.522,
					0.583,
					0.593,
					0.605,
					{
						"y": 0.567,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2.899,
					3.05,
					3.045,
					3.566,
					3.652,
					3.842,
					4.083,
					4.351,
					4.511,
					3.99,
					3.831,
					4.002,
					3.606,
					3.897,
					3.941,
					4.349,
					4.038,
					3.972,
					4.281,
					{
						"y": 4.34,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_5.png"
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.6,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in Island Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.703,
					0.726,
					0.751,
					0.949,
					0.964,
					1.095,
					1.027,
					1.103,
					1.169,
					1.078,
					1.048,
					1.141,
					1.124,
					1.075,
					1.094,
					1.153,
					1.176,
					1.26,
					1.24,
					{
						"y": 1.308,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.164,
					0.136,
					0.126,
					0.157,
					0.153,
					0.202,
					0.196,
					0.185,
					0.191,
					0.197,
					0.192,
					0.191,
					0.232,
					0.229,
					0.232,
					0.26,
					0.317,
					0.322,
					0.344,
					{
						"y": 0.299,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.405,
					1.528,
					1.559,
					1.802,
					1.917,
					1.952,
					2.077,
					2.226,
					2.302,
					2.122,
					1.975,
					2.12,
					1.832,
					2.021,
					2.053,
					2.247,
					2.059,
					2.14,
					2.232,
					{
						"y": 2.237,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_6.png"
};

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 1.7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in Island Health by HSDA <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 0.2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value:.1f}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0.693,
					0.7,
					0.717,
					0.914,
					0.967,
					0.975,
					1.007,
					1.071,
					1.063,
					1.008,
					1.042,
					1.098,
					1.021,
					1.056,
					1.064,
					1.161,
					1.208,
					1.209,
					1.367,
					{
						"y": 1.377,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0.132,
					0.137,
					0.124,
					0.143,
					0.144,
					0.167,
					0.183,
					0.165,
					0.186,
					0.157,
					0.166,
					0.214,
					0.184,
					0.191,
					0.233,
					0.244,
					0.254,
					0.249,
					0.242,
					{
						"y": 0.252,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.307,
					1.287,
					1.296,
					1.518,
					1.47,
					1.617,
					1.73,
					1.911,
					1.97,
					1.681,
					1.651,
					1.745,
					1.586,
					1.732,
					1.723,
					1.942,
					1.831,
					1.716,
					1.937,
					{
						"y": 2.02,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_1_7.png"
};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 2.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 430,
			"marginLeft": 150,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 150px;\">Figure 2.1</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing for Island Health and HSDA <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 300,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -140
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1717.5055534485562,
					1747.7735002343686,
					1742.1310506548718,
					1779.0265746866662,
					1955.5639954424612,
					2171.363267270157,
					2851.1477267221494,
					3125.228988055983,
					3056.9591263357966,
					{
						"y": 3186.523311839641,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1342.4961354929767,
					1368.3354434094358,
					1119.430955930735,
					1074.9629827922267,
					1261.3951313988046,
					1236.3672499316808,
					1409.884924248696,
					1481.499620442246,
					1627.5784119807856,
					{
						"y": 1946.7820790254068,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2268.293689554128,
					2222.2828533620723,
					2167.3847760804283,
					2434.079272479549,
					2608.1695216070134,
					2818.4862835445197,
					3501.0531858873087,
					3851.11037077784,
					3572.5399570458567,
					{
						"y": 3758.43676533785,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "All Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"index": -1,
				"data": [
					1927.4506495697653,
					1920.2260414069683,
					1850.9036506044338,
					1989.5021786173431,
					2166.8755083064225,
					2341.7245457731733,
					2945.755186284876,
					3227.0552880929745,
					3088.5801457424545,
					{
						"y": 3275.9594666879966,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">All Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_2_1.png"
};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 2.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 420,
			"marginLeft": 100,
			"marginRight": 170,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.2</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Gender for Island Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 200,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1911.8959767542267,
					1879.889238673812,
					1785.5549783004558,
					1977.8095582341941,
					2201.833427194794,
					2397.1523483310343,
					3072.795564299767,
					3340.8276540434204,
					3204.4870760792683,
					{
						"y": 3389.6138377272773,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					1927.0993879078778,
					1949.2437360368383,
					1911.9194022405136,
					1993.733901863596,
					2124.5833490390773,
					2276.979578981645,
					2803.9932933015125,
					3099.651168844692,
					2957.8854309472254,
					{
						"y": 3147.7526947325605,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_2_2.png"
};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 2.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Island Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017,
					2018
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 300,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					2490.0769949745795,
					2494.3672865453814,
					2380.7216733722325,
					2453.0987632222705,
					2660.349071476745,
					2790.6040383445697,
					3252.4809413253633,
					3444.0604550626676,
					3481.484584450402,
					{
						"y": 3783.5285070672116,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3965.058510513056,
					4043.936442368625,
					3837.7549598104356,
					4209.025254151525,
					4327.551890816037,
					4714.678909305669,
					5500.317557653139,
					5857.955274297687,
					5801.359121798223,
					{
						"y": 6137.534455880987,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2217.609992333726,
					2242.6407381229824,
					2193.6733755369214,
					2366.905605670103,
					2641.2204259899404,
					2830.889374615368,
					3565.0662145049473,
					3836.7181500127995,
					3684.4820144642235,
					{
						"y": 3941.902200642508,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					847.5021853003226,
					831.768350427762,
					843.7766343634584,
					984.7373465127893,
					1155.976291093362,
					1318.3477265136694,
					1961.3359238322973,
					2298.7123775499103,
					2014.4596006664972,
					{
						"y": 2079.220362174162,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_2_3.png"
};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 3.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 250,
			"marginLeft": 130,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 130px;\">Figure 3.1</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Island Health <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -120
				}
			}
		],
		"series": [
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					4,
					7,
					8,
					3,
					7,
					8,
					6,
					7,
					10,
					4,
					8,
					8,
					9,
					9,
					10,
					10,
					12,
					5,
					6,
					11
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "ShortDash",
				"data": [
					4,
					8,
					8,
					3,
					7,
					6,
					5,
					7,
					9,
					3,
					7,
					6,
					8,
					10,
					10,
					10,
					12,
					5,
					7,
					10
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_3_1.png"
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 3.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 350,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.2</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Island Health by Gender <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Female",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1,
					2,
					3,
					0,
					2,
					3,
					1,
					0,
					2,
					1,
					1,
					1,
					0,
					0,
					0,
					1,
					3,
					0,
					2,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Female</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Male",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					3,
					5,
					5,
					3,
					5,
					5,
					5,
					7,
					8,
					3,
					7,
					7,
					9,
					9,
					10,
					9,
					9,
					5,
					4,
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Male</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_3_2.png"
};

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 3.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.3</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Island Health by Age Category <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					2,
					0,
					1,
					3,
					2,
					3,
					3,
					1,
					2,
					4,
					2,
					4,
					2,
					2,
					3,
					2,
					2,
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0,
					4,
					1,
					1,
					2,
					4,
					0,
					2,
					0,
					0,
					3,
					3,
					3,
					2,
					3,
					4,
					2,
					1,
					1,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					2,
					1,
					3,
					1,
					3,
					1,
					1,
					0,
					2,
					1,
					1,
					0,
					2,
					1,
					2,
					4,
					5,
					1,
					2,
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 15,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					2,
					2,
					2,
					1,
					1,
					0,
					3,
					2,
					5,
					2,
					2,
					1,
					2,
					2,
					3,
					0,
					2,
					1,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 20,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_3_3.png"
};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 3.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 650,
			"height": 440,
			"marginLeft": 100,
			"marginRight": 90,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 3.4</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Island Health by Exposure Category <sup style=\"font-size: 10px;\">3, 4</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					1,
					5,
					9,
					13,
					17
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 3,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "MSM",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					5,
					3,
					2,
					2,
					3,
					2,
					4,
					2,
					3,
					5,
					5,
					0,
					5,
					5,
					8,
					7,
					9,
					6,
					7,
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">MSM</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "PWID",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					0,
					3,
					1,
					1,
					0,
					0,
					0,
					1,
					0,
					1,
					0,
					0,
					1,
					1,
					0,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">PWID</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "HET",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0,
					3,
					1,
					5,
					1,
					0,
					1,
					4,
					2,
					2,
					4,
					3,
					0,
					2,
					0,
					1,
					0,
					3,
					2,
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">HET</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "Other",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					0,
					0,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Other</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "NIR/Unknown",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					1,
					0,
					1,
					0,
					1,
					0,
					1,
					1,
					1,
					0,
					0,
					1,
					2,
					0,
					1,
					0,
					0,
					1,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">NIR/Unknown</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_3_4.png"
};

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 3.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 870,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 170,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 3.5</span>                 <span style=\"display: table-cell;\">New HIV Diagnoses for Island Health by HSDA <sup style=\"font-size: 10px;\">3</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7,
					11,
					15,
					19
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Diagnoses",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Central Vancouver Island",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"index": 0,
				"data": [
					2,
					1,
					7,
					0,
					3,
					4,
					2,
					3,
					1,
					0,
					5,
					1,
					2,
					2,
					2,
					1,
					3,
					1,
					3,
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Central Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "North Vancouver Island",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"index": 10,
				"data": [
					1,
					1,
					0,
					0,
					1,
					2,
					0,
					1,
					0,
					1,
					0,
					0,
					1,
					0,
					0,
					1,
					1,
					0,
					1,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">North Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "South Vancouver Island",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"index": 20,
				"data": [
					1,
					5,
					1,
					3,
					3,
					2,
					4,
					3,
					9,
					3,
					3,
					7,
					6,
					7,
					8,
					8,
					8,
					4,
					2,
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">South Vancouver Island</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "ShortDash",
				"index": 1,
				"data": [
					1,
					2,
					7,
					0,
					2,
					2,
					2,
					3,
					1,
					0,
					4,
					0,
					1,
					4,
					1,
					2,
					2,
					1,
					3,
					3
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "ShortDash",
				"index": 11,
				"data": [
					1,
					1,
					0,
					0,
					1,
					1,
					0,
					1,
					0,
					0,
					0,
					0,
					1,
					0,
					0,
					1,
					1,
					0,
					1,
					0
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			},
			{
				"name": "By Provider Address",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "ShortDash",
				"index": 21,
				"data": [
					2,
					5,
					1,
					3,
					4,
					3,
					3,
					3,
					8,
					3,
					3,
					6,
					6,
					6,
					9,
					7,
					9,
					4,
					3,
					7
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"fontStyle": "italic",
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_3_5.png"
};

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 4.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 300,
			"height": 390,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.1</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis for Island Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					3,
					2,
					3,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					2,
					3,
					2,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					3,
					1,
					3,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					3,
					5,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					4,
					null,
					2,
					4
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [],
		"dataTable": {
			"groups": [
				"Vancouver Island Health"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						5,
						3,
						2,
						3,
						6
					]
				},
				{
					"name": "Stage 1",
					"data": [
						3,
						2,
						3,
						2,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						4,
						3,
						1,
						3,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						6,
						3,
						5,
						0,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						7,
						4,
						0,
						2,
						4
					]
				},
				{
					"name": "Unknown",
					"data": [
						5,
						11,
						11,
						16,
						23
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						30,
						26,
						22,
						26,
						35
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_4_1.png"
};

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 4.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 370,
			"height": 380,
			"marginTop": 60,
			"marginRight": 1,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.2</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Gender for Island Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					5,
					3,
					2,
					3,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					1,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					1,
					2,
					2,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					3,
					3,
					1,
					3,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					3,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					6,
					null,
					5,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					1,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					6,
					3,
					null,
					null,
					4
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Female"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "Male"
			}
		],
		"dataTable": {
			"groups": [
				"Female",
				"Male"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						0,
						0,
						0,
						0,
						0,
						5,
						3,
						2,
						3,
						6
					]
				},
				{
					"name": "Stage 1",
					"data": [
						1,
						1,
						1,
						0,
						0,
						2,
						1,
						2,
						2,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						1,
						0,
						0,
						0,
						0,
						3,
						3,
						1,
						3,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						3,
						0,
						0,
						0,
						6,
						0,
						5,
						0,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						1,
						0,
						2,
						0,
						6,
						3,
						0,
						0,
						4
					]
				},
				{
					"name": "Unknown",
					"data": [
						1,
						3,
						4,
						1,
						1,
						4,
						8,
						7,
						15,
						21
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						4,
						8,
						5,
						3,
						1,
						26,
						18,
						17,
						23,
						33
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_4_2.png"
};

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 4.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Island Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					1,
					1,
					2,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					null,
					4,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					1,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					null,
					2,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					1,
					null,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					2,
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					2,
					1,
					2,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					2,
					1,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					4,
					null,
					3,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					1,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					null,
					null,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					null,
					null,
					1,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					4,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					4,
					null,
					null,
					null,
					2
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						2,
						1,
						1,
						2,
						1,
						1,
						1,
						0,
						0,
						4,
						1,
						0,
						0,
						1,
						1,
						1,
						1,
						1,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						2,
						0,
						2,
						0,
						0,
						0,
						0,
						0,
						2,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						2,
						1,
						0,
						1
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						0,
						0,
						0,
						0,
						0,
						2,
						0,
						0,
						1,
						0,
						2,
						1,
						0,
						0,
						0,
						0,
						2,
						1,
						2,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						0,
						0,
						0,
						0,
						1,
						1,
						2,
						1,
						0,
						0,
						4,
						0,
						3,
						0,
						0,
						1,
						1,
						1,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						0,
						0,
						1,
						1,
						1,
						0,
						0,
						1,
						1,
						1,
						4,
						0,
						0,
						0,
						4,
						0,
						0,
						0,
						2
					]
				},
				{
					"name": "Unknown",
					"data": [
						0,
						2,
						2,
						5,
						8,
						1,
						3,
						5,
						1,
						5,
						1,
						2,
						2,
						2,
						5,
						3,
						4,
						2,
						8,
						5
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						5,
						3,
						5,
						8,
						11,
						6,
						6,
						6,
						5,
						10,
						10,
						7,
						5,
						3,
						6,
						9,
						10,
						6,
						10,
						8
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_4_3.png"
};

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 4.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 532,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.4</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Exposure Category for Island Health <sup style=\"font-size: 10px;\">5, 6</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017,
					"",
					2013,
					2014,
					2015,
					2016,
					2017
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					1,
					2,
					2,
					6,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					1,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					1,
					1,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					null,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					2,
					null,
					2,
					null,
					{
						"y": 1,
						"color": "white"
					},
					null,
					null,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					1,
					1,
					1,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					null,
					3,
					null,
					1,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					1,
					2,
					2,
					null,
					null
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					1,
					null,
					null,
					2,
					{
						"y": 1,
						"color": "white"
					},
					null,
					1,
					null,
					null,
					null,
					{
						"y": 1,
						"color": "white"
					},
					4,
					1,
					null,
					1,
					1
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "MSM"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "PWID"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "HET"
			}
		],
		"dataTable": {
			"groups": [
				"MSM",
				"PWID",
				"HET",
				"Other",
				"Unknown"
			],
			"header": [
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017,
				2013,
				2014,
				2015,
				2016,
				2017
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						3,
						1,
						2,
						2,
						6,
						0,
						0,
						0,
						1,
						0,
						0,
						1,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						1,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 1",
					"data": [
						2,
						1,
						1,
						2,
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						1,
						0,
						0
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						3,
						2,
						0,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						1,
						1,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						5,
						0,
						3,
						0,
						1,
						0,
						1,
						0,
						0,
						0,
						1,
						2,
						2,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0
					]
				},
				{
					"name": "Stage 3",
					"data": [
						1,
						1,
						0,
						0,
						2,
						0,
						1,
						0,
						0,
						0,
						4,
						1,
						0,
						1,
						1,
						0,
						0,
						0,
						0,
						0,
						2,
						1,
						0,
						1,
						1
					]
				},
				{
					"name": "Unknown",
					"data": [
						1,
						6,
						3,
						7,
						19,
						1,
						1,
						2,
						1,
						1,
						3,
						4,
						4,
						6,
						2,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						2,
						2,
						0
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						15,
						11,
						9,
						13,
						28,
						1,
						3,
						2,
						2,
						2,
						10,
						10,
						7,
						8,
						3,
						1,
						0,
						1,
						0,
						1,
						3,
						2,
						3,
						3,
						1
					]
				}
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_4_4.png"
};

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Island Health, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.08050089445437,
						"dataLabels": {
							"enabled": true,
							"format": "1063"
						}
					},
					{
						"y": 86.8515205724508,
						"dataLabels": {
							"enabled": true,
							"format": "971"
						}
					},
					{
						"y": 83.54203935599284,
						"dataLabels": {
							"enabled": true,
							"format": "934"
						}
					},
					{
						"y": 76.47584973166369,
						"dataLabels": {
							"enabled": true,
							"format": "855"
						}
					},
					{
						"y": 59.83899821109123,
						"dataLabels": {
							"enabled": true,
							"format": "669"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.919499105545622,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.65475070555033,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.810504634397527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.458244111349034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.75438596491228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=1118"
			}
		],
		"dataTable": {
			"Overall HA": [
				1118,
				1063,
				971,
				934,
				855,
				669
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_1.png"
};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Island Health by Gender, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.43973941368078,
						"dataLabels": {
							"enabled": true,
							"format": "879",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.07926167209556,
						"dataLabels": {
							"enabled": true,
							"format": "802",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.82193268186754,
						"dataLabels": {
							"enabled": true,
							"format": "772",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.74158523344191,
						"dataLabels": {
							"enabled": true,
							"format": "716",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.80347448425625,
						"dataLabels": {
							"enabled": true,
							"format": "560",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.4010152284264,
						"dataLabels": {
							"enabled": true,
							"format": "184",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.78680203045685,
						"dataLabels": {
							"enabled": true,
							"format": "169",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.23350253807106,
						"dataLabels": {
							"enabled": true,
							"format": "162",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.55837563451777,
						"dataLabels": {
							"enabled": true,
							"format": "139",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 55.32994923857868,
						"dataLabels": {
							"enabled": true,
							"format": "109",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.56026058631922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.759954493742894,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.7406483790523692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.253886010362698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.78770949720671,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.598984771573601,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.15217391304348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.142011834319526,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.197530864197528,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.58273381294964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=921"
			},
			{
				"x": 9,
				"text": "Women<br>n=197"
			}
		],
		"dataTable": {
			"Men": [
				921,
				879,
				802,
				772,
				716,
				560
			],
			"Women": [
				197,
				184,
				169,
				162,
				139,
				109
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_2.png"
};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 81.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "49",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "41",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "38",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "30",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": true,
							"format": "24",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.51851851851852,
						"dataLabels": {
							"enabled": true,
							"format": "101",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "90",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.70370370370371,
						"dataLabels": {
							"enabled": true,
							"format": "85",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.888888888888886,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "54",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": true,
							"format": "216",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "195",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.55555555555556,
						"dataLabels": {
							"enabled": true,
							"format": "188",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.1111111111111,
						"dataLabels": {
							"enabled": true,
							"format": "169",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.22222222222223,
						"dataLabels": {
							"enabled": true,
							"format": "122",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": true,
							"format": "696",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.96551724137932,
						"dataLabels": {
							"enabled": true,
							"format": "645",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.93103448275862,
						"dataLabels": {
							"enabled": true,
							"format": "623",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.96551724137932,
						"dataLabels": {
							"enabled": true,
							"format": "587",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.6896551724138,
						"dataLabels": {
							"enabled": true,
							"format": "469",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -18.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.326530612244895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.481481481481477,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.89108910891089,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.823529411764707,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.722222222222221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.589743589743588,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.106382978723405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.810650887573964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.3275862068965525,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.4108527131782918,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.7784911717496,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.102214650766616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=60"
			},
			{
				"x": 9,
				"text": "30–39<br>n=108"
			},
			{
				"x": 15,
				"text": "40–49<br>n=225"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=725"
			}
		],
		"dataTable": {
			"< 30": [
				60,
				49,
				41,
				38,
				30,
				24
			],
			"30–39": [
				108,
				101,
				90,
				85,
				69,
				54
			],
			"40–49": [
				225,
				216,
				195,
				188,
				169,
				122
			],
			"≥ 50": [
				725,
				696,
				645,
				623,
				587,
				469
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_3.png"
};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.4,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.4</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.31680440771349,
						"dataLabels": {
							"enabled": true,
							"format": "346"
						}
					},
					{
						"y": 89.25619834710744,
						"dataLabels": {
							"enabled": true,
							"format": "324"
						}
					},
					{
						"y": 86.77685950413223,
						"dataLabels": {
							"enabled": true,
							"format": "315"
						}
					},
					{
						"y": 81.5426997245179,
						"dataLabels": {
							"enabled": true,
							"format": "296"
						}
					},
					{
						"y": 65.56473829201101,
						"dataLabels": {
							"enabled": true,
							"format": "238"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.90140845070422,
						"dataLabels": {
							"enabled": true,
							"format": "344"
						}
					},
					{
						"y": 91.83098591549296,
						"dataLabels": {
							"enabled": true,
							"format": "326"
						}
					},
					{
						"y": 85.91549295774648,
						"dataLabels": {
							"enabled": true,
							"format": "305"
						}
					},
					{
						"y": 75.21126760563381,
						"dataLabels": {
							"enabled": true,
							"format": "267"
						}
					},
					{
						"y": 56.056338028169016,
						"dataLabels": {
							"enabled": true,
							"format": "199"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.25,
						"dataLabels": {
							"enabled": true,
							"format": "373"
						}
					},
					{
						"y": 80.5,
						"dataLabels": {
							"enabled": true,
							"format": "322"
						}
					},
					{
						"y": 78.5,
						"dataLabels": {
							"enabled": true,
							"format": "314"
						}
					},
					{
						"y": 73,
						"dataLabels": {
							"enabled": true,
							"format": "292"
						}
					},
					{
						"y": 57.99999999999999,
						"dataLabels": {
							"enabled": true,
							"format": "232"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.683195592286504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.358381502890175,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.0317460317460325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.594594594594593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0985915492957705,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.232558139534882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.441717791411039,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.459016393442624,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.468164794007485,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.672922252010721,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4844720496894457,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.006369426751591,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.547945205479458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "MSM<br>n=363"
			},
			{
				"x": 9,
				"text": "Non-MSM<br>n=355"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=400"
			}
		],
		"dataTable": {
			"MSM": [
				363,
				346,
				324,
				315,
				296,
				238
			],
			"Non-MSM": [
				355,
				344,
				326,
				305,
				267,
				199
			],
			"Unknown": [
				400,
				373,
				322,
				314,
				292,
				232
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_4.png"
};

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 88.46153846153845,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0c4250"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.84615384615385,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#09472e"
					},
					{
						"y": 42.30769230769231,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#043f61"
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0c4250"
					},
					{
						"y": 85,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.5,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#09472e"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 84,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0c4250"
					},
					{
						"y": 82,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0d4440"
					},
					{
						"y": 76,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#09472e"
					},
					{
						"y": 62,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.34146341463415,
						"dataLabels": {
							"enabled": false,
							"format": "237"
						},
						"color": "#043f61"
					},
					{
						"y": 93.08943089430895,
						"dataLabels": {
							"enabled": false,
							"format": "229"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.65040650406505,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.77235772357723,
						"dataLabels": {
							"enabled": false,
							"format": "211"
						},
						"color": "#09472e"
					},
					{
						"y": 69.10569105691057,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#043f61"
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0c4250"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0d4440"
					},
					{
						"y": 53.333333333333336,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.62921348314607,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#043f61"
					},
					{
						"y": 91.01123595505618,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.39325842696628,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.91011235955057,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#09472e"
					},
					{
						"y": 50.56179775280899,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.75784753363229,
						"dataLabels": {
							"enabled": false,
							"format": "218"
						},
						"color": "#043f61"
					},
					{
						"y": 93.27354260089686,
						"dataLabels": {
							"enabled": false,
							"format": "208"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.89237668161435,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.26905829596413,
						"dataLabels": {
							"enabled": false,
							"format": "179"
						},
						"color": "#09472e"
					},
					{
						"y": 60.0896860986547,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#043f61"
					},
					{
						"y": 47.61904761904761,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 47.61904761904761,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.095238095238095,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#09472e"
					},
					{
						"y": 23.809523809523807,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#043f61"
					},
					{
						"y": 81.57894736842105,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.31578947368422,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 42.10526315789473,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.51162790697676,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#043f61"
					},
					{
						"y": 83.72093023255815,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.55813953488372,
						"dataLabels": {
							"enabled": false,
							"format": "71"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.90697674418605,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#09472e"
					},
					{
						"y": 53.48837209302325,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.50980392156862,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#043f61"
					},
					{
						"y": 81.96078431372548,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#0c4250"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "204"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.25490196078432,
						"dataLabels": {
							"enabled": false,
							"format": "197"
						},
						"color": "#09472e"
					},
					{
						"y": 64.70588235294117,
						"dataLabels": {
							"enabled": false,
							"format": "165"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -11.538461538461542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.8947368421052655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.212121212121215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.000000000000005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.63829787234043,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3809523809523836,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.42105263157895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.658536585365857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3755274261603407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.6200873362445365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.381165919282516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.431279620853083,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3707865168539297,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.813953488372093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.172839506172845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.789473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.6875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2421524663677084,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.587155963302747,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.673469387755105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.139664804469277,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.888888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.034482758620683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.488372093023251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.253012048192769,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.388888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.633802816901412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.343283582089555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.490196078431375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.278008298755184,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.392344497607657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4313725490196068,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.24365482233503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=26"
			},
			{
				"x": 9,
				"text": "30-39<br>n=40"
			},
			{
				"x": 15,
				"text": "40-49<br>n=50"
			},
			{
				"x": 21,
				"text": ">=50<br>n=246"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=13"
			},
			{
				"x": 34,
				"text": "30-39<br>n=30"
			},
			{
				"x": 40,
				"text": "40-49<br>n=89"
			},
			{
				"x": 46,
				"text": ">=50<br>n=223"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=21"
			},
			{
				"x": 59,
				"text": "30-39<br>n=38"
			},
			{
				"x": 65,
				"text": "40-49<br>n=86"
			},
			{
				"x": 71,
				"text": ">=50<br>n=255"
			}
		],
		"dataTable": {
			"MSM:<30": [
				26,
				23,
				18,
				17,
				14,
				11
			],
			"MSM:30-39": [
				40,
				38,
				35,
				34,
				33,
				26
			],
			"MSM:40-49": [
				50,
				47,
				42,
				41,
				38,
				31
			],
			"MSM:>=50": [
				246,
				237,
				229,
				223,
				211,
				170
			],
			"Non-MSM:<30": [
				13,
				13,
				12,
				11,
				8,
				8
			],
			"Non-MSM:30-39": [
				30,
				27,
				24,
				22,
				16,
				12
			],
			"Non-MSM:40-49": [
				89,
				86,
				81,
				76,
				64,
				45
			],
			"Non-MSM:>=50": [
				223,
				218,
				208,
				196,
				179,
				134
			],
			"Unknown:<30": [
				21,
				14,
				10,
				10,
				8,
				5
			],
			"Unknown:30-39": [
				38,
				36,
				31,
				29,
				20,
				16
			],
			"Unknown:40-49": [
				86,
				83,
				72,
				71,
				67,
				46
			],
			"Unknown:>=50": [
				255,
				241,
				209,
				204,
				197,
				165
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.6,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.93877551020408,
						"dataLabels": {
							"enabled": true,
							"format": "285"
						}
					},
					{
						"y": 91.15646258503402,
						"dataLabels": {
							"enabled": true,
							"format": "268"
						}
					},
					{
						"y": 85.37414965986395,
						"dataLabels": {
							"enabled": true,
							"format": "251"
						}
					},
					{
						"y": 75.51020408163265,
						"dataLabels": {
							"enabled": true,
							"format": "222"
						}
					},
					{
						"y": 53.74149659863946,
						"dataLabels": {
							"enabled": true,
							"format": "158"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.24796084828712,
						"dataLabels": {
							"enabled": true,
							"format": "590"
						}
					},
					{
						"y": 90.0489396411093,
						"dataLabels": {
							"enabled": true,
							"format": "552"
						}
					},
					{
						"y": 87.43882544861337,
						"dataLabels": {
							"enabled": true,
							"format": "536"
						}
					},
					{
						"y": 81.72920065252855,
						"dataLabels": {
							"enabled": true,
							"format": "501"
						}
					},
					{
						"y": 67.69983686786297,
						"dataLabels": {
							"enabled": true,
							"format": "415"
						}
					},
					{
						"y": null
					},
					{
						"y": 89.57345971563981,
						"dataLabels": {
							"enabled": true,
							"format": "189"
						}
					},
					{
						"y": 72.03791469194313,
						"dataLabels": {
							"enabled": true,
							"format": "152"
						}
					},
					{
						"y": 69.66824644549763,
						"dataLabels": {
							"enabled": true,
							"format": "147"
						}
					},
					{
						"y": 62.55924170616114,
						"dataLabels": {
							"enabled": true,
							"format": "132"
						}
					},
					{
						"y": 45.497630331753555,
						"dataLabels": {
							"enabled": true,
							"format": "96"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.0612244897959218,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.964912280701751,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.343283582089554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.55378486055777,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.828828828828833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.7520391517128826,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.440677966101694,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.898550724637683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.529850746268662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.165668662674648,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -10.426540284360186,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.576719576719583,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.289473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.204081632653061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=294"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=613"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=211"
			}
		],
		"dataTable": {
			"IDU": [
				294,
				285,
				268,
				251,
				222,
				158
			],
			"Non-IDU": [
				613,
				590,
				552,
				536,
				501,
				415
			],
			"Unknown": [
				211,
				189,
				152,
				147,
				132,
				96
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_6.png"
};

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 5.7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by HSDA, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -140,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.09803921568627,
						"dataLabels": {
							"enabled": true,
							"format": "291"
						}
					},
					{
						"y": 89.86928104575163,
						"dataLabels": {
							"enabled": true,
							"format": "275"
						}
					},
					{
						"y": 86.27450980392157,
						"dataLabels": {
							"enabled": true,
							"format": "264"
						}
					},
					{
						"y": 78.43137254901961,
						"dataLabels": {
							"enabled": true,
							"format": "240"
						}
					},
					{
						"y": 68.30065359477125,
						"dataLabels": {
							"enabled": true,
							"format": "209"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.34513274336283,
						"dataLabels": {
							"enabled": true,
							"format": "110"
						}
					},
					{
						"y": 93.80530973451327,
						"dataLabels": {
							"enabled": true,
							"format": "106"
						}
					},
					{
						"y": 89.38053097345133,
						"dataLabels": {
							"enabled": true,
							"format": "101"
						}
					},
					{
						"y": 81.41592920353983,
						"dataLabels": {
							"enabled": true,
							"format": "92"
						}
					},
					{
						"y": 63.716814159292035,
						"dataLabels": {
							"enabled": true,
							"format": "72"
						}
					},
					{
						"y": null
					},
					{
						"y": 94.70672389127324,
						"dataLabels": {
							"enabled": true,
							"format": "662"
						}
					},
					{
						"y": 84.4062947067239,
						"dataLabels": {
							"enabled": true,
							"format": "590"
						}
					},
					{
						"y": 81.40200286123033,
						"dataLabels": {
							"enabled": true,
							"format": "569"
						}
					},
					{
						"y": 74.8211731044349,
						"dataLabels": {
							"enabled": true,
							"format": "523"
						}
					},
					{
						"y": 55.50786838340487,
						"dataLabels": {
							"enabled": true,
							"format": "388"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.90196078431373,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.498281786941583,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.916666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.6548672566371723,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6363636363636376,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.716981132075471,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.910891089108908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.293276108726753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.876132930513593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.5593220338983045,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.084358523725832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.812619502868074,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Central Vancouver Island<br>n=306"
			},
			{
				"x": 9,
				"text": "North Vancouver Island<br>n=113"
			},
			{
				"x": 15,
				"text": "South Vancouver Island<br>n=699"
			}
		],
		"dataTable": {
			"Central Vancouver Island": [
				306,
				291,
				275,
				264,
				240,
				209
			],
			"North Vancouver Island": [
				113,
				110,
				106,
				101,
				92,
				72
			],
			"South Vancouver Island": [
				699,
				662,
				590,
				569,
				523,
				388
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_7.png"
};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 6.1,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					71.42857142857143,
					65.51724137931035,
					60.60606060606061,
					62.857142857142854,
					62.857142857142854,
					64.1025641025641,
					68.57142857142857,
					{
						"y": 70.27027027027027,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					10.714285714285714,
					6.896551724137931,
					3.0303030303030303,
					8.571428571428571,
					5.714285714285714,
					7.6923076923076925,
					8.571428571428571,
					{
						"y": 5.405405405405405,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					0,
					0,
					3.0303030303030303,
					2.857142857142857,
					2.857142857142857,
					2.564102564102564,
					2.857142857142857,
					{
						"y": 2.7027027027027026,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					28.57142857142857,
					27.586206896551722,
					18.181818181818183,
					22.857142857142858,
					14.285714285714285,
					15.384615384615385,
					14.285714285714285,
					{
						"y": 8.108108108108109,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					7.142857142857142,
					6.896551724137931,
					6.0606060606060606,
					8.571428571428571,
					8.571428571428571,
					7.6923076923076925,
					5.714285714285714,
					{
						"y": 2.7027027027027026,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					21.428571428571427,
					27.586206896551722,
					21.21212121212121,
					25.71428571428571,
					28.57142857142857,
					33.33333333333333,
					31.428571428571427,
					{
						"y": 24.324324324324326,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					28,
					29,
					33,
					35,
					35,
					39,
					35,
					{
						"y": 37,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_6_1.png"
};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 6.2,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 510,
			"height": 380,
			"marginLeft": 100,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.2</span>                 <span style=\"display: table-cell;\">Historical Trends for PCS Score for Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">10, 11</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 25,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Distribution of PCS Score",
					"reserveSpace": false,
					"x": -80
				}
			}
		],
		"series": [
			{
				"name": "0",
				"data": [
					{
						"y": 6,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#6bcff6",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">0</span>",
							"useHTML": true,
							"x": -55
						}
					},
					7,
					9,
					8,
					8,
					8,
					6,
					7
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 11,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-1)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true,
							"x": -55
						}
					},
					11,
					13,
					14,
					16,
					16,
					17,
					20
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2",
				"data": [
					{
						"y": 8,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2a)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">2</span>",
							"useHTML": true,
							"x": -55
						}
					},
					7,
					9,
					8,
					7,
					11,
					8,
					8
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "url(#polka-dot-2b)",
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true,
							"x": -55
						}
					},
					3,
					2,
					4,
					3,
					3,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "≥ 4",
				"data": [
					{
						"y": 2,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"color": "#9d070d",
								"fontSize": "0.65em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 4</span>",
							"useHTML": true,
							"x": -55
						}
					},
					1,
					0,
					1,
					1,
					1,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 28,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#231f20",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "right",
							"y": 2,
							"style": {
								"fontSize": "0.75em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true,
							"x": -55
						}
					},
					29,
					33,
					35,
					35,
					39,
					35,
					37
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_6_2.png"
};

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 600,
			"height": 210,
			"marginLeft": 100,
			"marginRight": 300,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 7</span>                 <span style=\"display: table-cell;\">BC-CfE Drug Treatment Program Enrollment New ART Participants in Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">12</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 10,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "First Starts",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					14,
					11,
					5,
					8,
					7,
					9,
					8,
					{
						"y": 12,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">First Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Experienced Starts",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					15,
					11,
					11,
					12,
					16,
					12,
					29,
					{
						"y": 20,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Experienced Starts</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_7.png"
};

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = {
	"ha": "viha",
	"id": 8,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 480,
			"height": 350,
			"marginLeft": 110,
			"marginRight": 110,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"enabled": false
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 8</span>                 <span style=\"display: table-cell;\">CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in Island Health, 2017 Q2–2019 Q1 <sup style=\"font-size: 10px;\">13</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {
						"fontWeight": "normal"
					},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "% in CD4 Cell Count Category at ART Initiation",
					"reserveSpace": false,
					"x": -90
				}
			},
			{
				"opposite": true,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"gridLineWidth": 0,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"offset": 10,
				"title": {
					"text": "Median CD4 Cell Count at ART Initiation (cells/µL)",
					"reserveSpace": false,
					"x": 35
				}
			}
		],
		"series": [
			{
				"name": "≥ 500 cells/µL",
				"data": [
					{
						"y": 3,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#6bcff6",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">≥ 500 cells/µL</span>",
							"useHTML": true
						}
					},
					4,
					1,
					4,
					4,
					3,
					2,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "350–499",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-1)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">350–499</span>",
							"useHTML": true
						}
					},
					0,
					1,
					4,
					0,
					1,
					1,
					6
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "200–349",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2a)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">200–349</span>",
							"useHTML": true
						}
					},
					3,
					3,
					0,
					3,
					3,
					3,
					2
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "50–199",
				"data": [
					{
						"y": 1,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "url(#polka-dot-2b)",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">50–199</span>",
							"useHTML": true
						}
					},
					2,
					0,
					0,
					0,
					1,
					1,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "< 50 cells/µL",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "#9d070d",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">< 50 cells/µL</span>",
							"useHTML": true
						}
					},
					0,
					0,
					0,
					0,
					1,
					0,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Median",
				"color": "white",
				"data": [
					{
						"y": 355,
						"dataLabels": {
							"enabled": false,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Median</span>",
							"useHTML": true
						}
					},
					290,
					340,
					750,
					{
						"y": 520,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "center",
							"verticalAlign": "top",
							"y": -12,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style\"padding-left: 4px\">Median</span>",
							"useHTML": true
						}
					},
					340,
					230,
					420
				],
				"table": {
					"visible": false
				},
				"type": "line",
				"lineWidth": 3,
				"yAxis": 2
			},
			{
				"name": "n=",
				"visible": false,
				"color": "#231f20",
				"data": [
					{
						"y": 14,
						"dataLabels": {
							"enabled": true,
							"padding": 0,
							"allowOverlap": false,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">n=</span>",
							"useHTML": true
						}
					},
					9,
					5,
					8,
					7,
					9,
					7,
					11
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		],
		"groups": []
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_viha_8.png"
};

/***/ })
],[58]);


// WEBPACK FOOTER //
// static/js/app.f529fc2f5a73af117a1a.js